export const termsAndConditionsHtml = String.raw`<html>
    <head>
        <meta content="text/html; charset=UTF-8" http-equiv="content-type">
        <style type="text/css">
            @import url(https://themes.googleusercontent.com/fonts/css?kit=fpjTOVmNbO4Lz34iLyptLUXza5VhXqVC6o75Eld_V98);
            ol.lst-kix_list_7-0{
                list-style-type:none;
            }
            .lst-kix_list_2-1>li{
                counter-increment:lst-ctn-kix_list_2-1;
            }
            .lst-kix_list_21-8>li{
                counter-increment:lst-ctn-kix_list_21-8;
            }
            ol.lst-kix_list_9-0.start{
                counter-reset:lst-ctn-kix_list_9-0 1;
            }
            ol.lst-kix_list_13-4.start{
                counter-reset:lst-ctn-kix_list_13-4 0;
            }
            .lst-kix_list_13-0>li{
                counter-increment:lst-ctn-kix_list_13-0;
            }
            ol.lst-kix_list_20-2.start{
                counter-reset:lst-ctn-kix_list_20-2 0;
            }
            .lst-kix_list_5-0>li{
                counter-increment:lst-ctn-kix_list_5-0;
            }
            ol.lst-kix_list_2-3.start{
                counter-reset:lst-ctn-kix_list_2-3 0;
            }
            ol.lst-kix_list_7-5{
                list-style-type:none;
            }
            ol.lst-kix_list_7-6{
                list-style-type:none;
            }
            ol.lst-kix_list_7-7{
                list-style-type:none;
            }
            ol.lst-kix_list_7-8{
                list-style-type:none;
            }
            ol.lst-kix_list_7-1{
                list-style-type:none;
            }
            ol.lst-kix_list_7-2{
                list-style-type:none;
            }
            ol.lst-kix_list_7-3{
                list-style-type:none;
            }
            ol.lst-kix_list_7-4{
                list-style-type:none;
            }
            ol.lst-kix_list_5-3.start{
                counter-reset:lst-ctn-kix_list_5-3 0;
            }
            ol.lst-kix_list_17-1.start{
                counter-reset:lst-ctn-kix_list_17-1 0;
            }
            .lst-kix_list_18-8>li{
                counter-increment:lst-ctn-kix_list_18-8;
            }
            ol.lst-kix_list_8-8.start{
                counter-reset:lst-ctn-kix_list_8-8 0;
            }
            ol.lst-kix_list_10-4.start{
                counter-reset:lst-ctn-kix_list_10-4 0;
            }
            .lst-kix_list_7-2>li{
                counter-increment:lst-ctn-kix_list_7-2;
            }
            ol.lst-kix_list_16-5{
                list-style-type:none;
            }
            .lst-kix_list_1-4>li{
                counter-increment:lst-ctn-kix_list_1-4;
            }
            ol.lst-kix_list_16-6{
                list-style-type:none;
            }
            ol.lst-kix_list_16-7{
                list-style-type:none;
            }
            ol.lst-kix_list_1-6.start{
                counter-reset:lst-ctn-kix_list_1-6 0;
            }
            ol.lst-kix_list_16-8{
                list-style-type:none;
            }
            ol.lst-kix_list_9-5.start{
                counter-reset:lst-ctn-kix_list_9-5 0;
            }
            ol.lst-kix_list_16-1{
                list-style-type:none;
            }
            ol.lst-kix_list_16-2{
                list-style-type:none;
            }
            ol.lst-kix_list_16-3{
                list-style-type:none;
            }
            ol.lst-kix_list_16-4{
                list-style-type:none;
            }
            ol.lst-kix_list_16-0{
                list-style-type:none;
            }
            ol.lst-kix_list_20-7.start{
                counter-reset:lst-ctn-kix_list_20-7 0;
            }
            li.li-bullet-13:before{
                margin-left:-48pt;
                white-space:nowrap;
                display:inline-block;
                min-width:48pt;
            }
            .lst-kix_list_9-4>li{
                counter-increment:lst-ctn-kix_list_9-4;
            }
            ol.lst-kix_list_16-4.start{
                counter-reset:lst-ctn-kix_list_16-4 0;
            }
            ol.lst-kix_list_14-1.start{
                counter-reset:lst-ctn-kix_list_14-1 0;
            }
            .lst-kix_list_6-5>li{
                counter-increment:lst-ctn-kix_list_6-5;
            }
            li.li-bullet-43:before{
                margin-left:-35.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:35.5pt;
            }
            li.li-bullet-32:before{
                margin-left:-25.4pt;
                white-space:nowrap;
                display:inline-block;
                min-width:25.4pt;
            }
            .lst-kix_list_3-6>li{
                counter-increment:lst-ctn-kix_list_3-6;
            }
            li.li-bullet-21:before{
                margin-left:-35.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:35.5pt;
            }
            li.li-bullet-29:before{
                margin-left:-35.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:35.5pt;
            }
            .lst-kix_list_2-8>li{
                counter-increment:lst-ctn-kix_list_2-8;
            }
            li.li-bullet-54:before{
                margin-left:-42.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:42.5pt;
            }
            .lst-kix_list_22-2>li:before{
                content:"" counter(lst-ctn-kix_list_22-0,decimal) "." counter(lst-ctn-kix_list_22-1,decimal) "." counter(lst-ctn-kix_list_22-2,decimal) " ";
            }
            .lst-kix_list_22-6>li:before{
                content:"" counter(lst-ctn-kix_list_22-0,decimal) "." counter(lst-ctn-kix_list_22-1,decimal) "." counter(lst-ctn-kix_list_22-2,decimal) "." counter(lst-ctn-kix_list_22-3,decimal) "." counter(lst-ctn-kix_list_22-4,decimal) "." counter(lst-ctn-kix_list_22-5,decimal) "." counter(lst-ctn-kix_list_22-6,decimal) " ";
            }
            .lst-kix_list_8-6>li{
                counter-increment:lst-ctn-kix_list_8-6;
            }
            .lst-kix_list_22-0>li:before{
                content:"" counter(lst-ctn-kix_list_22-0,decimal) " ";
            }
            .lst-kix_list_22-8>li:before{
                content:"" counter(lst-ctn-kix_list_22-0,decimal) "." counter(lst-ctn-kix_list_22-1,decimal) "." counter(lst-ctn-kix_list_22-2,decimal) "." counter(lst-ctn-kix_list_22-3,decimal) "." counter(lst-ctn-kix_list_22-4,decimal) "." counter(lst-ctn-kix_list_22-5,decimal) "." counter(lst-ctn-kix_list_22-6,decimal) "." counter(lst-ctn-kix_list_22-7,decimal) "." counter(lst-ctn-kix_list_22-8,decimal) " ";
            }
            ol.lst-kix_list_9-7{
                list-style-type:none;
            }
            ol.lst-kix_list_22-5.start{
                counter-reset:lst-ctn-kix_list_22-5 0;
            }
            ol.lst-kix_list_9-8{
                list-style-type:none;
            }
            ol.lst-kix_list_3-0.start{
                counter-reset:lst-ctn-kix_list_3-0 8;
            }
            ol.lst-kix_list_9-3{
                list-style-type:none;
            }
            ol.lst-kix_list_9-4{
                list-style-type:none;
            }
            .lst-kix_list_5-7>li{
                counter-increment:lst-ctn-kix_list_5-7;
            }
            ol.lst-kix_list_9-5{
                list-style-type:none;
            }
            ol.lst-kix_list_9-6{
                list-style-type:none;
            }
            ol.lst-kix_list_9-0{
                list-style-type:none;
            }
            ol.lst-kix_list_9-1{
                list-style-type:none;
            }
            .lst-kix_list_22-4>li:before{
                content:"" counter(lst-ctn-kix_list_22-0,decimal) "." counter(lst-ctn-kix_list_22-1,decimal) "." counter(lst-ctn-kix_list_22-2,decimal) "." counter(lst-ctn-kix_list_22-3,decimal) "." counter(lst-ctn-kix_list_22-4,decimal) " ";
            }
            ol.lst-kix_list_9-2{
                list-style-type:none;
            }
            li.li-bullet-24:before{
                margin-left:-32.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:32.5pt;
            }
            .lst-kix_list_3-5>li{
                counter-increment:lst-ctn-kix_list_3-5;
            }
            ol.lst-kix_list_1-1.start{
                counter-reset:lst-ctn-kix_list_1-1 2;
            }
            ol.lst-kix_list_18-3.start{
                counter-reset:lst-ctn-kix_list_18-3 0;
            }
            ol.lst-kix_list_18-7{
                list-style-type:none;
            }
            ol.lst-kix_list_18-8{
                list-style-type:none;
            }
            ol.lst-kix_list_18-3{
                list-style-type:none;
            }
            ol.lst-kix_list_18-4{
                list-style-type:none;
            }
            .lst-kix_list_6-4>li{
                counter-increment:lst-ctn-kix_list_6-4;
            }
            ol.lst-kix_list_18-5{
                list-style-type:none;
            }
            ol.lst-kix_list_18-6{
                list-style-type:none;
            }
            ol.lst-kix_list_18-0{
                list-style-type:none;
            }
            ol.lst-kix_list_18-1{
                list-style-type:none;
            }
            .lst-kix_list_9-3>li{
                counter-increment:lst-ctn-kix_list_9-3;
            }
            ol.lst-kix_list_18-2{
                list-style-type:none;
            }
            ol.lst-kix_list_15-2.start{
                counter-reset:lst-ctn-kix_list_15-2 0;
            }
            ol.lst-kix_list_2-8.start{
                counter-reset:lst-ctn-kix_list_2-8 0;
            }
            ol.lst-kix_list_7-6.start{
                counter-reset:lst-ctn-kix_list_7-6 0;
            }
            ol.lst-kix_list_15-3.start{
                counter-reset:lst-ctn-kix_list_15-3 0;
            }
            ol.lst-kix_list_5-8.start{
                counter-reset:lst-ctn-kix_list_5-8 0;
            }
            .lst-kix_list_1-3>li{
                counter-increment:lst-ctn-kix_list_1-3;
            }
            ol.lst-kix_list_12-2.start{
                counter-reset:lst-ctn-kix_list_12-2 0;
            }
            ol.lst-kix_list_6-0.start{
                counter-reset:lst-ctn-kix_list_6-0 10;
            }
            ol.lst-kix_list_3-1{
                list-style-type:none;
            }
            ol.lst-kix_list_3-2{
                list-style-type:none;
            }
            ol.lst-kix_list_3-3{
                list-style-type:none;
            }
            ol.lst-kix_list_3-4.start{
                counter-reset:lst-ctn-kix_list_3-4 0;
            }
            .lst-kix_list_5-1>li{
                counter-increment:lst-ctn-kix_list_5-1;
            }
            ol.lst-kix_list_3-4{
                list-style-type:none;
            }
            ol.lst-kix_list_19-0.start{
                counter-reset:lst-ctn-kix_list_19-0 10;
            }
            ol.lst-kix_list_21-3.start{
                counter-reset:lst-ctn-kix_list_21-3 0;
            }
            ol.lst-kix_list_3-0{
                list-style-type:none;
            }
            .lst-kix_list_7-1>li{
                counter-increment:lst-ctn-kix_list_7-1;
            }
            .lst-kix_list_21-8>li:before{
                content:"" counter(lst-ctn-kix_list_21-0,decimal) "." counter(lst-ctn-kix_list_21-1,decimal) "." counter(lst-ctn-kix_list_21-2,decimal) "." counter(lst-ctn-kix_list_21-3,decimal) "." counter(lst-ctn-kix_list_21-4,decimal) "." counter(lst-ctn-kix_list_21-5,decimal) "." counter(lst-ctn-kix_list_21-6,decimal) "." counter(lst-ctn-kix_list_21-7,decimal) "." counter(lst-ctn-kix_list_21-8,decimal) ". ";
            }
            .lst-kix_list_16-0>li{
                counter-increment:lst-ctn-kix_list_16-0;
            }
            .lst-kix_list_8-0>li{
                counter-increment:lst-ctn-kix_list_8-0;
            }
            .lst-kix_list_10-0>li{
                counter-increment:lst-ctn-kix_list_10-0;
            }
            ol.lst-kix_list_18-2.start{
                counter-reset:lst-ctn-kix_list_18-2 0;
            }
            ol.lst-kix_list_3-5{
                list-style-type:none;
            }
            ol.lst-kix_list_3-6{
                list-style-type:none;
            }
            ol.lst-kix_list_3-7{
                list-style-type:none;
            }
            ol.lst-kix_list_3-8{
                list-style-type:none;
            }
            li.li-bullet-35:before{
                margin-left:-25.4pt;
                white-space:nowrap;
                display:inline-block;
                min-width:25.4pt;
            }
            .lst-kix_list_21-0>li:before{
                content:"" counter(lst-ctn-kix_list_21-0,decimal) ". ";
            }
            li.li-bullet-46:before{
                margin-left:-30.2pt;
                white-space:nowrap;
                display:inline-block;
                min-width:30.2pt;
            }
            .lst-kix_list_13-1>li{
                counter-increment:lst-ctn-kix_list_13-1;
            }
            .lst-kix_list_21-1>li:before{
                content:"" counter(lst-ctn-kix_list_21-0,decimal) "." counter(lst-ctn-kix_list_21-1,decimal) ". ";
            }
            ol.lst-kix_list_15-8.start{
                counter-reset:lst-ctn-kix_list_15-8 0;
            }
            .lst-kix_list_10-2>li{
                counter-increment:lst-ctn-kix_list_10-2;
            }
            .lst-kix_list_21-5>li:before{
                content:"" counter(lst-ctn-kix_list_21-0,decimal) "." counter(lst-ctn-kix_list_21-1,decimal) "." counter(lst-ctn-kix_list_21-2,decimal) "." counter(lst-ctn-kix_list_21-3,decimal) "." counter(lst-ctn-kix_list_21-4,decimal) "." counter(lst-ctn-kix_list_21-5,decimal) ". ";
            }
            li.li-bullet-40:before{
                margin-left:-35.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:35.5pt;
            }
            .lst-kix_list_21-4>li:before{
                content:"" counter(lst-ctn-kix_list_21-0,decimal) "." counter(lst-ctn-kix_list_21-1,decimal) "." counter(lst-ctn-kix_list_21-2,decimal) "." counter(lst-ctn-kix_list_21-3,decimal) "." counter(lst-ctn-kix_list_21-4,decimal) ". ";
            }
            ol.lst-kix_list_7-2.start{
                counter-reset:lst-ctn-kix_list_7-2 0;
            }
            ol.lst-kix_list_19-5.start{
                counter-reset:lst-ctn-kix_list_19-5 0;
            }
            ol.lst-kix_list_12-5{
                list-style-type:none;
            }
            ol.lst-kix_list_12-6{
                list-style-type:none;
            }
            ol.lst-kix_list_12-7{
                list-style-type:none;
            }
            ol.lst-kix_list_12-8{
                list-style-type:none;
            }
            ol.lst-kix_list_12-1{
                list-style-type:none;
            }
            ol.lst-kix_list_12-2{
                list-style-type:none;
            }
            ol.lst-kix_list_12-3{
                list-style-type:none;
            }
            ol.lst-kix_list_12-4{
                list-style-type:none;
            }
            ol.lst-kix_list_12-0{
                list-style-type:none;
            }
            .lst-kix_list_21-0>li{
                counter-increment:lst-ctn-kix_list_21-0;
            }
            ol.lst-kix_list_10-8.start{
                counter-reset:lst-ctn-kix_list_10-8 0;
            }
            li.li-bullet-18:before{
                margin-left:-18pt;
                white-space:nowrap;
                display:inline-block;
                min-width:18pt;
            }
            ol.lst-kix_list_7-1.start{
                counter-reset:lst-ctn-kix_list_7-1 1;
            }
            .lst-kix_list_16-7>li{
                counter-increment:lst-ctn-kix_list_16-7;
            }
            ol.lst-kix_list_21-4.start{
                counter-reset:lst-ctn-kix_list_21-4 0;
            }
            ol.lst-kix_list_20-6.start{
                counter-reset:lst-ctn-kix_list_20-6 0;
            }
            .lst-kix_list_13-8>li{
                counter-increment:lst-ctn-kix_list_13-8;
            }
            .lst-kix_list_2-2>li{
                counter-increment:lst-ctn-kix_list_2-2;
            }
            .lst-kix_list_16-5>li{
                counter-increment:lst-ctn-kix_list_16-5;
            }
            ol.lst-kix_list_5-0{
                list-style-type:none;
            }
            .lst-kix_list_3-7>li{
                counter-increment:lst-ctn-kix_list_3-7;
            }
            ol.lst-kix_list_5-1{
                list-style-type:none;
            }
            ol.lst-kix_list_5-2{
                list-style-type:none;
            }
            .lst-kix_list_22-5>li:before{
                content:"" counter(lst-ctn-kix_list_22-0,decimal) "." counter(lst-ctn-kix_list_22-1,decimal) "." counter(lst-ctn-kix_list_22-2,decimal) "." counter(lst-ctn-kix_list_22-3,decimal) "." counter(lst-ctn-kix_list_22-4,decimal) "." counter(lst-ctn-kix_list_22-5,decimal) " ";
            }
            .lst-kix_list_21-2>li{
                counter-increment:lst-ctn-kix_list_21-2;
            }
            .lst-kix_list_22-1>li:before{
                content:"" counter(lst-ctn-kix_list_22-0,decimal) "." counter(lst-ctn-kix_list_22-1,decimal) " ";
            }
            .lst-kix_list_20-2>li{
                counter-increment:lst-ctn-kix_list_20-2;
            }
            .lst-kix_list_6-6>li{
                counter-increment:lst-ctn-kix_list_6-6;
            }
            ol.lst-kix_list_15-7.start{
                counter-reset:lst-ctn-kix_list_15-7 0;
            }
            .lst-kix_list_13-6>li{
                counter-increment:lst-ctn-kix_list_13-6;
            }
            ol.lst-kix_list_14-6.start{
                counter-reset:lst-ctn-kix_list_14-6 0;
            }
            ol.lst-kix_list_5-7{
                list-style-type:none;
            }
            ol.lst-kix_list_5-8{
                list-style-type:none;
            }
            ol.lst-kix_list_5-3{
                list-style-type:none;
            }
            .lst-kix_list_8-7>li{
                counter-increment:lst-ctn-kix_list_8-7;
            }
            .lst-kix_list_19-6>li{
                counter-increment:lst-ctn-kix_list_19-6;
            }
            ol.lst-kix_list_5-4{
                list-style-type:none;
            }
            ol.lst-kix_list_5-5{
                list-style-type:none;
            }
            ol.lst-kix_list_5-6{
                list-style-type:none;
            }
            .lst-kix_list_20-4>li{
                counter-increment:lst-ctn-kix_list_20-4;
            }
            li.li-bullet-62:before{
                margin-left:-25.4pt;
                white-space:nowrap;
                display:inline-block;
                min-width:25.4pt;
            }
            .lst-kix_list_9-5>li{
                counter-increment:lst-ctn-kix_list_9-5;
            }
            .lst-kix_list_5-8>li{
                counter-increment:lst-ctn-kix_list_5-8;
            }
            li.li-bullet-3:before{
                margin-left:-21.6pt;
                white-space:nowrap;
                display:inline-block;
                min-width:21.6pt;
            }
            ol.lst-kix_list_19-4.start{
                counter-reset:lst-ctn-kix_list_19-4 0;
            }
            ol.lst-kix_list_20-1.start{
                counter-reset:lst-ctn-kix_list_20-1 0;
            }
            ol.lst-kix_list_2-2.start{
                counter-reset:lst-ctn-kix_list_2-2 0;
            }
            .lst-kix_list_19-4>li{
                counter-increment:lst-ctn-kix_list_19-4;
            }
            li.li-bullet-51:before{
                margin-left:-30.2pt;
                white-space:nowrap;
                display:inline-block;
                min-width:30.2pt;
            }
            ol.lst-kix_list_14-7{
                list-style-type:none;
            }
            ol.lst-kix_list_14-8{
                list-style-type:none;
            }
            ol.lst-kix_list_21-8.start{
                counter-reset:lst-ctn-kix_list_21-8 0;
            }
            ol.lst-kix_list_14-3{
                list-style-type:none;
            }
            li.li-bullet-8:before{
                margin-left:-18pt;
                white-space:nowrap;
                display:inline-block;
                min-width:18pt;
            }
            ol.lst-kix_list_14-4{
                list-style-type:none;
            }
            ol.lst-kix_list_14-5{
                list-style-type:none;
            }
            ol.lst-kix_list_14-6{
                list-style-type:none;
            }
            .lst-kix_list_15-2>li{
                counter-increment:lst-ctn-kix_list_15-2;
            }
            .lst-kix_list_22-5>li{
                counter-increment:lst-ctn-kix_list_22-5;
            }
            ol.lst-kix_list_14-0{
                list-style-type:none;
            }
            ol.lst-kix_list_14-1{
                list-style-type:none;
            }
            ol.lst-kix_list_14-2{
                list-style-type:none;
            }
            .lst-kix_list_20-5>li:before{
                content:"" counter(lst-ctn-kix_list_20-0,decimal) "." counter(lst-ctn-kix_list_20-1,decimal) "." counter(lst-ctn-kix_list_20-2,decimal) "." counter(lst-ctn-kix_list_20-3,decimal) "." counter(lst-ctn-kix_list_20-4,decimal) "." counter(lst-ctn-kix_list_20-5,decimal) ". ";
            }
            .lst-kix_list_20-1>li:before{
                content:"" counter(lst-ctn-kix_list_20-0,decimal) "." counter(lst-ctn-kix_list_20-1,decimal) ". ";
            }
            .lst-kix_list_12-3>li{
                counter-increment:lst-ctn-kix_list_12-3;
            }
            .lst-kix_list_17-3>li{
                counter-increment:lst-ctn-kix_list_17-3;
            }
            ol.lst-kix_list_8-4.start{
                counter-reset:lst-ctn-kix_list_8-4 0;
            }
            li.li-bullet-45:before{
                margin-left:-30.2pt;
                white-space:nowrap;
                display:inline-block;
                min-width:30.2pt;
            }
            ol.lst-kix_list_3-5.start{
                counter-reset:lst-ctn-kix_list_3-5 0;
            }
            .lst-kix_list_21-7>li{
                counter-increment:lst-ctn-kix_list_21-7;
            }
            ol.lst-kix_list_13-0.start{
                counter-reset:lst-ctn-kix_list_13-0 1;
            }
            .lst-kix_list_14-4>li{
                counter-increment:lst-ctn-kix_list_14-4;
            }
            .lst-kix_list_10-7>li{
                counter-increment:lst-ctn-kix_list_10-7;
            }
            li.li-bullet-67:before{
                margin-left:-25.4pt;
                white-space:nowrap;
                display:inline-block;
                min-width:25.4pt;
            }
            .lst-kix_list_18-1>li{
                counter-increment:lst-ctn-kix_list_18-1;
            }
            ol.lst-kix_list_8-3.start{
                counter-reset:lst-ctn-kix_list_8-3 0;
            }
            .lst-kix_list_11-5>li{
                counter-increment:lst-ctn-kix_list_11-5;
            }
            ol.lst-kix_list_14-5.start{
                counter-reset:lst-ctn-kix_list_14-5 0;
            }
            ol.lst-kix_list_20-3.start{
                counter-reset:lst-ctn-kix_list_20-3 0;
            }
            li.li-bullet-56:before{
                margin-left:-25.4pt;
                white-space:nowrap;
                display:inline-block;
                min-width:25.4pt;
            }
            .lst-kix_list_19-1>li:before{
                content:"" counter(lst-ctn-kix_list_19-0,decimal) "." counter(lst-ctn-kix_list_19-1,decimal) ". ";
            }
            .lst-kix_list_19-4>li:before{
                content:"" counter(lst-ctn-kix_list_19-0,decimal) "." counter(lst-ctn-kix_list_19-1,decimal) "." counter(lst-ctn-kix_list_19-2,decimal) "." counter(lst-ctn-kix_list_19-3,decimal) "." counter(lst-ctn-kix_list_19-4,decimal) ". ";
            }
            .lst-kix_list_19-3>li:before{
                content:"" counter(lst-ctn-kix_list_19-0,decimal) "." counter(lst-ctn-kix_list_19-1,decimal) "." counter(lst-ctn-kix_list_19-2,decimal) "." counter(lst-ctn-kix_list_19-3,decimal) ". ";
            }
            .lst-kix_list_15-0>li{
                counter-increment:lst-ctn-kix_list_15-0;
            }
            ol.lst-kix_list_6-6.start{
                counter-reset:lst-ctn-kix_list_6-6 0;
            }
            .lst-kix_list_11-0>li{
                counter-increment:lst-ctn-kix_list_11-0;
            }
            ol.lst-kix_list_1-5.start{
                counter-reset:lst-ctn-kix_list_1-5 0;
            }
            ol.lst-kix_list_9-6.start{
                counter-reset:lst-ctn-kix_list_9-6 0;
            }
            ol.lst-kix_list_16-3.start{
                counter-reset:lst-ctn-kix_list_16-3 0;
            }
            ol.lst-kix_list_22-4.start{
                counter-reset:lst-ctn-kix_list_22-4 0;
            }
            .lst-kix_list_22-7>li{
                counter-increment:lst-ctn-kix_list_22-7;
            }
            ol.lst-kix_list_11-2.start{
                counter-reset:lst-ctn-kix_list_11-2 0;
            }
            .lst-kix_list_5-2>li{
                counter-increment:lst-ctn-kix_list_5-2;
            }
            .lst-kix_list_19-6>li:before{
                content:"" counter(lst-ctn-kix_list_19-0,decimal) "." counter(lst-ctn-kix_list_19-1,decimal) "." counter(lst-ctn-kix_list_19-2,decimal) "." counter(lst-ctn-kix_list_19-3,decimal) "." counter(lst-ctn-kix_list_19-4,decimal) "." counter(lst-ctn-kix_list_19-5,decimal) "." counter(lst-ctn-kix_list_19-6,decimal) ". ";
            }
            ol.lst-kix_list_8-7.start{
                counter-reset:lst-ctn-kix_list_8-7 0;
            }
            .lst-kix_list_17-2>li{
                counter-increment:lst-ctn-kix_list_17-2;
            }
            .lst-kix_list_20-5>li{
                counter-increment:lst-ctn-kix_list_20-5;
            }
            .lst-kix_list_22-0>li{
                counter-increment:lst-ctn-kix_list_22-0;
            }
            .lst-kix_list_18-3>li{
                counter-increment:lst-ctn-kix_list_18-3;
            }
            .lst-kix_list_21-6>li{
                counter-increment:lst-ctn-kix_list_21-6;
            }
            .lst-kix_list_10-3>li{
                counter-increment:lst-ctn-kix_list_10-3;
            }
            ol.lst-kix_list_1-0.start{
                counter-reset:lst-ctn-kix_list_1-0 7;
            }
            .lst-kix_list_18-0>li:before{
                content:"" counter(lst-ctn-kix_list_18-0,decimal) ". ";
            }
            ol.lst-kix_list_13-3.start{
                counter-reset:lst-ctn-kix_list_13-3 0;
            }
            .lst-kix_list_3-0>li{
                counter-increment:lst-ctn-kix_list_3-0;
            }
            .lst-kix_list_18-2>li:before{
                content:"" counter(lst-ctn-kix_list_18-0,decimal) "." counter(lst-ctn-kix_list_18-1,decimal) "." counter(lst-ctn-kix_list_18-2,decimal) ". ";
            }
            li.li-bullet-2:before{
                margin-left:-34.9pt;
                white-space:nowrap;
                display:inline-block;
                min-width:34.9pt;
            }
            ol.lst-kix_list_11-7.start{
                counter-reset:lst-ctn-kix_list_11-7 0;
            }
            ol.lst-kix_list_14-2.start{
                counter-reset:lst-ctn-kix_list_14-2 0;
            }
            .lst-kix_list_16-1>li{
                counter-increment:lst-ctn-kix_list_16-1;
            }
            .lst-kix_list_17-5>li{
                counter-increment:lst-ctn-kix_list_17-5;
            }
            ol.lst-kix_list_9-4.start{
                counter-reset:lst-ctn-kix_list_9-4 0;
            }
            .lst-kix_list_21-3>li{
                counter-increment:lst-ctn-kix_list_21-3;
            }
            .lst-kix_list_18-8>li:before{
                content:"" counter(lst-ctn-kix_list_18-0,decimal) "." counter(lst-ctn-kix_list_18-1,decimal) "." counter(lst-ctn-kix_list_18-2,decimal) "." counter(lst-ctn-kix_list_18-3,decimal) "." counter(lst-ctn-kix_list_18-4,decimal) "." counter(lst-ctn-kix_list_18-5,decimal) "." counter(lst-ctn-kix_list_18-6,decimal) "." counter(lst-ctn-kix_list_18-7,decimal) "." counter(lst-ctn-kix_list_18-8,decimal) ". ";
            }
            .lst-kix_list_17-6>li{
                counter-increment:lst-ctn-kix_list_17-6;
            }
            .lst-kix_list_10-7>li:before{
                content:"" counter(lst-ctn-kix_list_10-0,decimal) "." counter(lst-ctn-kix_list_10-1,decimal) "." counter(lst-ctn-kix_list_10-2,decimal) "." counter(lst-ctn-kix_list_10-3,decimal) "." counter(lst-ctn-kix_list_10-4,decimal) "." counter(lst-ctn-kix_list_10-5,decimal) "." counter(lst-ctn-kix_list_10-6,decimal) "." counter(lst-ctn-kix_list_10-7,decimal) ". ";
            }
            .lst-kix_list_7-8>li{
                counter-increment:lst-ctn-kix_list_7-8;
            }
            .lst-kix_list_20-1>li{
                counter-increment:lst-ctn-kix_list_20-1;
            }
            li.li-bullet-60:before{
                margin-left:-36pt;
                white-space:nowrap;
                display:inline-block;
                min-width:36pt;
            }
            .lst-kix_list_10-5>li:before{
                content:"" counter(lst-ctn-kix_list_10-0,decimal) "." counter(lst-ctn-kix_list_10-1,decimal) "." counter(lst-ctn-kix_list_10-2,decimal) "." counter(lst-ctn-kix_list_10-3,decimal) "." counter(lst-ctn-kix_list_10-4,decimal) "." counter(lst-ctn-kix_list_10-5,decimal) ". ";
            }
            ol.lst-kix_list_13-5.start{
                counter-reset:lst-ctn-kix_list_13-5 0;
            }
            ol.lst-kix_list_18-6.start{
                counter-reset:lst-ctn-kix_list_18-6 0;
            }
            ol.lst-kix_list_20-8{
                list-style-type:none;
            }
            ol.lst-kix_list_20-5{
                list-style-type:none;
            }
            ol.lst-kix_list_13-8.start{
                counter-reset:lst-ctn-kix_list_13-8 0;
            }
            ol.lst-kix_list_20-4{
                list-style-type:none;
            }
            ol.lst-kix_list_20-7{
                list-style-type:none;
            }
            ol.lst-kix_list_20-6{
                list-style-type:none;
            }
            .lst-kix_list_11-7>li{
                counter-increment:lst-ctn-kix_list_11-7;
            }
            ol.lst-kix_list_20-1{
                list-style-type:none;
            }
            .lst-kix_list_9-2>li:before{
                content:"" counter(lst-ctn-kix_list_9-0,decimal) "." counter(lst-ctn-kix_list_9-1,decimal) "." counter(lst-ctn-kix_list_9-2,decimal) ". ";
            }
            li.li-bullet-68:before{
                margin-left:-25.4pt;
                white-space:nowrap;
                display:inline-block;
                min-width:25.4pt;
            }
            ol.lst-kix_list_20-0{
                list-style-type:none;
            }
            ol.lst-kix_list_20-3{
                list-style-type:none;
            }
            ol.lst-kix_list_20-2{
                list-style-type:none;
            }
            ol.lst-kix_list_14-0.start{
                counter-reset:lst-ctn-kix_list_14-0 1;
            }
            .lst-kix_list_12-5>li{
                counter-increment:lst-ctn-kix_list_12-5;
            }
            .lst-kix_list_5-5>li{
                counter-increment:lst-ctn-kix_list_5-5;
            }
            .lst-kix_list_9-0>li:before{
                content:"" counter(lst-ctn-kix_list_9-0,decimal) ". ";
            }
            li.li-bullet-57:before{
                margin-left:-25.4pt;
                white-space:nowrap;
                display:inline-block;
                min-width:25.4pt;
            }
            .lst-kix_list_16-8>li{
                counter-increment:lst-ctn-kix_list_16-8;
            }
            .lst-kix_list_11-3>li:before{
                content:"" counter(lst-ctn-kix_list_11-3,decimal) ". ";
            }
            .lst-kix_list_6-3>li{
                counter-increment:lst-ctn-kix_list_6-3;
            }
            ol.lst-kix_list_18-4.start{
                counter-reset:lst-ctn-kix_list_18-4 0;
            }
            ol.lst-kix_list_1-3.start{
                counter-reset:lst-ctn-kix_list_1-3 0;
            }
            .lst-kix_list_20-4>li:before{
                content:"" counter(lst-ctn-kix_list_20-0,decimal) "." counter(lst-ctn-kix_list_20-1,decimal) "." counter(lst-ctn-kix_list_20-2,decimal) "." counter(lst-ctn-kix_list_20-3,decimal) "." counter(lst-ctn-kix_list_20-4,decimal) ". ";
            }
            ol.lst-kix_list_1-2.start{
                counter-reset:lst-ctn-kix_list_1-2 0;
            }
            ol.lst-kix_list_22-7.start{
                counter-reset:lst-ctn-kix_list_22-7 0;
            }
            .lst-kix_list_20-2>li:before{
                content:"" counter(lst-ctn-kix_list_20-0,decimal) "." counter(lst-ctn-kix_list_20-1,decimal) "." counter(lst-ctn-kix_list_20-2,decimal) ". ";
            }
            ol.lst-kix_list_6-1.start{
                counter-reset:lst-ctn-kix_list_6-1 1;
            }
            .lst-kix_list_9-8>li:before{
                content:"" counter(lst-ctn-kix_list_9-0,decimal) "." counter(lst-ctn-kix_list_9-1,decimal) "." counter(lst-ctn-kix_list_9-2,decimal) "." counter(lst-ctn-kix_list_9-3,decimal) "." counter(lst-ctn-kix_list_9-4,decimal) "." counter(lst-ctn-kix_list_9-5,decimal) "." counter(lst-ctn-kix_list_9-6,decimal) "." counter(lst-ctn-kix_list_9-7,decimal) "." counter(lst-ctn-kix_list_9-8,decimal) ". ";
            }
            ol.lst-kix_list_16-8.start{
                counter-reset:lst-ctn-kix_list_16-8 0;
            }
            li.li-bullet-63:before{
                margin-left:-10.9pt;
                white-space:nowrap;
                display:inline-block;
                min-width:10.9pt;
            }
            .lst-kix_list_1-7>li:before{
                content:"" counter(lst-ctn-kix_list_1-0,decimal) "." counter(lst-ctn-kix_list_1-1,decimal) "." counter(lst-ctn-kix_list_1-2,decimal) "." counter(lst-ctn-kix_list_1-3,decimal) "." counter(lst-ctn-kix_list_1-4,decimal) "." counter(lst-ctn-kix_list_1-5,decimal) "." counter(lst-ctn-kix_list_1-6,decimal) "." counter(lst-ctn-kix_list_1-7,decimal) ". ";
            }
            .lst-kix_list_1-5>li:before{
                content:"" counter(lst-ctn-kix_list_1-0,decimal) "." counter(lst-ctn-kix_list_1-1,decimal) "." counter(lst-ctn-kix_list_1-2,decimal) "." counter(lst-ctn-kix_list_1-3,decimal) "." counter(lst-ctn-kix_list_1-4,decimal) "." counter(lst-ctn-kix_list_1-5,decimal) ". ";
            }
            ol.lst-kix_list_9-1.start{
                counter-reset:lst-ctn-kix_list_9-1 1;
            }
            .lst-kix_list_5-6>li{
                counter-increment:lst-ctn-kix_list_5-6;
            }
            ol.lst-kix_list_22-6.start{
                counter-reset:lst-ctn-kix_list_22-6 0;
            }
            li.li-bullet-30:before{
                margin-left:-18pt;
                white-space:nowrap;
                display:inline-block;
                min-width:18pt;
            }
            .lst-kix_list_2-1>li:before{
                content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) ". ";
            }
            .lst-kix_list_19-8>li{
                counter-increment:lst-ctn-kix_list_19-8;
            }
            li.li-bullet-41:before{
                margin-left:-35.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:35.5pt;
            }
            .lst-kix_list_2-3>li:before{
                content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) "." counter(lst-ctn-kix_list_2-3,decimal) ". ";
            }
            .lst-kix_list_11-8>li{
                counter-increment:lst-ctn-kix_list_11-8;
            }
            li.li-bullet-52:before{
                margin-left:-30.2pt;
                white-space:nowrap;
                display:inline-block;
                min-width:30.2pt;
            }
            .lst-kix_list_20-8>li{
                counter-increment:lst-ctn-kix_list_20-8;
            }
            .lst-kix_list_9-1>li{
                counter-increment:lst-ctn-kix_list_9-1;
            }
            .lst-kix_list_3-2>li:before{
                content:"" counter(lst-ctn-kix_list_3-0,decimal) "." counter(lst-ctn-kix_list_3-1,decimal) "." counter(lst-ctn-kix_list_3-2,decimal) " ";
            }
            .lst-kix_list_8-1>li:before{
                content:"" counter(lst-ctn-kix_list_8-0,decimal) "." counter(lst-ctn-kix_list_8-1,decimal) ". ";
            }
            ol.lst-kix_list_1-8.start{
                counter-reset:lst-ctn-kix_list_1-8 0;
            }
            .lst-kix_list_6-0>li{
                counter-increment:lst-ctn-kix_list_6-0;
            }
            .lst-kix_list_3-5>li:before{
                content:"" counter(lst-ctn-kix_list_3-0,decimal) "." counter(lst-ctn-kix_list_3-1,decimal) "." counter(lst-ctn-kix_list_3-2,decimal) "." counter(lst-ctn-kix_list_3-3,decimal) "." counter(lst-ctn-kix_list_3-4,decimal) "." counter(lst-ctn-kix_list_3-5,decimal) " ";
            }
            .lst-kix_list_18-0>li{
                counter-increment:lst-ctn-kix_list_18-0;
            }
            li.li-bullet-37:before{
                margin-left:-18pt;
                white-space:nowrap;
                display:inline-block;
                min-width:18pt;
            }
            ol.lst-kix_list_11-5.start{
                counter-reset:lst-ctn-kix_list_11-5 0;
            }
            .lst-kix_list_11-1>li{
                counter-increment:lst-ctn-kix_list_11-1;
            }
            .lst-kix_list_8-6>li:before{
                content:"" counter(lst-ctn-kix_list_8-0,decimal) "." counter(lst-ctn-kix_list_8-1,decimal) "." counter(lst-ctn-kix_list_8-2,decimal) "." counter(lst-ctn-kix_list_8-3,decimal) "." counter(lst-ctn-kix_list_8-4,decimal) "." counter(lst-ctn-kix_list_8-5,decimal) "." counter(lst-ctn-kix_list_8-6,decimal) ". ";
            }
            .lst-kix_list_21-6>li:before{
                content:"" counter(lst-ctn-kix_list_21-0,decimal) "." counter(lst-ctn-kix_list_21-1,decimal) "." counter(lst-ctn-kix_list_21-2,decimal) "." counter(lst-ctn-kix_list_21-3,decimal) "." counter(lst-ctn-kix_list_21-4,decimal) "." counter(lst-ctn-kix_list_21-5,decimal) "." counter(lst-ctn-kix_list_21-6,decimal) ". ";
            }
            ol.lst-kix_list_16-6.start{
                counter-reset:lst-ctn-kix_list_16-6 0;
            }
            li.li-bullet-48:before{
                margin-left:-30.2pt;
                white-space:nowrap;
                display:inline-block;
                min-width:30.2pt;
            }
            ol.lst-kix_list_22-1.start{
                counter-reset:lst-ctn-kix_list_22-1 0;
            }
            ol.lst-kix_list_16-0.start{
                counter-reset:lst-ctn-kix_list_16-0 10;
            }
            .lst-kix_list_21-3>li:before{
                content:"" counter(lst-ctn-kix_list_21-0,decimal) "." counter(lst-ctn-kix_list_21-1,decimal) "." counter(lst-ctn-kix_list_21-2,decimal) "." counter(lst-ctn-kix_list_21-3,decimal) ". ";
            }
            ol.lst-kix_list_18-7.start{
                counter-reset:lst-ctn-kix_list_18-7 0;
            }
            ol.lst-kix_list_11-6.start{
                counter-reset:lst-ctn-kix_list_11-6 0;
            }
            ol.lst-kix_list_6-4.start{
                counter-reset:lst-ctn-kix_list_6-4 0;
            }
            .lst-kix_list_17-1>li:before{
                content:"" counter(lst-ctn-kix_list_17-0,decimal) "." counter(lst-ctn-kix_list_17-1,decimal) ". ";
            }
            li.li-bullet-10:before{
                margin-left:-27.4pt;
                white-space:nowrap;
                display:inline-block;
                min-width:27.4pt;
            }
            .lst-kix_list_16-2>li:before{
                content:"" counter(lst-ctn-kix_list_16-0,decimal) "." counter(lst-ctn-kix_list_16-1,decimal) "." counter(lst-ctn-kix_list_16-2,decimal) ". ";
            }
            .lst-kix_list_16-5>li:before{
                content:"" counter(lst-ctn-kix_list_16-0,decimal) "." counter(lst-ctn-kix_list_16-1,decimal) "." counter(lst-ctn-kix_list_16-2,decimal) "." counter(lst-ctn-kix_list_16-3,decimal) "." counter(lst-ctn-kix_list_16-4,decimal) "." counter(lst-ctn-kix_list_16-5,decimal) ". ";
            }
            .lst-kix_list_15-3>li{
                counter-increment:lst-ctn-kix_list_15-3;
            }
            ol.lst-kix_list_22-2.start{
                counter-reset:lst-ctn-kix_list_22-2 0;
            }
            ol.lst-kix_list_11-0.start{
                counter-reset:lst-ctn-kix_list_11-0 0;
            }
            ol.lst-kix_list_18-8.start{
                counter-reset:lst-ctn-kix_list_18-8 0;
            }
            .lst-kix_list_3-3>li{
                counter-increment:lst-ctn-kix_list_3-3;
            }
            .lst-kix_list_16-4>li{
                counter-increment:lst-ctn-kix_list_16-4;
            }
            ol.lst-kix_list_6-3.start{
                counter-reset:lst-ctn-kix_list_6-3 0;
            }
            ol.lst-kix_list_16-5.start{
                counter-reset:lst-ctn-kix_list_16-5 0;
            }
            li.li-bullet-65:before{
                margin-left:-36pt;
                white-space:nowrap;
                display:inline-block;
                min-width:36pt;
            }
            .lst-kix_list_17-6>li:before{
                content:"" counter(lst-ctn-kix_list_17-0,decimal) "." counter(lst-ctn-kix_list_17-1,decimal) "." counter(lst-ctn-kix_list_17-2,decimal) "." counter(lst-ctn-kix_list_17-3,decimal) "." counter(lst-ctn-kix_list_17-4,decimal) "." counter(lst-ctn-kix_list_17-5,decimal) "." counter(lst-ctn-kix_list_17-6,decimal) ". ";
            }
            .lst-kix_list_2-6>li:before{
                content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) "." counter(lst-ctn-kix_list_2-3,decimal) "." counter(lst-ctn-kix_list_2-4,decimal) "." counter(lst-ctn-kix_list_2-5,decimal) "." counter(lst-ctn-kix_list_2-6,decimal) ". ";
            }
            ol.lst-kix_list_16-2.start{
                counter-reset:lst-ctn-kix_list_16-2 0;
            }
            .lst-kix_list_14-5>li{
                counter-increment:lst-ctn-kix_list_14-5;
            }
            .lst-kix_list_7-5>li:before{
                content:"" counter(lst-ctn-kix_list_7-0,decimal) "." counter(lst-ctn-kix_list_7-1,decimal) "." counter(lst-ctn-kix_list_7-2,decimal) "." counter(lst-ctn-kix_list_7-3,decimal) "." counter(lst-ctn-kix_list_7-4,decimal) "." counter(lst-ctn-kix_list_7-5,decimal) ". ";
            }
            .lst-kix_list_19-5>li{
                counter-increment:lst-ctn-kix_list_19-5;
            }
            .lst-kix_list_22-7>li:before{
                content:"" counter(lst-ctn-kix_list_22-0,decimal) "." counter(lst-ctn-kix_list_22-1,decimal) "." counter(lst-ctn-kix_list_22-2,decimal) "." counter(lst-ctn-kix_list_22-3,decimal) "." counter(lst-ctn-kix_list_22-4,decimal) "." counter(lst-ctn-kix_list_22-5,decimal) "." counter(lst-ctn-kix_list_22-6,decimal) "." counter(lst-ctn-kix_list_22-7,decimal) " ";
            }
            ol.lst-kix_list_11-1.start{
                counter-reset:lst-ctn-kix_list_11-1 0;
            }
            .lst-kix_list_18-5>li:before{
                content:"" counter(lst-ctn-kix_list_18-0,decimal) "." counter(lst-ctn-kix_list_18-1,decimal) "." counter(lst-ctn-kix_list_18-2,decimal) "." counter(lst-ctn-kix_list_18-3,decimal) "." counter(lst-ctn-kix_list_18-4,decimal) "." counter(lst-ctn-kix_list_18-5,decimal) ". ";
            }
            .lst-kix_list_13-6>li:before{
                content:"" counter(lst-ctn-kix_list_13-0,decimal) "." counter(lst-ctn-kix_list_13-1,decimal) "." counter(lst-ctn-kix_list_13-2,decimal) "." counter(lst-ctn-kix_list_13-3,decimal) "." counter(lst-ctn-kix_list_13-4,decimal) "." counter(lst-ctn-kix_list_13-5,decimal) "." counter(lst-ctn-kix_list_13-6,decimal) ". ";
            }
            .lst-kix_list_6-7>li{
                counter-increment:lst-ctn-kix_list_6-7;
            }
            .lst-kix_list_10-6>li{
                counter-increment:lst-ctn-kix_list_10-6;
            }
            .lst-kix_list_1-7>li{
                counter-increment:lst-ctn-kix_list_1-7;
            }
            .lst-kix_list_7-5>li{
                counter-increment:lst-ctn-kix_list_7-5;
            }
            .lst-kix_list_15-6>li:before{
                content:"" counter(lst-ctn-kix_list_15-0,decimal) "." counter(lst-ctn-kix_list_15-1,decimal) "." counter(lst-ctn-kix_list_15-2,decimal) "." counter(lst-ctn-kix_list_15-3,decimal) "." counter(lst-ctn-kix_list_15-4,decimal) "." counter(lst-ctn-kix_list_15-5,decimal) "." counter(lst-ctn-kix_list_15-6,decimal) ". ";
            }
            .lst-kix_list_11-4>li{
                counter-increment:lst-ctn-kix_list_11-4;
            }
            .lst-kix_list_22-4>li{
                counter-increment:lst-ctn-kix_list_22-4;
            }
            li.li-bullet-15:before{
                margin-left:-27.4pt;
                white-space:nowrap;
                display:inline-block;
                min-width:27.4pt;
            }
            ol.lst-kix_list_6-8.start{
                counter-reset:lst-ctn-kix_list_6-8 0;
            }
            .lst-kix_list_10-2>li:before{
                content:"" counter(lst-ctn-kix_list_10-0,decimal) "." counter(lst-ctn-kix_list_10-1,decimal) "." counter(lst-ctn-kix_list_10-2,decimal) ". ";
            }
            li.li-bullet-26:before{
                margin-left:-32.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:32.5pt;
            }
            .lst-kix_list_13-7>li{
                counter-increment:lst-ctn-kix_list_13-7;
            }
            ol.lst-kix_list_1-7.start{
                counter-reset:lst-ctn-kix_list_1-7 0;
            }
            .lst-kix_list_20-7>li:before{
                content:"" counter(lst-ctn-kix_list_20-0,decimal) "." counter(lst-ctn-kix_list_20-1,decimal) "." counter(lst-ctn-kix_list_20-2,decimal) "." counter(lst-ctn-kix_list_20-3,decimal) "." counter(lst-ctn-kix_list_20-4,decimal) "." counter(lst-ctn-kix_list_20-5,decimal) "." counter(lst-ctn-kix_list_20-6,decimal) "." counter(lst-ctn-kix_list_20-7,decimal) ". ";
            }
            ol.lst-kix_list_6-5.start{
                counter-reset:lst-ctn-kix_list_6-5 0;
            }
            .lst-kix_list_4-6>li:before{
                content:"\0025cf   ";
            }
            li.li-bullet-59:before{
                margin-left:-36pt;
                white-space:nowrap;
                display:inline-block;
                min-width:36pt;
            }
            ol.lst-kix_list_6-7.start{
                counter-reset:lst-ctn-kix_list_6-7 0;
            }
            .lst-kix_list_12-2>li{
                counter-increment:lst-ctn-kix_list_12-2;
            }
            .lst-kix_list_9-5>li:before{
                content:"" counter(lst-ctn-kix_list_9-0,decimal) "." counter(lst-ctn-kix_list_9-1,decimal) "." counter(lst-ctn-kix_list_9-2,decimal) "." counter(lst-ctn-kix_list_9-3,decimal) "." counter(lst-ctn-kix_list_9-4,decimal) "." counter(lst-ctn-kix_list_9-5,decimal) ". ";
            }
            li.li-bullet-5:before{
                margin-left:-18pt;
                white-space:nowrap;
                display:inline-block;
                min-width:18pt;
            }
            ol.lst-kix_list_22-0.start{
                counter-reset:lst-ctn-kix_list_22-0 4;
            }
            .lst-kix_list_12-2>li:before{
                content:"" counter(lst-ctn-kix_list_12-0,decimal) "." counter(lst-ctn-kix_list_12-1,decimal) "." counter(lst-ctn-kix_list_12-2,decimal) ". ";
            }
            .lst-kix_list_11-6>li:before{
                content:"" counter(lst-ctn-kix_list_11-6,decimal) ". ";
            }
            ol.lst-kix_list_11-3.start{
                counter-reset:lst-ctn-kix_list_11-3 0;
            }
            .lst-kix_list_1-2>li:before{
                content:"" counter(lst-ctn-kix_list_1-0,decimal) "." counter(lst-ctn-kix_list_1-1,decimal) "." counter(lst-ctn-kix_list_1-2,decimal) ". ";
            }
            .lst-kix_list_1-0>li{
                counter-increment:lst-ctn-kix_list_1-0;
            }
            ol.lst-kix_list_16-1.start{
                counter-reset:lst-ctn-kix_list_16-1 0;
            }
            li.li-bullet-0:before{
                margin-left:-18pt;
                white-space:nowrap;
                display:inline-block;
                min-width:18pt;
            }
            .lst-kix_list_18-7>li{
                counter-increment:lst-ctn-kix_list_18-7;
            }
            ol.lst-kix_list_11-4.start{
                counter-reset:lst-ctn-kix_list_11-4 0;
            }
            .lst-kix_list_14-1>li:before{
                content:"" counter(lst-ctn-kix_list_14-0,decimal) "." counter(lst-ctn-kix_list_14-1,decimal) ". ";
            }
            .lst-kix_list_14-3>li:before{
                content:"" counter(lst-ctn-kix_list_14-0,decimal) "." counter(lst-ctn-kix_list_14-1,decimal) "." counter(lst-ctn-kix_list_14-2,decimal) "." counter(lst-ctn-kix_list_14-3,decimal) ". ";
            }
            ol.lst-kix_list_15-6{
                list-style-type:none;
            }
            ol.lst-kix_list_15-7{
                list-style-type:none;
            }
            ol.lst-kix_list_15-8{
                list-style-type:none;
            }
            .lst-kix_list_14-0>li:before{
                content:"" counter(lst-ctn-kix_list_14-0,decimal) ". ";
            }
            .lst-kix_list_14-4>li:before{
                content:"" counter(lst-ctn-kix_list_14-0,decimal) "." counter(lst-ctn-kix_list_14-1,decimal) "." counter(lst-ctn-kix_list_14-2,decimal) "." counter(lst-ctn-kix_list_14-3,decimal) "." counter(lst-ctn-kix_list_14-4,decimal) ". ";
            }
            ol.lst-kix_list_15-2{
                list-style-type:none;
            }
            ol.lst-kix_list_15-3{
                list-style-type:none;
            }
            ol.lst-kix_list_15-4{
                list-style-type:none;
            }
            ol.lst-kix_list_18-5.start{
                counter-reset:lst-ctn-kix_list_18-5 0;
            }
            .lst-kix_list_6-1>li{
                counter-increment:lst-ctn-kix_list_6-1;
            }
            .lst-kix_list_14-5>li:before{
                content:"" counter(lst-ctn-kix_list_14-0,decimal) "." counter(lst-ctn-kix_list_14-1,decimal) "." counter(lst-ctn-kix_list_14-2,decimal) "." counter(lst-ctn-kix_list_14-3,decimal) "." counter(lst-ctn-kix_list_14-4,decimal) "." counter(lst-ctn-kix_list_14-5,decimal) ". ";
            }
            .lst-kix_list_14-7>li:before{
                content:"" counter(lst-ctn-kix_list_14-0,decimal) "." counter(lst-ctn-kix_list_14-1,decimal) "." counter(lst-ctn-kix_list_14-2,decimal) "." counter(lst-ctn-kix_list_14-3,decimal) "." counter(lst-ctn-kix_list_14-4,decimal) "." counter(lst-ctn-kix_list_14-5,decimal) "." counter(lst-ctn-kix_list_14-6,decimal) "." counter(lst-ctn-kix_list_14-7,decimal) ". ";
            }
            ol.lst-kix_list_15-5{
                list-style-type:none;
            }
            ol.lst-kix_list_15-0{
                list-style-type:none;
            }
            .lst-kix_list_14-6>li:before{
                content:"" counter(lst-ctn-kix_list_14-0,decimal) "." counter(lst-ctn-kix_list_14-1,decimal) "." counter(lst-ctn-kix_list_14-2,decimal) "." counter(lst-ctn-kix_list_14-3,decimal) "." counter(lst-ctn-kix_list_14-4,decimal) "." counter(lst-ctn-kix_list_14-5,decimal) "." counter(lst-ctn-kix_list_14-6,decimal) ". ";
            }
            ol.lst-kix_list_15-1{
                list-style-type:none;
            }
            ol.lst-kix_list_7-4.start{
                counter-reset:lst-ctn-kix_list_7-4 0;
            }
            .lst-kix_list_17-0>li{
                counter-increment:lst-ctn-kix_list_17-0;
            }
            .lst-kix_list_9-0>li{
                counter-increment:lst-ctn-kix_list_9-0;
            }
            ol.lst-kix_list_11-8.start{
                counter-reset:lst-ctn-kix_list_11-8 0;
            }
            .lst-kix_list_14-2>li:before{
                content:"" counter(lst-ctn-kix_list_14-0,decimal) "." counter(lst-ctn-kix_list_14-1,decimal) "." counter(lst-ctn-kix_list_14-2,decimal) ". ";
            }
            .lst-kix_list_20-7>li{
                counter-increment:lst-ctn-kix_list_20-7;
            }
            ol.lst-kix_list_12-0.start{
                counter-reset:lst-ctn-kix_list_12-0 1;
            }
            ol.lst-kix_list_21-6.start{
                counter-reset:lst-ctn-kix_list_21-6 0;
            }
            ol.lst-kix_list_3-7.start{
                counter-reset:lst-ctn-kix_list_3-7 0;
            }
            .lst-kix_list_14-8>li:before{
                content:"" counter(lst-ctn-kix_list_14-0,decimal) "." counter(lst-ctn-kix_list_14-1,decimal) "." counter(lst-ctn-kix_list_14-2,decimal) "." counter(lst-ctn-kix_list_14-3,decimal) "." counter(lst-ctn-kix_list_14-4,decimal) "." counter(lst-ctn-kix_list_14-5,decimal) "." counter(lst-ctn-kix_list_14-6,decimal) "." counter(lst-ctn-kix_list_14-7,decimal) "." counter(lst-ctn-kix_list_14-8,decimal) ". ";
            }
            .lst-kix_list_3-2>li{
                counter-increment:lst-ctn-kix_list_3-2;
            }
            ol.lst-kix_list_15-5.start{
                counter-reset:lst-ctn-kix_list_15-5 0;
            }
            .lst-kix_list_5-0>li:before{
                content:"" counter(lst-ctn-kix_list_5-0,decimal) ". ";
            }
            ol.lst-kix_list_6-0{
                list-style-type:none;
            }
            ol.lst-kix_list_6-1{
                list-style-type:none;
            }
            ol.lst-kix_list_22-3.start{
                counter-reset:lst-ctn-kix_list_22-3 0;
            }
            .lst-kix_list_14-8>li{
                counter-increment:lst-ctn-kix_list_14-8;
            }
            .lst-kix_list_5-4>li{
                counter-increment:lst-ctn-kix_list_5-4;
            }
            .lst-kix_list_5-3>li:before{
                content:"" counter(lst-ctn-kix_list_5-0,decimal) "." counter(lst-ctn-kix_list_5-1,decimal) "." counter(lst-ctn-kix_list_5-2,decimal) "." counter(lst-ctn-kix_list_5-3,decimal) ". ";
            }
            .lst-kix_list_5-2>li:before{
                content:"" counter(lst-ctn-kix_list_5-0,decimal) "." counter(lst-ctn-kix_list_5-1,decimal) "." counter(lst-ctn-kix_list_5-2,decimal) ". ";
            }
            .lst-kix_list_8-3>li{
                counter-increment:lst-ctn-kix_list_8-3;
            }
            .lst-kix_list_5-1>li:before{
                content:"" counter(lst-ctn-kix_list_5-0,decimal) "." counter(lst-ctn-kix_list_5-1,decimal) ". ";
            }
            ol.lst-kix_list_18-0.start{
                counter-reset:lst-ctn-kix_list_18-0 10;
            }
            .lst-kix_list_5-7>li:before{
                content:"" counter(lst-ctn-kix_list_5-0,decimal) "." counter(lst-ctn-kix_list_5-1,decimal) "." counter(lst-ctn-kix_list_5-2,decimal) "." counter(lst-ctn-kix_list_5-3,decimal) "." counter(lst-ctn-kix_list_5-4,decimal) "." counter(lst-ctn-kix_list_5-5,decimal) "." counter(lst-ctn-kix_list_5-6,decimal) "." counter(lst-ctn-kix_list_5-7,decimal) ". ";
            }
            .lst-kix_list_5-6>li:before{
                content:"" counter(lst-ctn-kix_list_5-0,decimal) "." counter(lst-ctn-kix_list_5-1,decimal) "." counter(lst-ctn-kix_list_5-2,decimal) "." counter(lst-ctn-kix_list_5-3,decimal) "." counter(lst-ctn-kix_list_5-4,decimal) "." counter(lst-ctn-kix_list_5-5,decimal) "." counter(lst-ctn-kix_list_5-6,decimal) ". ";
            }
            .lst-kix_list_5-8>li:before{
                content:"" counter(lst-ctn-kix_list_5-0,decimal) "." counter(lst-ctn-kix_list_5-1,decimal) "." counter(lst-ctn-kix_list_5-2,decimal) "." counter(lst-ctn-kix_list_5-3,decimal) "." counter(lst-ctn-kix_list_5-4,decimal) "." counter(lst-ctn-kix_list_5-5,decimal) "." counter(lst-ctn-kix_list_5-6,decimal) "." counter(lst-ctn-kix_list_5-7,decimal) "." counter(lst-ctn-kix_list_5-8,decimal) ". ";
            }
            ol.lst-kix_list_6-6{
                list-style-type:none;
            }
            ol.lst-kix_list_6-7{
                list-style-type:none;
            }
            .lst-kix_list_5-4>li:before{
                content:"" counter(lst-ctn-kix_list_5-0,decimal) "." counter(lst-ctn-kix_list_5-1,decimal) "." counter(lst-ctn-kix_list_5-2,decimal) "." counter(lst-ctn-kix_list_5-3,decimal) "." counter(lst-ctn-kix_list_5-4,decimal) ". ";
            }
            ol.lst-kix_list_6-8{
                list-style-type:none;
            }
            .lst-kix_list_5-5>li:before{
                content:"" counter(lst-ctn-kix_list_5-0,decimal) "." counter(lst-ctn-kix_list_5-1,decimal) "." counter(lst-ctn-kix_list_5-2,decimal) "." counter(lst-ctn-kix_list_5-3,decimal) "." counter(lst-ctn-kix_list_5-4,decimal) "." counter(lst-ctn-kix_list_5-5,decimal) ". ";
            }
            ol.lst-kix_list_6-2{
                list-style-type:none;
            }
            ol.lst-kix_list_6-3{
                list-style-type:none;
            }
            ol.lst-kix_list_6-4{
                list-style-type:none;
            }
            ol.lst-kix_list_6-5{
                list-style-type:none;
            }
            li.li-bullet-36:before{
                margin-left:-25.4pt;
                white-space:nowrap;
                display:inline-block;
                min-width:25.4pt;
            }
            ol.lst-kix_list_12-5.start{
                counter-reset:lst-ctn-kix_list_12-5 0;
            }
            .lst-kix_list_6-1>li:before{
                content:"" counter(lst-ctn-kix_list_6-0,decimal) "." counter(lst-ctn-kix_list_6-1,decimal) ". ";
            }
            .lst-kix_list_6-3>li:before{
                content:"" counter(lst-ctn-kix_list_6-0,decimal) "." counter(lst-ctn-kix_list_6-1,decimal) "." counter(lst-ctn-kix_list_6-2,decimal) "." counter(lst-ctn-kix_list_6-3,decimal) ". ";
            }
            .lst-kix_list_6-8>li{
                counter-increment:lst-ctn-kix_list_6-8;
            }
            .lst-kix_list_6-0>li:before{
                content:"" counter(lst-ctn-kix_list_6-0,decimal) ". ";
            }
            .lst-kix_list_6-4>li:before{
                content:"" counter(lst-ctn-kix_list_6-0,decimal) "." counter(lst-ctn-kix_list_6-1,decimal) "." counter(lst-ctn-kix_list_6-2,decimal) "." counter(lst-ctn-kix_list_6-3,decimal) "." counter(lst-ctn-kix_list_6-4,decimal) ". ";
            }
            ol.lst-kix_list_14-8.start{
                counter-reset:lst-ctn-kix_list_14-8 0;
            }
            li.li-bullet-25:before{
                margin-left:-32.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:32.5pt;
            }
            .lst-kix_list_6-2>li:before{
                content:"" counter(lst-ctn-kix_list_6-0,decimal) "." counter(lst-ctn-kix_list_6-1,decimal) "." counter(lst-ctn-kix_list_6-2,decimal) ". ";
            }
            ol.lst-kix_list_15-0.start{
                counter-reset:lst-ctn-kix_list_15-0 1;
            }
            .lst-kix_list_2-5>li{
                counter-increment:lst-ctn-kix_list_2-5;
            }
            ol.lst-kix_list_3-2.start{
                counter-reset:lst-ctn-kix_list_3-2 0;
            }
            .lst-kix_list_6-8>li:before{
                content:"" counter(lst-ctn-kix_list_6-0,decimal) "." counter(lst-ctn-kix_list_6-1,decimal) "." counter(lst-ctn-kix_list_6-2,decimal) "." counter(lst-ctn-kix_list_6-3,decimal) "." counter(lst-ctn-kix_list_6-4,decimal) "." counter(lst-ctn-kix_list_6-5,decimal) "." counter(lst-ctn-kix_list_6-6,decimal) "." counter(lst-ctn-kix_list_6-7,decimal) "." counter(lst-ctn-kix_list_6-8,decimal) ". ";
            }
            li.li-bullet-47:before{
                margin-left:-30.2pt;
                white-space:nowrap;
                display:inline-block;
                min-width:30.2pt;
            }
            .lst-kix_list_6-5>li:before{
                content:"" counter(lst-ctn-kix_list_6-0,decimal) "." counter(lst-ctn-kix_list_6-1,decimal) "." counter(lst-ctn-kix_list_6-2,decimal) "." counter(lst-ctn-kix_list_6-3,decimal) "." counter(lst-ctn-kix_list_6-4,decimal) "." counter(lst-ctn-kix_list_6-5,decimal) ". ";
            }
            .lst-kix_list_6-7>li:before{
                content:"" counter(lst-ctn-kix_list_6-0,decimal) "." counter(lst-ctn-kix_list_6-1,decimal) "." counter(lst-ctn-kix_list_6-2,decimal) "." counter(lst-ctn-kix_list_6-3,decimal) "." counter(lst-ctn-kix_list_6-4,decimal) "." counter(lst-ctn-kix_list_6-5,decimal) "." counter(lst-ctn-kix_list_6-6,decimal) "." counter(lst-ctn-kix_list_6-7,decimal) ". ";
            }
            li.li-bullet-50:before{
                margin-left:-30.2pt;
                white-space:nowrap;
                display:inline-block;
                min-width:30.2pt;
            }
            li.li-bullet-58:before{
                margin-left:-32.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:32.5pt;
            }
            .lst-kix_list_6-6>li:before{
                content:"" counter(lst-ctn-kix_list_6-0,decimal) "." counter(lst-ctn-kix_list_6-1,decimal) "." counter(lst-ctn-kix_list_6-2,decimal) "." counter(lst-ctn-kix_list_6-3,decimal) "." counter(lst-ctn-kix_list_6-4,decimal) "." counter(lst-ctn-kix_list_6-5,decimal) "." counter(lst-ctn-kix_list_6-6,decimal) ". ";
            }
            ol.lst-kix_list_17-8{
                list-style-type:none;
            }
            ol.lst-kix_list_10-6.start{
                counter-reset:lst-ctn-kix_list_10-6 0;
            }
            .lst-kix_list_7-4>li:before{
                content:"" counter(lst-ctn-kix_list_7-0,decimal) "." counter(lst-ctn-kix_list_7-1,decimal) "." counter(lst-ctn-kix_list_7-2,decimal) "." counter(lst-ctn-kix_list_7-3,decimal) "." counter(lst-ctn-kix_list_7-4,decimal) ". ";
            }
            .lst-kix_list_7-6>li:before{
                content:"" counter(lst-ctn-kix_list_7-0,decimal) "." counter(lst-ctn-kix_list_7-1,decimal) "." counter(lst-ctn-kix_list_7-2,decimal) "." counter(lst-ctn-kix_list_7-3,decimal) "." counter(lst-ctn-kix_list_7-4,decimal) "." counter(lst-ctn-kix_list_7-5,decimal) "." counter(lst-ctn-kix_list_7-6,decimal) ". ";
            }
            ol.lst-kix_list_17-4{
                list-style-type:none;
            }
            .lst-kix_list_18-5>li{
                counter-increment:lst-ctn-kix_list_18-5;
            }
            ol.lst-kix_list_19-7.start{
                counter-reset:lst-ctn-kix_list_19-7 0;
            }
            ol.lst-kix_list_17-5{
                list-style-type:none;
            }
            ol.lst-kix_list_6-2.start{
                counter-reset:lst-ctn-kix_list_6-2 0;
            }
            .lst-kix_list_15-5>li{
                counter-increment:lst-ctn-kix_list_15-5;
            }
            ol.lst-kix_list_17-6{
                list-style-type:none;
            }
            ol.lst-kix_list_17-7{
                list-style-type:none;
            }
            ol.lst-kix_list_17-0{
                list-style-type:none;
            }
            .lst-kix_list_22-2>li{
                counter-increment:lst-ctn-kix_list_22-2;
            }
            ol.lst-kix_list_17-1{
                list-style-type:none;
            }
            ol.lst-kix_list_17-2{
                list-style-type:none;
            }
            .lst-kix_list_7-2>li:before{
                content:"" counter(lst-ctn-kix_list_7-0,decimal) "." counter(lst-ctn-kix_list_7-1,decimal) "." counter(lst-ctn-kix_list_7-2,decimal) ". ";
            }
            ol.lst-kix_list_17-3{
                list-style-type:none;
            }
            .lst-kix_list_7-6>li{
                counter-increment:lst-ctn-kix_list_7-6;
            }
            ol.lst-kix_list_22-8.start{
                counter-reset:lst-ctn-kix_list_22-8 0;
            }
            .lst-kix_list_12-6>li{
                counter-increment:lst-ctn-kix_list_12-6;
            }
            .lst-kix_list_13-7>li:before{
                content:"" counter(lst-ctn-kix_list_13-0,decimal) "." counter(lst-ctn-kix_list_13-1,decimal) "." counter(lst-ctn-kix_list_13-2,decimal) "." counter(lst-ctn-kix_list_13-3,decimal) "." counter(lst-ctn-kix_list_13-4,decimal) "." counter(lst-ctn-kix_list_13-5,decimal) "." counter(lst-ctn-kix_list_13-6,decimal) "." counter(lst-ctn-kix_list_13-7,decimal) ". ";
            }
            .lst-kix_list_7-8>li:before{
                content:"" counter(lst-ctn-kix_list_7-0,decimal) "." counter(lst-ctn-kix_list_7-1,decimal) "." counter(lst-ctn-kix_list_7-2,decimal) "." counter(lst-ctn-kix_list_7-3,decimal) "." counter(lst-ctn-kix_list_7-4,decimal) "." counter(lst-ctn-kix_list_7-5,decimal) "." counter(lst-ctn-kix_list_7-6,decimal) "." counter(lst-ctn-kix_list_7-7,decimal) "." counter(lst-ctn-kix_list_7-8,decimal) ". ";
            }
            .lst-kix_list_15-6>li{
                counter-increment:lst-ctn-kix_list_15-6;
            }
            ol.lst-kix_list_2-5.start{
                counter-reset:lst-ctn-kix_list_2-5 0;
            }
            .lst-kix_list_15-5>li:before{
                content:"" counter(lst-ctn-kix_list_15-0,decimal) "." counter(lst-ctn-kix_list_15-1,decimal) "." counter(lst-ctn-kix_list_15-2,decimal) "." counter(lst-ctn-kix_list_15-3,decimal) "." counter(lst-ctn-kix_list_15-4,decimal) "." counter(lst-ctn-kix_list_15-5,decimal) ". ";
            }
            .lst-kix_list_9-8>li{
                counter-increment:lst-ctn-kix_list_9-8;
            }
            .lst-kix_list_13-4>li{
                counter-increment:lst-ctn-kix_list_13-4;
            }
            .lst-kix_list_4-1>li:before{
                content:"\0025cf   ";
            }
            .lst-kix_list_15-7>li:before{
                content:"" counter(lst-ctn-kix_list_15-0,decimal) "." counter(lst-ctn-kix_list_15-1,decimal) "." counter(lst-ctn-kix_list_15-2,decimal) "." counter(lst-ctn-kix_list_15-3,decimal) "." counter(lst-ctn-kix_list_15-4,decimal) "." counter(lst-ctn-kix_list_15-5,decimal) "." counter(lst-ctn-kix_list_15-6,decimal) "." counter(lst-ctn-kix_list_15-7,decimal) ". ";
            }
            .lst-kix_list_17-7>li{
                counter-increment:lst-ctn-kix_list_17-7;
            }
            .lst-kix_list_4-3>li:before{
                content:"\0025cf   ";
            }
            .lst-kix_list_4-5>li:before{
                content:"\0025cf   ";
            }
            .lst-kix_list_1-8>li{
                counter-increment:lst-ctn-kix_list_1-8;
            }
            .lst-kix_list_10-5>li{
                counter-increment:lst-ctn-kix_list_10-5;
            }
            .lst-kix_list_15-1>li:before{
                content:"" counter(lst-ctn-kix_list_15-0,decimal) "." counter(lst-ctn-kix_list_15-1,decimal) ". ";
            }
            ol.lst-kix_list_1-4.start{
                counter-reset:lst-ctn-kix_list_1-4 0;
            }
            li.li-bullet-66:before{
                margin-left:-36pt;
                white-space:nowrap;
                display:inline-block;
                min-width:36pt;
            }
            .lst-kix_list_15-3>li:before{
                content:"" counter(lst-ctn-kix_list_15-0,decimal) "." counter(lst-ctn-kix_list_15-1,decimal) "." counter(lst-ctn-kix_list_15-2,decimal) "." counter(lst-ctn-kix_list_15-3,decimal) ". ";
            }
            .lst-kix_list_22-1>li{
                counter-increment:lst-ctn-kix_list_22-1;
            }
            li.li-bullet-55:before{
                margin-left:-42.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:42.5pt;
            }
            .lst-kix_list_16-2>li{
                counter-increment:lst-ctn-kix_list_16-2;
            }
            ol.lst-kix_list_9-2.start{
                counter-reset:lst-ctn-kix_list_9-2 0;
            }
            .lst-kix_list_20-0>li{
                counter-increment:lst-ctn-kix_list_20-0;
            }
            ol.lst-kix_list_16-7.start{
                counter-reset:lst-ctn-kix_list_16-7 0;
            }
            .lst-kix_list_11-2>li{
                counter-increment:lst-ctn-kix_list_11-2;
            }
            .lst-kix_list_19-2>li{
                counter-increment:lst-ctn-kix_list_19-2;
            }
            ol.lst-kix_list_8-8{
                list-style-type:none;
            }
            .lst-kix_list_12-3>li:before{
                content:"" counter(lst-ctn-kix_list_12-0,decimal) "." counter(lst-ctn-kix_list_12-1,decimal) "." counter(lst-ctn-kix_list_12-2,decimal) "." counter(lst-ctn-kix_list_12-3,decimal) ". ";
            }
            ol.lst-kix_list_8-4{
                list-style-type:none;
            }
            .lst-kix_list_12-1>li:before{
                content:"" counter(lst-ctn-kix_list_12-0,decimal) "." counter(lst-ctn-kix_list_12-1,decimal) ". ";
            }
            ol.lst-kix_list_8-5{
                list-style-type:none;
            }
            ol.lst-kix_list_8-6{
                list-style-type:none;
            }
            ol.lst-kix_list_8-7{
                list-style-type:none;
            }
            ol.lst-kix_list_8-0{
                list-style-type:none;
            }
            .lst-kix_list_16-3>li{
                counter-increment:lst-ctn-kix_list_16-3;
            }
            ol.lst-kix_list_8-1{
                list-style-type:none;
            }
            ol.lst-kix_list_8-2{
                list-style-type:none;
            }
            .lst-kix_list_13-3>li{
                counter-increment:lst-ctn-kix_list_13-3;
            }
            ol.lst-kix_list_13-6.start{
                counter-reset:lst-ctn-kix_list_13-6 0;
            }
            ol.lst-kix_list_8-3{
                list-style-type:none;
            }
            .lst-kix_list_10-4>li{
                counter-increment:lst-ctn-kix_list_10-4;
            }
            .lst-kix_list_14-1>li{
                counter-increment:lst-ctn-kix_list_14-1;
            }
            .lst-kix_list_21-4>li{
                counter-increment:lst-ctn-kix_list_21-4;
            }
            .lst-kix_list_13-3>li:before{
                content:"" counter(lst-ctn-kix_list_13-0,decimal) "." counter(lst-ctn-kix_list_13-1,decimal) "." counter(lst-ctn-kix_list_13-2,decimal) "." counter(lst-ctn-kix_list_13-3,decimal) ". ";
            }
            li.li-bullet-4:before{
                margin-left:-21.6pt;
                white-space:nowrap;
                display:inline-block;
                min-width:21.6pt;
            }
            .lst-kix_list_13-5>li:before{
                content:"" counter(lst-ctn-kix_list_13-0,decimal) "." counter(lst-ctn-kix_list_13-1,decimal) "." counter(lst-ctn-kix_list_13-2,decimal) "." counter(lst-ctn-kix_list_13-3,decimal) "." counter(lst-ctn-kix_list_13-4,decimal) "." counter(lst-ctn-kix_list_13-5,decimal) ". ";
            }
            .lst-kix_list_12-5>li:before{
                content:"" counter(lst-ctn-kix_list_12-0,decimal) "." counter(lst-ctn-kix_list_12-1,decimal) "." counter(lst-ctn-kix_list_12-2,decimal) "." counter(lst-ctn-kix_list_12-3,decimal) "." counter(lst-ctn-kix_list_12-4,decimal) "." counter(lst-ctn-kix_list_12-5,decimal) ". ";
            }
            ol.lst-kix_list_13-7.start{
                counter-reset:lst-ctn-kix_list_13-7 0;
            }
            .lst-kix_list_18-4>li{
                counter-increment:lst-ctn-kix_list_18-4;
            }
            .lst-kix_list_12-7>li:before{
                content:"" counter(lst-ctn-kix_list_12-0,decimal) "." counter(lst-ctn-kix_list_12-1,decimal) "." counter(lst-ctn-kix_list_12-2,decimal) "." counter(lst-ctn-kix_list_12-3,decimal) "." counter(lst-ctn-kix_list_12-4,decimal) "." counter(lst-ctn-kix_list_12-5,decimal) "." counter(lst-ctn-kix_list_12-6,decimal) "." counter(lst-ctn-kix_list_12-7,decimal) ". ";
            }
            ol.lst-kix_list_21-1.start{
                counter-reset:lst-ctn-kix_list_21-1 0;
            }
            .lst-kix_list_13-1>li:before{
                content:"" counter(lst-ctn-kix_list_13-0,decimal) "." counter(lst-ctn-kix_list_13-1,decimal) ". ";
            }
            .lst-kix_list_22-8>li{
                counter-increment:lst-ctn-kix_list_22-8;
            }
            ol.lst-kix_list_11-6{
                list-style-type:none;
            }
            ol.lst-kix_list_11-7{
                list-style-type:none;
            }
            ol.lst-kix_list_11-8{
                list-style-type:none;
            }
            .lst-kix_list_1-1>li{
                counter-increment:lst-ctn-kix_list_1-1;
            }
            ol.lst-kix_list_11-2{
                list-style-type:none;
            }
            ol.lst-kix_list_11-3{
                list-style-type:none;
            }
            ol.lst-kix_list_2-6.start{
                counter-reset:lst-ctn-kix_list_2-6 0;
            }
            .lst-kix_list_3-0>li:before{
                content:"" counter(lst-ctn-kix_list_3-0,decimal) " ";
            }
            ol.lst-kix_list_11-4{
                list-style-type:none;
            }
            ol.lst-kix_list_20-5.start{
                counter-reset:lst-ctn-kix_list_20-5 0;
            }
            ol.lst-kix_list_11-5{
                list-style-type:none;
            }
            ol.lst-kix_list_13-1.start{
                counter-reset:lst-ctn-kix_list_13-1 0;
            }
            ol.lst-kix_list_11-0{
                list-style-type:none;
            }
            ol.lst-kix_list_11-1{
                list-style-type:none;
            }
            .lst-kix_list_3-4>li:before{
                content:"" counter(lst-ctn-kix_list_3-0,decimal) "." counter(lst-ctn-kix_list_3-1,decimal) "." counter(lst-ctn-kix_list_3-2,decimal) "." counter(lst-ctn-kix_list_3-3,decimal) "." counter(lst-ctn-kix_list_3-4,decimal) " ";
            }
            .lst-kix_list_3-3>li:before{
                content:"" counter(lst-ctn-kix_list_3-0,decimal) "." counter(lst-ctn-kix_list_3-1,decimal) "." counter(lst-ctn-kix_list_3-2,decimal) "." counter(lst-ctn-kix_list_3-3,decimal) " ";
            }
            .lst-kix_list_8-0>li:before{
                content:"" counter(lst-ctn-kix_list_8-0,decimal) ". ";
            }
            .lst-kix_list_8-7>li:before{
                content:"" counter(lst-ctn-kix_list_8-0,decimal) "." counter(lst-ctn-kix_list_8-1,decimal) "." counter(lst-ctn-kix_list_8-2,decimal) "." counter(lst-ctn-kix_list_8-3,decimal) "." counter(lst-ctn-kix_list_8-4,decimal) "." counter(lst-ctn-kix_list_8-5,decimal) "." counter(lst-ctn-kix_list_8-6,decimal) "." counter(lst-ctn-kix_list_8-7,decimal) ". ";
            }
            li.li-bullet-44:before{
                margin-left:-35.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:35.5pt;
            }
            .lst-kix_list_3-8>li:before{
                content:"" counter(lst-ctn-kix_list_3-0,decimal) "." counter(lst-ctn-kix_list_3-1,decimal) "." counter(lst-ctn-kix_list_3-2,decimal) "." counter(lst-ctn-kix_list_3-3,decimal) "." counter(lst-ctn-kix_list_3-4,decimal) "." counter(lst-ctn-kix_list_3-5,decimal) "." counter(lst-ctn-kix_list_3-6,decimal) "." counter(lst-ctn-kix_list_3-7,decimal) "." counter(lst-ctn-kix_list_3-8,decimal) " ";
            }
            ol.lst-kix_list_10-7.start{
                counter-reset:lst-ctn-kix_list_10-7 0;
            }
            ol.lst-kix_list_22-7{
                list-style-type:none;
            }
            .lst-kix_list_8-3>li:before{
                content:"" counter(lst-ctn-kix_list_8-0,decimal) "." counter(lst-ctn-kix_list_8-1,decimal) "." counter(lst-ctn-kix_list_8-2,decimal) "." counter(lst-ctn-kix_list_8-3,decimal) ". ";
            }
            li.li-bullet-39:before{
                margin-left:-35.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:35.5pt;
            }
            ol.lst-kix_list_22-6{
                list-style-type:none;
            }
            li.li-bullet-33:before{
                margin-left:-25.4pt;
                white-space:nowrap;
                display:inline-block;
                min-width:25.4pt;
            }
            ol.lst-kix_list_22-8{
                list-style-type:none;
            }
            ol.lst-kix_list_22-3{
                list-style-type:none;
            }
            .lst-kix_list_3-7>li:before{
                content:"" counter(lst-ctn-kix_list_3-0,decimal) "." counter(lst-ctn-kix_list_3-1,decimal) "." counter(lst-ctn-kix_list_3-2,decimal) "." counter(lst-ctn-kix_list_3-3,decimal) "." counter(lst-ctn-kix_list_3-4,decimal) "." counter(lst-ctn-kix_list_3-5,decimal) "." counter(lst-ctn-kix_list_3-6,decimal) "." counter(lst-ctn-kix_list_3-7,decimal) " ";
            }
            ol.lst-kix_list_22-2{
                list-style-type:none;
            }
            ol.lst-kix_list_22-5{
                list-style-type:none;
            }
            .lst-kix_list_8-4>li:before{
                content:"" counter(lst-ctn-kix_list_8-0,decimal) "." counter(lst-ctn-kix_list_8-1,decimal) "." counter(lst-ctn-kix_list_8-2,decimal) "." counter(lst-ctn-kix_list_8-3,decimal) "." counter(lst-ctn-kix_list_8-4,decimal) ". ";
            }
            ol.lst-kix_list_22-4{
                list-style-type:none;
            }
            .lst-kix_list_19-1>li{
                counter-increment:lst-ctn-kix_list_19-1;
            }
            ol.lst-kix_list_22-1{
                list-style-type:none;
            }
            ol.lst-kix_list_22-0{
                list-style-type:none;
            }
            ol.lst-kix_list_8-5.start{
                counter-reset:lst-ctn-kix_list_8-5 0;
            }
            .lst-kix_list_17-1>li{
                counter-increment:lst-ctn-kix_list_17-1;
            }
            .lst-kix_list_11-1>li:before{
                content:"" counter(lst-ctn-kix_list_11-1,lower-latin) ". ";
            }
            .lst-kix_list_11-0>li:before{
                content:"" counter(lst-ctn-kix_list_11-0,decimal) ". ";
            }
            ol.lst-kix_list_9-3.start{
                counter-reset:lst-ctn-kix_list_9-3 0;
            }
            .lst-kix_list_8-8>li:before{
                content:"" counter(lst-ctn-kix_list_8-0,decimal) "." counter(lst-ctn-kix_list_8-1,decimal) "." counter(lst-ctn-kix_list_8-2,decimal) "." counter(lst-ctn-kix_list_8-3,decimal) "." counter(lst-ctn-kix_list_8-4,decimal) "." counter(lst-ctn-kix_list_8-5,decimal) "." counter(lst-ctn-kix_list_8-6,decimal) "." counter(lst-ctn-kix_list_8-7,decimal) "." counter(lst-ctn-kix_list_8-8,decimal) ". ";
            }
            ol.lst-kix_list_2-2{
                list-style-type:none;
            }
            .lst-kix_list_16-8>li:before{
                content:"" counter(lst-ctn-kix_list_16-0,decimal) "." counter(lst-ctn-kix_list_16-1,decimal) "." counter(lst-ctn-kix_list_16-2,decimal) "." counter(lst-ctn-kix_list_16-3,decimal) "." counter(lst-ctn-kix_list_16-4,decimal) "." counter(lst-ctn-kix_list_16-5,decimal) "." counter(lst-ctn-kix_list_16-6,decimal) "." counter(lst-ctn-kix_list_16-7,decimal) "." counter(lst-ctn-kix_list_16-8,decimal) ". ";
            }
            ol.lst-kix_list_2-3{
                list-style-type:none;
            }
            ol.lst-kix_list_2-4{
                list-style-type:none;
            }
            .lst-kix_list_16-7>li:before{
                content:"" counter(lst-ctn-kix_list_16-0,decimal) "." counter(lst-ctn-kix_list_16-1,decimal) "." counter(lst-ctn-kix_list_16-2,decimal) "." counter(lst-ctn-kix_list_16-3,decimal) "." counter(lst-ctn-kix_list_16-4,decimal) "." counter(lst-ctn-kix_list_16-5,decimal) "." counter(lst-ctn-kix_list_16-6,decimal) "." counter(lst-ctn-kix_list_16-7,decimal) ". ";
            }
            ol.lst-kix_list_2-5{
                list-style-type:none;
            }
            .lst-kix_list_17-8>li{
                counter-increment:lst-ctn-kix_list_17-8;
            }
            ol.lst-kix_list_2-0{
                list-style-type:none;
            }
            ol.lst-kix_list_2-1{
                list-style-type:none;
            }
            .lst-kix_list_4-8>li:before{
                content:"\0025cf   ";
            }
            .lst-kix_list_21-5>li{
                counter-increment:lst-ctn-kix_list_21-5;
            }
            .lst-kix_list_4-7>li:before{
                content:"\0025cf   ";
            }
            ol.lst-kix_list_20-0.start{
                counter-reset:lst-ctn-kix_list_20-0 10;
            }
            .lst-kix_list_14-2>li{
                counter-increment:lst-ctn-kix_list_14-2;
            }
            .lst-kix_list_17-0>li:before{
                content:"" counter(lst-ctn-kix_list_17-0,decimal) ". ";
            }
            li.li-bullet-7:before{
                margin-left:-25.2pt;
                white-space:nowrap;
                display:inline-block;
                min-width:25.2pt;
            }
            ul.lst-kix_list_4-8{
                list-style-type:none;
            }
            .lst-kix_list_16-0>li:before{
                content:"" counter(lst-ctn-kix_list_16-0,decimal) ". ";
            }
            ul.lst-kix_list_4-6{
                list-style-type:none;
            }
            ul.lst-kix_list_4-7{
                list-style-type:none;
            }
            .lst-kix_list_8-4>li{
                counter-increment:lst-ctn-kix_list_8-4;
            }
            ul.lst-kix_list_4-0{
                list-style-type:none;
            }
            .lst-kix_list_16-4>li:before{
                content:"" counter(lst-ctn-kix_list_16-0,decimal) "." counter(lst-ctn-kix_list_16-1,decimal) "." counter(lst-ctn-kix_list_16-2,decimal) "." counter(lst-ctn-kix_list_16-3,decimal) "." counter(lst-ctn-kix_list_16-4,decimal) ". ";
            }
            ul.lst-kix_list_4-1{
                list-style-type:none;
            }
            ol.lst-kix_list_3-3.start{
                counter-reset:lst-ctn-kix_list_3-3 0;
            }
            .lst-kix_list_16-3>li:before{
                content:"" counter(lst-ctn-kix_list_16-0,decimal) "." counter(lst-ctn-kix_list_16-1,decimal) "." counter(lst-ctn-kix_list_16-2,decimal) "." counter(lst-ctn-kix_list_16-3,decimal) ". ";
            }
            ul.lst-kix_list_4-4{
                list-style-type:none;
            }
            ol.lst-kix_list_2-6{
                list-style-type:none;
            }
            ul.lst-kix_list_4-5{
                list-style-type:none;
            }
            ol.lst-kix_list_2-7{
                list-style-type:none;
            }
            ul.lst-kix_list_4-2{
                list-style-type:none;
            }
            ol.lst-kix_list_2-8{
                list-style-type:none;
            }
            ul.lst-kix_list_4-3{
                list-style-type:none;
            }
            .lst-kix_list_11-3>li{
                counter-increment:lst-ctn-kix_list_11-3;
            }
            li.li-bullet-61:before{
                margin-left:-36pt;
                white-space:nowrap;
                display:inline-block;
                min-width:36pt;
            }
            ol.lst-kix_list_18-1.start{
                counter-reset:lst-ctn-kix_list_18-1 0;
            }
            ol.lst-kix_list_8-6.start{
                counter-reset:lst-ctn-kix_list_8-6 0;
            }
            .lst-kix_list_17-7>li:before{
                content:"" counter(lst-ctn-kix_list_17-0,decimal) "." counter(lst-ctn-kix_list_17-1,decimal) "." counter(lst-ctn-kix_list_17-2,decimal) "." counter(lst-ctn-kix_list_17-3,decimal) "." counter(lst-ctn-kix_list_17-4,decimal) "." counter(lst-ctn-kix_list_17-5,decimal) "." counter(lst-ctn-kix_list_17-6,decimal) "." counter(lst-ctn-kix_list_17-7,decimal) ". ";
            }
            .lst-kix_list_17-8>li:before{
                content:"" counter(lst-ctn-kix_list_17-0,decimal) "." counter(lst-ctn-kix_list_17-1,decimal) "." counter(lst-ctn-kix_list_17-2,decimal) "." counter(lst-ctn-kix_list_17-3,decimal) "." counter(lst-ctn-kix_list_17-4,decimal) "." counter(lst-ctn-kix_list_17-5,decimal) "." counter(lst-ctn-kix_list_17-6,decimal) "." counter(lst-ctn-kix_list_17-7,decimal) "." counter(lst-ctn-kix_list_17-8,decimal) ". ";
            }
            .lst-kix_list_17-3>li:before{
                content:"" counter(lst-ctn-kix_list_17-0,decimal) "." counter(lst-ctn-kix_list_17-1,decimal) "." counter(lst-ctn-kix_list_17-2,decimal) "." counter(lst-ctn-kix_list_17-3,decimal) ". ";
            }
            .lst-kix_list_17-4>li:before{
                content:"" counter(lst-ctn-kix_list_17-0,decimal) "." counter(lst-ctn-kix_list_17-1,decimal) "." counter(lst-ctn-kix_list_17-2,decimal) "." counter(lst-ctn-kix_list_17-3,decimal) "." counter(lst-ctn-kix_list_17-4,decimal) ". ";
            }
            ol.lst-kix_list_8-0.start{
                counter-reset:lst-ctn-kix_list_8-0 0;
            }
            .lst-kix_list_7-0>li:before{
                content:"" counter(lst-ctn-kix_list_7-0,decimal) ". ";
            }
            ol.lst-kix_list_19-6.start{
                counter-reset:lst-ctn-kix_list_19-6 0;
            }
            ol.lst-kix_list_9-7.start{
                counter-reset:lst-ctn-kix_list_9-7 0;
            }
            ol.lst-kix_list_13-8{
                list-style-type:none;
            }
            .lst-kix_list_2-4>li:before{
                content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) "." counter(lst-ctn-kix_list_2-3,decimal) "." counter(lst-ctn-kix_list_2-4,decimal) ". ";
            }
            .lst-kix_list_2-8>li:before{
                content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) "." counter(lst-ctn-kix_list_2-3,decimal) "." counter(lst-ctn-kix_list_2-4,decimal) "." counter(lst-ctn-kix_list_2-5,decimal) "." counter(lst-ctn-kix_list_2-6,decimal) "." counter(lst-ctn-kix_list_2-7,decimal) "." counter(lst-ctn-kix_list_2-8,decimal) ". ";
            }
            ol.lst-kix_list_13-4{
                list-style-type:none;
            }
            ol.lst-kix_list_13-5{
                list-style-type:none;
            }
            ol.lst-kix_list_13-6{
                list-style-type:none;
            }
            ol.lst-kix_list_13-7{
                list-style-type:none;
            }
            ol.lst-kix_list_13-0{
                list-style-type:none;
            }
            ol.lst-kix_list_13-1{
                list-style-type:none;
            }
            ol.lst-kix_list_13-2{
                list-style-type:none;
            }
            .lst-kix_list_7-3>li:before{
                content:"" counter(lst-ctn-kix_list_7-0,decimal) "." counter(lst-ctn-kix_list_7-1,decimal) "." counter(lst-ctn-kix_list_7-2,decimal) "." counter(lst-ctn-kix_list_7-3,decimal) ". ";
            }
            ol.lst-kix_list_13-3{
                list-style-type:none;
            }
            .lst-kix_list_10-0>li:before{
                content:"" counter(lst-ctn-kix_list_10-0,decimal) ". ";
            }
            ol.lst-kix_list_21-7.start{
                counter-reset:lst-ctn-kix_list_21-7 0;
            }
            .lst-kix_list_9-7>li{
                counter-increment:lst-ctn-kix_list_9-7;
            }
            .lst-kix_list_13-8>li:before{
                content:"" counter(lst-ctn-kix_list_13-0,decimal) "." counter(lst-ctn-kix_list_13-1,decimal) "." counter(lst-ctn-kix_list_13-2,decimal) "." counter(lst-ctn-kix_list_13-3,decimal) "." counter(lst-ctn-kix_list_13-4,decimal) "." counter(lst-ctn-kix_list_13-5,decimal) "." counter(lst-ctn-kix_list_13-6,decimal) "." counter(lst-ctn-kix_list_13-7,decimal) "." counter(lst-ctn-kix_list_13-8,decimal) ". ";
            }
            .lst-kix_list_18-3>li:before{
                content:"" counter(lst-ctn-kix_list_18-0,decimal) "." counter(lst-ctn-kix_list_18-1,decimal) "." counter(lst-ctn-kix_list_18-2,decimal) "." counter(lst-ctn-kix_list_18-3,decimal) ". ";
            }
            .lst-kix_list_18-7>li:before{
                content:"" counter(lst-ctn-kix_list_18-0,decimal) "." counter(lst-ctn-kix_list_18-1,decimal) "." counter(lst-ctn-kix_list_18-2,decimal) "." counter(lst-ctn-kix_list_18-3,decimal) "." counter(lst-ctn-kix_list_18-4,decimal) "." counter(lst-ctn-kix_list_18-5,decimal) "." counter(lst-ctn-kix_list_18-6,decimal) "." counter(lst-ctn-kix_list_18-7,decimal) ". ";
            }
            .lst-kix_list_18-6>li{
                counter-increment:lst-ctn-kix_list_18-6;
            }
            ol.lst-kix_list_3-8.start{
                counter-reset:lst-ctn-kix_list_3-8 0;
            }
            .lst-kix_list_7-7>li:before{
                content:"" counter(lst-ctn-kix_list_7-0,decimal) "." counter(lst-ctn-kix_list_7-1,decimal) "." counter(lst-ctn-kix_list_7-2,decimal) "." counter(lst-ctn-kix_list_7-3,decimal) "." counter(lst-ctn-kix_list_7-4,decimal) "." counter(lst-ctn-kix_list_7-5,decimal) "." counter(lst-ctn-kix_list_7-6,decimal) "." counter(lst-ctn-kix_list_7-7,decimal) ". ";
            }
            ol.lst-kix_list_8-1.start{
                counter-reset:lst-ctn-kix_list_8-1 0;
            }
            .lst-kix_list_15-4>li:before{
                content:"" counter(lst-ctn-kix_list_15-0,decimal) "." counter(lst-ctn-kix_list_15-1,decimal) "." counter(lst-ctn-kix_list_15-2,decimal) "." counter(lst-ctn-kix_list_15-3,decimal) "." counter(lst-ctn-kix_list_15-4,decimal) ". ";
            }
            ol.lst-kix_list_19-1.start{
                counter-reset:lst-ctn-kix_list_19-1 0;
            }
            li.li-bullet-17:before{
                margin-left:-27.4pt;
                white-space:nowrap;
                display:inline-block;
                min-width:27.4pt;
            }
            .lst-kix_list_10-4>li:before{
                content:"" counter(lst-ctn-kix_list_10-0,decimal) "." counter(lst-ctn-kix_list_10-1,decimal) "." counter(lst-ctn-kix_list_10-2,decimal) "." counter(lst-ctn-kix_list_10-3,decimal) "." counter(lst-ctn-kix_list_10-4,decimal) ". ";
            }
            .lst-kix_list_10-8>li:before{
                content:"" counter(lst-ctn-kix_list_10-0,decimal) "." counter(lst-ctn-kix_list_10-1,decimal) "." counter(lst-ctn-kix_list_10-2,decimal) "." counter(lst-ctn-kix_list_10-3,decimal) "." counter(lst-ctn-kix_list_10-4,decimal) "." counter(lst-ctn-kix_list_10-5,decimal) "." counter(lst-ctn-kix_list_10-6,decimal) "." counter(lst-ctn-kix_list_10-7,decimal) "." counter(lst-ctn-kix_list_10-8,decimal) ". ";
            }
            ol.lst-kix_list_20-4.start{
                counter-reset:lst-ctn-kix_list_20-4 0;
            }
            .lst-kix_list_4-0>li:before{
                content:"\0025cf   ";
            }
            .lst-kix_list_15-0>li:before{
                content:"" counter(lst-ctn-kix_list_15-0,decimal) ". ";
            }
            .lst-kix_list_15-8>li:before{
                content:"" counter(lst-ctn-kix_list_15-0,decimal) "." counter(lst-ctn-kix_list_15-1,decimal) "." counter(lst-ctn-kix_list_15-2,decimal) "." counter(lst-ctn-kix_list_15-3,decimal) "." counter(lst-ctn-kix_list_15-4,decimal) "." counter(lst-ctn-kix_list_15-5,decimal) "." counter(lst-ctn-kix_list_15-6,decimal) "." counter(lst-ctn-kix_list_15-7,decimal) "." counter(lst-ctn-kix_list_15-8,decimal) ". ";
            }
            ol.lst-kix_list_14-3.start{
                counter-reset:lst-ctn-kix_list_14-3 0;
            }
            .lst-kix_list_15-7>li{
                counter-increment:lst-ctn-kix_list_15-7;
            }
            li.li-bullet-28:before{
                margin-left:-35.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:35.5pt;
            }
            .lst-kix_list_4-4>li:before{
                content:"\0025cf   ";
            }
            .lst-kix_list_9-3>li:before{
                content:"" counter(lst-ctn-kix_list_9-0,decimal) "." counter(lst-ctn-kix_list_9-1,decimal) "." counter(lst-ctn-kix_list_9-2,decimal) "." counter(lst-ctn-kix_list_9-3,decimal) ". ";
            }
            ol.lst-kix_list_7-0.start{
                counter-reset:lst-ctn-kix_list_7-0 0;
            }
            .lst-kix_list_12-8>li{
                counter-increment:lst-ctn-kix_list_12-8;
            }
            ol.lst-kix_list_13-2.start{
                counter-reset:lst-ctn-kix_list_13-2 0;
            }
            ol.lst-kix_list_14-4.start{
                counter-reset:lst-ctn-kix_list_14-4 0;
            }
            .lst-kix_list_9-7>li:before{
                content:"" counter(lst-ctn-kix_list_9-0,decimal) "." counter(lst-ctn-kix_list_9-1,decimal) "." counter(lst-ctn-kix_list_9-2,decimal) "." counter(lst-ctn-kix_list_9-3,decimal) "." counter(lst-ctn-kix_list_9-4,decimal) "." counter(lst-ctn-kix_list_9-5,decimal) "." counter(lst-ctn-kix_list_9-6,decimal) "." counter(lst-ctn-kix_list_9-7,decimal) ". ";
            }
            .lst-kix_list_2-4>li{
                counter-increment:lst-ctn-kix_list_2-4;
            }
            ol.lst-kix_list_3-6.start{
                counter-reset:lst-ctn-kix_list_3-6 0;
            }
            .lst-kix_list_11-4>li:before{
                content:"" counter(lst-ctn-kix_list_11-4,lower-latin) ". ";
            }
            .lst-kix_list_12-4>li:before{
                content:"" counter(lst-ctn-kix_list_12-0,decimal) "." counter(lst-ctn-kix_list_12-1,decimal) "." counter(lst-ctn-kix_list_12-2,decimal) "." counter(lst-ctn-kix_list_12-3,decimal) "." counter(lst-ctn-kix_list_12-4,decimal) ". ";
            }
            li.li-bullet-12:before{
                margin-left:-48pt;
                white-space:nowrap;
                display:inline-block;
                min-width:48pt;
            }
            .lst-kix_list_5-3>li{
                counter-increment:lst-ctn-kix_list_5-3;
            }
            .lst-kix_list_7-4>li{
                counter-increment:lst-ctn-kix_list_7-4;
            }
            .lst-kix_list_1-0>li:before{
                content:"" counter(lst-ctn-kix_list_1-0,decimal) ". ";
            }
            ol.lst-kix_list_19-2.start{
                counter-reset:lst-ctn-kix_list_19-2 0;
            }
            .lst-kix_list_11-8>li:before{
                content:"" counter(lst-ctn-kix_list_11-8,lower-roman) ". ";
            }
            ol.lst-kix_list_2-0.start{
                counter-reset:lst-ctn-kix_list_2-0 1;
            }
            .lst-kix_list_12-0>li:before{
                content:"" counter(lst-ctn-kix_list_12-0,decimal) ". ";
            }
            .lst-kix_list_1-4>li:before{
                content:"" counter(lst-ctn-kix_list_1-0,decimal) "." counter(lst-ctn-kix_list_1-1,decimal) "." counter(lst-ctn-kix_list_1-2,decimal) "." counter(lst-ctn-kix_list_1-3,decimal) "." counter(lst-ctn-kix_list_1-4,decimal) ". ";
            }
            .lst-kix_list_13-0>li:before{
                content:"" counter(lst-ctn-kix_list_13-0,decimal) ". ";
            }
            li.li-bullet-34:before{
                margin-left:-25.4pt;
                white-space:nowrap;
                display:inline-block;
                min-width:25.4pt;
            }
            .lst-kix_list_1-6>li{
                counter-increment:lst-ctn-kix_list_1-6;
            }
            .lst-kix_list_13-4>li:before{
                content:"" counter(lst-ctn-kix_list_13-0,decimal) "." counter(lst-ctn-kix_list_13-1,decimal) "." counter(lst-ctn-kix_list_13-2,decimal) "." counter(lst-ctn-kix_list_13-3,decimal) "." counter(lst-ctn-kix_list_13-4,decimal) ". ";
            }
            li.li-bullet-23:before{
                margin-left:-35.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:35.5pt;
            }
            ol.lst-kix_list_19-3.start{
                counter-reset:lst-ctn-kix_list_19-3 0;
            }
            .lst-kix_list_2-0>li:before{
                content:"" counter(lst-ctn-kix_list_2-0,decimal) ". ";
            }
            ol.lst-kix_list_2-1.start{
                counter-reset:lst-ctn-kix_list_2-1 0;
            }
            ol.lst-kix_list_9-8.start{
                counter-reset:lst-ctn-kix_list_9-8 0;
            }
            .lst-kix_list_1-8>li:before{
                content:"" counter(lst-ctn-kix_list_1-0,decimal) "." counter(lst-ctn-kix_list_1-1,decimal) "." counter(lst-ctn-kix_list_1-2,decimal) "." counter(lst-ctn-kix_list_1-3,decimal) "." counter(lst-ctn-kix_list_1-4,decimal) "." counter(lst-ctn-kix_list_1-5,decimal) "." counter(lst-ctn-kix_list_1-6,decimal) "." counter(lst-ctn-kix_list_1-7,decimal) "." counter(lst-ctn-kix_list_1-8,decimal) ". ";
            }
            .lst-kix_list_12-8>li:before{
                content:"" counter(lst-ctn-kix_list_12-0,decimal) "." counter(lst-ctn-kix_list_12-1,decimal) "." counter(lst-ctn-kix_list_12-2,decimal) "." counter(lst-ctn-kix_list_12-3,decimal) "." counter(lst-ctn-kix_list_12-4,decimal) "." counter(lst-ctn-kix_list_12-5,decimal) "." counter(lst-ctn-kix_list_12-6,decimal) "." counter(lst-ctn-kix_list_12-7,decimal) "." counter(lst-ctn-kix_list_12-8,decimal) ". ";
            }
            .lst-kix_list_8-2>li{
                counter-increment:lst-ctn-kix_list_8-2;
            }
            .lst-kix_list_19-0>li:before{
                content:"" counter(lst-ctn-kix_list_19-0,decimal) ". ";
            }
            ol.lst-kix_list_17-7.start{
                counter-reset:lst-ctn-kix_list_17-7 0;
            }
            ol.lst-kix_list_12-6.start{
                counter-reset:lst-ctn-kix_list_12-6 0;
            }
            .lst-kix_list_8-1>li{
                counter-increment:lst-ctn-kix_list_8-1;
            }
            ol.lst-kix_list_8-2.start{
                counter-reset:lst-ctn-kix_list_8-2 0;
            }
            .lst-kix_list_19-2>li:before{
                content:"" counter(lst-ctn-kix_list_19-0,decimal) "." counter(lst-ctn-kix_list_19-1,decimal) "." counter(lst-ctn-kix_list_19-2,decimal) ". ";
            }
            ol.lst-kix_list_21-0.start{
                counter-reset:lst-ctn-kix_list_21-0 10;
            }
            ol.lst-kix_list_3-1.start{
                counter-reset:lst-ctn-kix_list_3-1 0;
            }
            .lst-kix_list_7-0>li{
                counter-increment:lst-ctn-kix_list_7-0;
            }
            .lst-kix_list_19-0>li{
                counter-increment:lst-ctn-kix_list_19-0;
            }
            .lst-kix_list_2-3>li{
                counter-increment:lst-ctn-kix_list_2-3;
            }
            ol.lst-kix_list_19-8.start{
                counter-reset:lst-ctn-kix_list_19-8 0;
            }
            .lst-kix_list_1-2>li{
                counter-increment:lst-ctn-kix_list_1-2;
            }
            .lst-kix_list_19-8>li:before{
                content:"" counter(lst-ctn-kix_list_19-0,decimal) "." counter(lst-ctn-kix_list_19-1,decimal) "." counter(lst-ctn-kix_list_19-2,decimal) "." counter(lst-ctn-kix_list_19-3,decimal) "." counter(lst-ctn-kix_list_19-4,decimal) "." counter(lst-ctn-kix_list_19-5,decimal) "." counter(lst-ctn-kix_list_19-6,decimal) "." counter(lst-ctn-kix_list_19-7,decimal) "." counter(lst-ctn-kix_list_19-8,decimal) ". ";
            }
            ol.lst-kix_list_14-7.start{
                counter-reset:lst-ctn-kix_list_14-7 0;
            }
            ol.lst-kix_list_20-8.start{
                counter-reset:lst-ctn-kix_list_20-8 0;
            }
            .lst-kix_list_19-5>li:before{
                content:"" counter(lst-ctn-kix_list_19-0,decimal) "." counter(lst-ctn-kix_list_19-1,decimal) "." counter(lst-ctn-kix_list_19-2,decimal) "." counter(lst-ctn-kix_list_19-3,decimal) "." counter(lst-ctn-kix_list_19-4,decimal) "." counter(lst-ctn-kix_list_19-5,decimal) ". ";
            }
            .lst-kix_list_19-7>li:before{
                content:"" counter(lst-ctn-kix_list_19-0,decimal) "." counter(lst-ctn-kix_list_19-1,decimal) "." counter(lst-ctn-kix_list_19-2,decimal) "." counter(lst-ctn-kix_list_19-3,decimal) "." counter(lst-ctn-kix_list_19-4,decimal) "." counter(lst-ctn-kix_list_19-5,decimal) "." counter(lst-ctn-kix_list_19-6,decimal) "." counter(lst-ctn-kix_list_19-7,decimal) ". ";
            }
            .lst-kix_list_9-2>li{
                counter-increment:lst-ctn-kix_list_9-2;
            }
            ol.lst-kix_list_17-2.start{
                counter-reset:lst-ctn-kix_list_17-2 0;
            }
            ol.lst-kix_list_21-5.start{
                counter-reset:lst-ctn-kix_list_21-5 0;
            }
            .lst-kix_list_13-2>li{
                counter-increment:lst-ctn-kix_list_13-2;
            }
            li.li-bullet-6:before{
                margin-left:-25.2pt;
                white-space:nowrap;
                display:inline-block;
                min-width:25.2pt;
            }
            .lst-kix_list_19-7>li{
                counter-increment:lst-ctn-kix_list_19-7;
            }
            .lst-kix_list_14-3>li{
                counter-increment:lst-ctn-kix_list_14-3;
            }
            ol.lst-kix_list_15-6.start{
                counter-reset:lst-ctn-kix_list_15-6 0;
            }
            .lst-kix_list_12-1>li{
                counter-increment:lst-ctn-kix_list_12-1;
            }
            .lst-kix_list_18-1>li:before{
                content:"" counter(lst-ctn-kix_list_18-0,decimal) "." counter(lst-ctn-kix_list_18-1,decimal) ". ";
            }
            ol.lst-kix_list_2-4.start{
                counter-reset:lst-ctn-kix_list_2-4 0;
            }
            ol.lst-kix_list_1-3{
                list-style-type:none;
            }
            ol.lst-kix_list_1-4{
                list-style-type:none;
            }
            .lst-kix_list_2-7>li:before{
                content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) "." counter(lst-ctn-kix_list_2-3,decimal) "." counter(lst-ctn-kix_list_2-4,decimal) "." counter(lst-ctn-kix_list_2-5,decimal) "." counter(lst-ctn-kix_list_2-6,decimal) "." counter(lst-ctn-kix_list_2-7,decimal) ". ";
            }
            .lst-kix_list_2-7>li{
                counter-increment:lst-ctn-kix_list_2-7;
            }
            ol.lst-kix_list_1-5{
                list-style-type:none;
            }
            ol.lst-kix_list_1-6{
                list-style-type:none;
            }
            ol.lst-kix_list_1-0{
                list-style-type:none;
            }
            .lst-kix_list_2-5>li:before{
                content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) "." counter(lst-ctn-kix_list_2-3,decimal) "." counter(lst-ctn-kix_list_2-4,decimal) "." counter(lst-ctn-kix_list_2-5,decimal) ". ";
            }
            ol.lst-kix_list_1-1{
                list-style-type:none;
            }
            ol.lst-kix_list_1-2{
                list-style-type:none;
            }
            ol.lst-kix_list_17-0.start{
                counter-reset:lst-ctn-kix_list_17-0 10;
            }
            ol.lst-kix_list_10-3.start{
                counter-reset:lst-ctn-kix_list_10-3 0;
            }
            .lst-kix_list_22-3>li{
                counter-increment:lst-ctn-kix_list_22-3;
            }
            .lst-kix_list_18-6>li:before{
                content:"" counter(lst-ctn-kix_list_18-0,decimal) "." counter(lst-ctn-kix_list_18-1,decimal) "." counter(lst-ctn-kix_list_18-2,decimal) "." counter(lst-ctn-kix_list_18-3,decimal) "." counter(lst-ctn-kix_list_18-4,decimal) "." counter(lst-ctn-kix_list_18-5,decimal) "." counter(lst-ctn-kix_list_18-6,decimal) ". ";
            }
            .lst-kix_list_14-6>li{
                counter-increment:lst-ctn-kix_list_14-6;
            }
            .lst-kix_list_10-1>li:before{
                content:"" counter(lst-ctn-kix_list_10-0,decimal) "." counter(lst-ctn-kix_list_10-1,decimal) ". ";
            }
            .lst-kix_list_18-4>li:before{
                content:"" counter(lst-ctn-kix_list_18-0,decimal) "." counter(lst-ctn-kix_list_18-1,decimal) "." counter(lst-ctn-kix_list_18-2,decimal) "." counter(lst-ctn-kix_list_18-3,decimal) "." counter(lst-ctn-kix_list_18-4,decimal) ". ";
            }
            .lst-kix_list_7-7>li{
                counter-increment:lst-ctn-kix_list_7-7;
            }
            ol.lst-kix_list_15-1.start{
                counter-reset:lst-ctn-kix_list_15-1 0;
            }
            ol.lst-kix_list_15-4.start{
                counter-reset:lst-ctn-kix_list_15-4 0;
            }
            ol.lst-kix_list_1-7{
                list-style-type:none;
            }
            ol.lst-kix_list_1-8{
                list-style-type:none;
            }
            li.li-bullet-19:before{
                margin-left:-32.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:32.5pt;
            }
            li.li-bullet-1:before{
                margin-left:-21.6pt;
                white-space:nowrap;
                display:inline-block;
                min-width:21.6pt;
            }
            .lst-kix_list_10-3>li:before{
                content:"" counter(lst-ctn-kix_list_10-0,decimal) "." counter(lst-ctn-kix_list_10-1,decimal) "." counter(lst-ctn-kix_list_10-2,decimal) "." counter(lst-ctn-kix_list_10-3,decimal) ". ";
            }
            .lst-kix_list_15-4>li{
                counter-increment:lst-ctn-kix_list_15-4;
            }
            .lst-kix_list_2-6>li{
                counter-increment:lst-ctn-kix_list_2-6;
            }
            ol.lst-kix_list_7-3.start{
                counter-reset:lst-ctn-kix_list_7-3 0;
            }
            li.li-bullet-22:before{
                margin-left:-35.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:35.5pt;
            }
            ol.lst-kix_list_5-7.start{
                counter-reset:lst-ctn-kix_list_5-7 0;
            }
            .lst-kix_list_20-8>li:before{
                content:"" counter(lst-ctn-kix_list_20-0,decimal) "." counter(lst-ctn-kix_list_20-1,decimal) "." counter(lst-ctn-kix_list_20-2,decimal) "." counter(lst-ctn-kix_list_20-3,decimal) "." counter(lst-ctn-kix_list_20-4,decimal) "." counter(lst-ctn-kix_list_20-5,decimal) "." counter(lst-ctn-kix_list_20-6,decimal) "." counter(lst-ctn-kix_list_20-7,decimal) "." counter(lst-ctn-kix_list_20-8,decimal) ". ";
            }
            .lst-kix_list_3-4>li{
                counter-increment:lst-ctn-kix_list_3-4;
            }
            .lst-kix_list_20-0>li:before{
                content:"" counter(lst-ctn-kix_list_20-0,decimal) ". ";
            }
            ol.lst-kix_list_10-7{
                list-style-type:none;
            }
            .lst-kix_list_9-6>li:before{
                content:"" counter(lst-ctn-kix_list_9-0,decimal) "." counter(lst-ctn-kix_list_9-1,decimal) "." counter(lst-ctn-kix_list_9-2,decimal) "." counter(lst-ctn-kix_list_9-3,decimal) "." counter(lst-ctn-kix_list_9-4,decimal) "." counter(lst-ctn-kix_list_9-5,decimal) "." counter(lst-ctn-kix_list_9-6,decimal) ". ";
            }
            li.li-bullet-9:before{
                margin-left:-27.4pt;
                white-space:nowrap;
                display:inline-block;
                min-width:27.4pt;
            }
            ol.lst-kix_list_10-8{
                list-style-type:none;
            }
            ol.lst-kix_list_10-3{
                list-style-type:none;
            }
            .lst-kix_list_9-4>li:before{
                content:"" counter(lst-ctn-kix_list_9-0,decimal) "." counter(lst-ctn-kix_list_9-1,decimal) "." counter(lst-ctn-kix_list_9-2,decimal) "." counter(lst-ctn-kix_list_9-3,decimal) "." counter(lst-ctn-kix_list_9-4,decimal) ". ";
            }
            ol.lst-kix_list_10-4{
                list-style-type:none;
            }
            ol.lst-kix_list_10-5{
                list-style-type:none;
            }
            ol.lst-kix_list_10-6{
                list-style-type:none;
            }
            .lst-kix_list_20-6>li:before{
                content:"" counter(lst-ctn-kix_list_20-0,decimal) "." counter(lst-ctn-kix_list_20-1,decimal) "." counter(lst-ctn-kix_list_20-2,decimal) "." counter(lst-ctn-kix_list_20-3,decimal) "." counter(lst-ctn-kix_list_20-4,decimal) "." counter(lst-ctn-kix_list_20-5,decimal) "." counter(lst-ctn-kix_list_20-6,decimal) ". ";
            }
            ol.lst-kix_list_10-0{
                list-style-type:none;
            }
            ol.lst-kix_list_10-1{
                list-style-type:none;
            }
            ol.lst-kix_list_10-2{
                list-style-type:none;
            }
            ol.lst-kix_list_12-1.start{
                counter-reset:lst-ctn-kix_list_12-1 0;
            }
            li.li-bullet-11:before{
                margin-left:-48pt;
                white-space:nowrap;
                display:inline-block;
                min-width:48pt;
            }
            .lst-kix_list_11-5>li:before{
                content:"" counter(lst-ctn-kix_list_11-5,lower-roman) ". ";
            }
            ol.lst-kix_list_21-2.start{
                counter-reset:lst-ctn-kix_list_21-2 0;
            }
            .lst-kix_list_20-6>li{
                counter-increment:lst-ctn-kix_list_20-6;
            }
            .lst-kix_list_1-1>li:before{
                content:"" counter(lst-ctn-kix_list_1-0,decimal) "." counter(lst-ctn-kix_list_1-1,decimal) ". ";
            }
            .lst-kix_list_11-7>li:before{
                content:"" counter(lst-ctn-kix_list_11-7,lower-latin) ". ";
            }
            .lst-kix_list_8-5>li{
                counter-increment:lst-ctn-kix_list_8-5;
            }
            .lst-kix_list_1-3>li:before{
                content:"" counter(lst-ctn-kix_list_1-0,decimal) "." counter(lst-ctn-kix_list_1-1,decimal) "." counter(lst-ctn-kix_list_1-2,decimal) "." counter(lst-ctn-kix_list_1-3,decimal) ". ";
            }
            li.li-bullet-38:before{
                margin-left:-35.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:35.5pt;
            }
            ol.lst-kix_list_10-5.start{
                counter-reset:lst-ctn-kix_list_10-5 0;
            }
            ol.lst-kix_list_21-8{
                list-style-type:none;
            }
            li.li-bullet-16:before{
                margin-left:-27.4pt;
                white-space:nowrap;
                display:inline-block;
                min-width:27.4pt;
            }
            ol.lst-kix_list_21-7{
                list-style-type:none;
            }
            ol.lst-kix_list_2-7.start{
                counter-reset:lst-ctn-kix_list_2-7 0;
            }
            ol.lst-kix_list_21-4{
                list-style-type:none;
            }
            ol.lst-kix_list_21-3{
                list-style-type:none;
            }
            ol.lst-kix_list_21-6{
                list-style-type:none;
            }
            li.li-bullet-27:before{
                margin-left:-35.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:35.5pt;
            }
            ol.lst-kix_list_21-5{
                list-style-type:none;
            }
            .lst-kix_list_14-7>li{
                counter-increment:lst-ctn-kix_list_14-7;
            }
            ol.lst-kix_list_21-0{
                list-style-type:none;
            }
            ol.lst-kix_list_7-5.start{
                counter-reset:lst-ctn-kix_list_7-5 0;
            }
            ol.lst-kix_list_21-2{
                list-style-type:none;
            }
            ol.lst-kix_list_21-1{
                list-style-type:none;
            }
            li.li-bullet-49:before{
                margin-left:-30.2pt;
                white-space:nowrap;
                display:inline-block;
                min-width:30.2pt;
            }
            ol.lst-kix_list_19-6{
                list-style-type:none;
            }
            ol.lst-kix_list_19-7{
                list-style-type:none;
            }
            .lst-kix_list_3-1>li{
                counter-increment:lst-ctn-kix_list_3-1;
            }
            ol.lst-kix_list_19-8{
                list-style-type:none;
            }
            ol.lst-kix_list_19-2{
                list-style-type:none;
            }
            ol.lst-kix_list_19-3{
                list-style-type:none;
            }
            ol.lst-kix_list_19-4{
                list-style-type:none;
            }
            ol.lst-kix_list_19-5{
                list-style-type:none;
            }
            ol.lst-kix_list_19-0{
                list-style-type:none;
            }
            ol.lst-kix_list_19-1{
                list-style-type:none;
            }
            ol.lst-kix_list_7-7.start{
                counter-reset:lst-ctn-kix_list_7-7 0;
            }
            .lst-kix_list_3-1>li:before{
                content:"" counter(lst-ctn-kix_list_3-0,decimal) "." counter(lst-ctn-kix_list_3-1,decimal) " ";
            }
            .lst-kix_list_14-0>li{
                counter-increment:lst-ctn-kix_list_14-0;
            }
            ol.lst-kix_list_17-4.start{
                counter-reset:lst-ctn-kix_list_17-4 0;
            }
            .lst-kix_list_8-2>li:before{
                content:"" counter(lst-ctn-kix_list_8-0,decimal) "." counter(lst-ctn-kix_list_8-1,decimal) "." counter(lst-ctn-kix_list_8-2,decimal) ". ";
            }
            .lst-kix_list_12-0>li{
                counter-increment:lst-ctn-kix_list_12-0;
            }
            ol.lst-kix_list_12-3.start{
                counter-reset:lst-ctn-kix_list_12-3 0;
            }
            .lst-kix_list_21-2>li:before{
                content:"" counter(lst-ctn-kix_list_21-0,decimal) "." counter(lst-ctn-kix_list_21-1,decimal) "." counter(lst-ctn-kix_list_21-2,decimal) ". ";
            }
            .lst-kix_list_8-5>li:before{
                content:"" counter(lst-ctn-kix_list_8-0,decimal) "." counter(lst-ctn-kix_list_8-1,decimal) "." counter(lst-ctn-kix_list_8-2,decimal) "." counter(lst-ctn-kix_list_8-3,decimal) "." counter(lst-ctn-kix_list_8-4,decimal) "." counter(lst-ctn-kix_list_8-5,decimal) ". ";
            }
            li.li-bullet-42:before{
                margin-left:-35.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:35.5pt;
            }
            .lst-kix_list_2-0>li{
                counter-increment:lst-ctn-kix_list_2-0;
            }
            .lst-kix_list_15-1>li{
                counter-increment:lst-ctn-kix_list_15-1;
            }
            .lst-kix_list_3-6>li:before{
                content:"" counter(lst-ctn-kix_list_3-0,decimal) "." counter(lst-ctn-kix_list_3-1,decimal) "." counter(lst-ctn-kix_list_3-2,decimal) "." counter(lst-ctn-kix_list_3-3,decimal) "." counter(lst-ctn-kix_list_3-4,decimal) "." counter(lst-ctn-kix_list_3-5,decimal) "." counter(lst-ctn-kix_list_3-6,decimal) " ";
            }
            li.li-bullet-31:before{
                margin-left:-25.4pt;
                white-space:nowrap;
                display:inline-block;
                min-width:25.4pt;
            }
            .lst-kix_list_21-7>li:before{
                content:"" counter(lst-ctn-kix_list_21-0,decimal) "." counter(lst-ctn-kix_list_21-1,decimal) "." counter(lst-ctn-kix_list_21-2,decimal) "." counter(lst-ctn-kix_list_21-3,decimal) "." counter(lst-ctn-kix_list_21-4,decimal) "." counter(lst-ctn-kix_list_21-5,decimal) "." counter(lst-ctn-kix_list_21-6,decimal) "." counter(lst-ctn-kix_list_21-7,decimal) ". ";
            }
            ol.lst-kix_list_5-0.start{
                counter-reset:lst-ctn-kix_list_5-0 0;
            }
            .lst-kix_list_11-2>li:before{
                content:"" counter(lst-ctn-kix_list_11-2,lower-roman) ". ";
            }
            ol.lst-kix_list_12-4.start{
                counter-reset:lst-ctn-kix_list_12-4 0;
            }
            .lst-kix_list_16-6>li:before{
                content:"" counter(lst-ctn-kix_list_16-0,decimal) "." counter(lst-ctn-kix_list_16-1,decimal) "." counter(lst-ctn-kix_list_16-2,decimal) "." counter(lst-ctn-kix_list_16-3,decimal) "." counter(lst-ctn-kix_list_16-4,decimal) "." counter(lst-ctn-kix_list_16-5,decimal) "." counter(lst-ctn-kix_list_16-6,decimal) ". ";
            }
            ol.lst-kix_list_10-1.start{
                counter-reset:lst-ctn-kix_list_10-1 0;
            }
            .lst-kix_list_18-2>li{
                counter-increment:lst-ctn-kix_list_18-2;
            }
            ol.lst-kix_list_5-6.start{
                counter-reset:lst-ctn-kix_list_5-6 0;
            }
            .lst-kix_list_22-6>li{
                counter-increment:lst-ctn-kix_list_22-6;
            }
            .lst-kix_list_16-1>li:before{
                content:"" counter(lst-ctn-kix_list_16-0,decimal) "." counter(lst-ctn-kix_list_16-1,decimal) ". ";
            }
            .lst-kix_list_7-3>li{
                counter-increment:lst-ctn-kix_list_7-3;
            }
            li.li-bullet-14:before{
                margin-left:-48pt;
                white-space:nowrap;
                display:inline-block;
                min-width:48pt;
            }
            .lst-kix_list_19-3>li{
                counter-increment:lst-ctn-kix_list_19-3;
            }
            ol.lst-kix_list_7-8.start{
                counter-reset:lst-ctn-kix_list_7-8 0;
            }
            .lst-kix_list_12-4>li{
                counter-increment:lst-ctn-kix_list_12-4;
            }
            ol.lst-kix_list_10-2.start{
                counter-reset:lst-ctn-kix_list_10-2 0;
            }
            .lst-kix_list_12-7>li{
                counter-increment:lst-ctn-kix_list_12-7;
            }
            li.li-bullet-69:before{
                margin-left:-25.4pt;
                white-space:nowrap;
                display:inline-block;
                min-width:25.4pt;
            }
            .lst-kix_list_17-2>li:before{
                content:"" counter(lst-ctn-kix_list_17-0,decimal) "." counter(lst-ctn-kix_list_17-1,decimal) "." counter(lst-ctn-kix_list_17-2,decimal) ". ";
            }
            ol.lst-kix_list_5-5.start{
                counter-reset:lst-ctn-kix_list_5-5 0;
            }
            ol.lst-kix_list_17-3.start{
                counter-reset:lst-ctn-kix_list_17-3 0;
            }
            .lst-kix_list_17-5>li:before{
                content:"" counter(lst-ctn-kix_list_17-0,decimal) "." counter(lst-ctn-kix_list_17-1,decimal) "." counter(lst-ctn-kix_list_17-2,decimal) "." counter(lst-ctn-kix_list_17-3,decimal) "." counter(lst-ctn-kix_list_17-4,decimal) "." counter(lst-ctn-kix_list_17-5,decimal) ". ";
            }
            .lst-kix_list_6-2>li{
                counter-increment:lst-ctn-kix_list_6-2;
            }
            .lst-kix_list_22-3>li:before{
                content:"" counter(lst-ctn-kix_list_22-0,decimal) "." counter(lst-ctn-kix_list_22-1,decimal) "." counter(lst-ctn-kix_list_22-2,decimal) "." counter(lst-ctn-kix_list_22-3,decimal) " ";
            }
            .lst-kix_list_7-1>li:before{
                content:"" counter(lst-ctn-kix_list_7-0,decimal) "." counter(lst-ctn-kix_list_7-1,decimal) ". ";
            }
            .lst-kix_list_13-5>li{
                counter-increment:lst-ctn-kix_list_13-5;
            }
            .lst-kix_list_9-6>li{
                counter-increment:lst-ctn-kix_list_9-6;
            }
            ol.lst-kix_list_5-4.start{
                counter-reset:lst-ctn-kix_list_5-4 0;
            }
            li.li-bullet-20:before{
                margin-left:-32.5pt;
                white-space:nowrap;
                display:inline-block;
                min-width:32.5pt;
            }
            ol.lst-kix_list_5-1.start{
                counter-reset:lst-ctn-kix_list_5-1 1;
            }
            .lst-kix_list_20-3>li{
                counter-increment:lst-ctn-kix_list_20-3;
            }
            .lst-kix_list_16-6>li{
                counter-increment:lst-ctn-kix_list_16-6;
            }
            .lst-kix_list_11-6>li{
                counter-increment:lst-ctn-kix_list_11-6;
            }
            li.li-bullet-53:before{
                margin-left:-25.4pt;
                white-space:nowrap;
                display:inline-block;
                min-width:25.4pt;
            }
            ol.lst-kix_list_10-0.start{
                counter-reset:lst-ctn-kix_list_10-0 0;
            }
            ol.lst-kix_list_17-8.start{
                counter-reset:lst-ctn-kix_list_17-8 0;
            }
            .lst-kix_list_3-8>li{
                counter-increment:lst-ctn-kix_list_3-8;
            }
            .lst-kix_list_1-5>li{
                counter-increment:lst-ctn-kix_list_1-5;
            }
            ol.lst-kix_list_17-5.start{
                counter-reset:lst-ctn-kix_list_17-5 0;
            }
            .lst-kix_list_4-2>li:before{
                content:"\0025cf   ";
            }
            .lst-kix_list_17-4>li{
                counter-increment:lst-ctn-kix_list_17-4;
            }
            li.li-bullet-64:before{
                margin-left:-10.9pt;
                white-space:nowrap;
                display:inline-block;
                min-width:10.9pt;
            }
            .lst-kix_list_15-2>li:before{
                content:"" counter(lst-ctn-kix_list_15-0,decimal) "." counter(lst-ctn-kix_list_15-1,decimal) "." counter(lst-ctn-kix_list_15-2,decimal) ". ";
            }
            .lst-kix_list_10-8>li{
                counter-increment:lst-ctn-kix_list_10-8;
            }
            .lst-kix_list_10-6>li:before{
                content:"" counter(lst-ctn-kix_list_10-0,decimal) "." counter(lst-ctn-kix_list_10-1,decimal) "." counter(lst-ctn-kix_list_10-2,decimal) "." counter(lst-ctn-kix_list_10-3,decimal) "." counter(lst-ctn-kix_list_10-4,decimal) "." counter(lst-ctn-kix_list_10-5,decimal) "." counter(lst-ctn-kix_list_10-6,decimal) ". ";
            }
            .lst-kix_list_9-1>li:before{
                content:"" counter(lst-ctn-kix_list_9-0,decimal) "." counter(lst-ctn-kix_list_9-1,decimal) ". ";
            }
            ol.lst-kix_list_12-7.start{
                counter-reset:lst-ctn-kix_list_12-7 0;
            }
            .lst-kix_list_15-8>li{
                counter-increment:lst-ctn-kix_list_15-8;
            }
            ol.lst-kix_list_12-8.start{
                counter-reset:lst-ctn-kix_list_12-8 0;
            }
            .lst-kix_list_20-3>li:before{
                content:"" counter(lst-ctn-kix_list_20-0,decimal) "." counter(lst-ctn-kix_list_20-1,decimal) "." counter(lst-ctn-kix_list_20-2,decimal) "." counter(lst-ctn-kix_list_20-3,decimal) ". ";
            }
            .lst-kix_list_21-1>li{
                counter-increment:lst-ctn-kix_list_21-1;
            }
            .lst-kix_list_10-1>li{
                counter-increment:lst-ctn-kix_list_10-1;
            }
            .lst-kix_list_8-8>li{
                counter-increment:lst-ctn-kix_list_8-8;
            }
            ol.lst-kix_list_17-6.start{
                counter-reset:lst-ctn-kix_list_17-6 0;
            }
            .lst-kix_list_1-6>li:before{
                content:"" counter(lst-ctn-kix_list_1-0,decimal) "." counter(lst-ctn-kix_list_1-1,decimal) "." counter(lst-ctn-kix_list_1-2,decimal) "." counter(lst-ctn-kix_list_1-3,decimal) "." counter(lst-ctn-kix_list_1-4,decimal) "." counter(lst-ctn-kix_list_1-5,decimal) "." counter(lst-ctn-kix_list_1-6,decimal) ". ";
            }
            .lst-kix_list_12-6>li:before{
                content:"" counter(lst-ctn-kix_list_12-0,decimal) "." counter(lst-ctn-kix_list_12-1,decimal) "." counter(lst-ctn-kix_list_12-2,decimal) "." counter(lst-ctn-kix_list_12-3,decimal) "." counter(lst-ctn-kix_list_12-4,decimal) "." counter(lst-ctn-kix_list_12-5,decimal) "." counter(lst-ctn-kix_list_12-6,decimal) ". ";
            }
            .lst-kix_list_2-2>li:before{
                content:"" counter(lst-ctn-kix_list_2-0,decimal) "." counter(lst-ctn-kix_list_2-1,decimal) "." counter(lst-ctn-kix_list_2-2,decimal) ". ";
            }
            .lst-kix_list_13-2>li:before{
                content:"" counter(lst-ctn-kix_list_13-0,decimal) "." counter(lst-ctn-kix_list_13-1,decimal) "." counter(lst-ctn-kix_list_13-2,decimal) ". ";
            }
            ol.lst-kix_list_5-2.start{
                counter-reset:lst-ctn-kix_list_5-2 0;
            }
            ol{
                margin:0;
                padding:0;
            }
            table td,table th{
                padding:0;
            }
            .c24{
                -webkit-text-decoration-skip:none;
                color:#000000;
                font-weight:400;
                text-decoration:underline;
                vertical-align:baseline;
                text-decoration-skip-ink:none;
                font-size:11pt;
                font-family:"Calibri";
                font-style:normal;
            }
            .c6{
                margin-left:18pt;
                padding-top:0pt;
                padding-left:0pt;
                padding-bottom:0pt;
                line-height:1.1500000000000001;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .c11{
                margin-left:72pt;
                padding-top:0pt;
                padding-left:30pt;
                padding-bottom:0pt;
                line-height:1.1500000000000001;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .c0{
                margin-left:39.6pt;
                padding-top:0pt;
                padding-bottom:0pt;
                line-height:1.1500000000000001;
                page-break-after:avoid;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .c2{
                margin-left:54pt;
                padding-top:0pt;
                padding-left:16.9pt;
                padding-bottom:0pt;
                line-height:1.1500000000000001;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .c10{
                margin-left:57.6pt;
                padding-top:0pt;
                padding-left:0pt;
                padding-bottom:10pt;
                line-height:1.1500000000000001;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .c8{
                margin-left:60.5pt;
                padding-top:0pt;
                padding-left:17.5pt;
                padding-bottom:0pt;
                line-height:1.1500000000000001;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .c20{
                margin-left:97.2pt;
                padding-top:0pt;
                padding-left:18pt;
                padding-bottom:0pt;
                line-height:1.1500000000000001;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .c13{
                margin-left:43.1pt;
                padding-top:0pt;
                padding-left:14.5pt;
                padding-bottom:0pt;
                line-height:1.1500000000000001;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .c15{
                margin-left:36pt;
                padding-top:0pt;
                padding-left:9.4pt;
                padding-bottom:0pt;
                line-height:1.1500000000000001;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .c12{
                margin-left:50.2pt;
                padding-top:0pt;
                padding-left:7.4pt;
                padding-bottom:0pt;
                line-height:1.1500000000000001;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .c19{
                margin-left:36pt;
                padding-top:0pt;
                padding-left:12.2pt;
                padding-bottom:10pt;
                line-height:1.1500000000000001;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .c17{
                margin-left:36pt;
                padding-top:0pt;
                padding-left:12.2pt;
                padding-bottom:0pt;
                line-height:1.1500000000000001;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .c14{
                margin-left:36pt;
                padding-top:0pt;
                padding-left:3.6pt;
                padding-bottom:0pt;
                line-height:1.1500000000000001;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .c7{
                margin-left:57.6pt;
                padding-top:0pt;
                padding-left:0pt;
                padding-bottom:0pt;
                line-height:1.1500000000000001;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .c1{
                color:#000000;
                font-weight:400;
                text-decoration:none;
                vertical-align:baseline;
                font-size:11pt;
                font-family:"Calibri";
                font-style:normal;
            }
            .c9{
                color:#000000;
                font-weight:700;
                text-decoration:none;
                vertical-align:baseline;
                font-size:11pt;
                font-family:"Calibri";
                font-style:normal;
            }
            .c18{
                margin-left:18pt;
                padding-top:0pt;
                padding-bottom:10pt;
                line-height:1.1500000000000001;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .c21{
                color:#ff0000;
                font-weight:400;
                text-decoration:none;
                vertical-align:baseline;
                font-size:11pt;
                font-family:"Calibri";
                font-style:normal;
            }
            .c30{
                padding-top:0pt;
                padding-bottom:10pt;
                line-height:1.1500000000000001;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .c23{
                padding-top:0pt;
                padding-bottom:0pt;
                line-height:1.1500000000000001;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .c33{
                background-color:#ffffff;
                max-width:595.3pt;
                padding:0pt 0pt 0pt 0pt;
            }
            .c28{
                margin-left:25.1pt;
                padding-left:-7.1pt;
            }
            .c31{
                margin-left:60.5pt;
                padding-left:24.5pt;
            }
            .c5{
                padding:0;
                margin:0;
            }
            .c25{
                margin-left:54pt;
                padding-left:7.2pt;
            }
            .c22{
                color:inherit;
                text-decoration:inherit;
            }
            .c16{
                font-weight:700;
            }
            .c4{
                page-break-after:avoid;
            }
            .c29{
                text-indent:-18pt;
            }
            .c32{
                padding-left:0pt;
            }
            .c27{
                margin-left:70.9pt;
            }
            .c26{
                margin-left:18pt;
            }
            .c3{
                height:11pt;
            }
            .c34{
                margin-left:72pt;
            }
            .title{
                padding-top:24pt;
                color:#000000;
                font-weight:700;
                font-size:36pt;
                padding-bottom:6pt;
                font-family:"Calibri";
                line-height:1.1500000000000001;
                page-break-after:avoid;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .subtitle{
                padding-top:18pt;
                color:#666666;
                font-size:24pt;
                padding-bottom:4pt;
                font-family:"Georgia";
                line-height:1.1500000000000001;
                page-break-after:avoid;
                font-style:italic;
                orphans:2;
                widows:2;
                text-align:left;
            }
            li{
                color:#000000;
                font-size:11pt;
                font-family:"Calibri";
            }
            p{
                margin:0;
                color:#000000;
                font-size:11pt;
                font-family:"Calibri";
            }
            h1{
                padding-top:24pt;
                color:#000000;
                font-weight:700;
                font-size:24pt;
                padding-bottom:6pt;
                font-family:"Calibri";
                line-height:1.1500000000000001;
                page-break-after:avoid;
                orphans:2;
                widows:2;
                text-align:left;
            }
            h2{
                padding-top:18pt;
                color:#000000;
                font-weight:700;
                font-size:18pt;
                padding-bottom:4pt;
                font-family:"Calibri";
                line-height:1.1500000000000001;
                page-break-after:avoid;
                orphans:2;
                widows:2;
                text-align:left;
            }
            h3{
                padding-top:14pt;
                color:#000000;
                font-weight:700;
                font-size:14pt;
                padding-bottom:4pt;
                font-family:"Calibri";
                line-height:1.1500000000000001;
                page-break-after:avoid;
                orphans:2;
                widows:2;
                text-align:left;
            }
            h4{
                padding-top:12pt;
                color:#000000;
                font-weight:700;
                font-size:12pt;
                padding-bottom:2pt;
                font-family:"Calibri";
                line-height:1.1500000000000001;
                page-break-after:avoid;
                orphans:2;
                widows:2;
                text-align:left;
            }
            h5{
                padding-top:11pt;
                color:#000000;
                font-weight:700;
                font-size:11pt;
                padding-bottom:2pt;
                font-family:"Calibri";
                line-height:1.1500000000000001;
                page-break-after:avoid;
                orphans:2;
                widows:2;
                text-align:left;
            }
            h6{
                padding-top:10pt;
                color:#000000;
                font-weight:700;
                font-size:10pt;
                padding-bottom:2pt;
                font-family:"Calibri";
                line-height:1.1500000000000001;
                page-break-after:avoid;
                orphans:2;
                widows:2;
                text-align:left;
            }
        </style>
    </head>
    <body class="c33 doc-content">
        <p class="c23 c4 c26 c29">
            <span class="c9">
                Animotive Terms and Conditions of Subscription
            </span>
        </p>
        <p class="c23 c4 c29 c26 c3">
            <span class="c9">
            </span>
        </p>
        <p class="c23 c4">
            <span>
                Please read these terms and conditions (
            </span>
            <span class="c16">
                Terms
            </span>
            <span class="c1">
                ) carefully before subscribing to our Services. The Customer acknowledges that by subscribing to the Services, it agrees to be bound by these Terms. These Terms apply to the subscription by the Customer and supply of Services by the Supplier to the Customer, whether in connection with a paid subscription or a free trial. They apply to the exclusion of any other terms that the Customer may seek to impose or incorporate, or which are implied by law, trade custom, practice or course of dealing.
            </span>
        </p>
        <p class="c23 c4 c3">
            <span class="c1">
            </span>
        </p>
        <p class="c23 c4">
            <span class="c21">
                The Customer&rsquo;s attention is particularly drawn to the provisions of clause 12 (Limitation of liability).
            </span>
        </p>
        <p class="c23 c4 c29 c26 c3">
            <span class="c21">
            </span>
        </p>
        <ol class="c5 lst-kix_list_7-0 start" start="1">
            <li class="c6 c4 li-bullet-0">
                <span class="c9">
                    Interpretation
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_8-1 start" start="1">
            <li class="c14 c4 li-bullet-1">
                <span class="c9">
                    In these Terms:-
                </span>
            </li>
        </ol>
        <p class="c0">
            <span class="c9">
                Accepted Subscription:
            </span>
            <span class="c1">
                means a Subscription which has been accepted by the Supplier pursuant to clause 2.2, as may have been amended by agreement between the Supplier and Customer.
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Animotive Content
            </span>
            <span class="c1">
                means any content or materials accessible through or available on the Platform, other than Customer Content and Created Content;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Annual Turnover
            </span>
            <span class="c1">
                &nbsp;means the total revenue of the Customer from the last 12 calendar months generated from the sale of goods or provision of services before any deductions are made for returned goods, allowances for damaged or missing goods, and any discounts allowed;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Commencement Date
            </span>
            <span class="c1">
                &nbsp;shall be as set out in the Subscription;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Commercial Use
            </span>
            <span class="c1">
                &nbsp;refers to any use of the Services that involves direct or indirect financial gain, including but not limited to the sale of goods or services, advertising, sponsorship, and the promotion of a company or product;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Confidential Information
            </span>
            <span class="c1">
                means any information (in any media and whether or not stated to be confidential or marked as such) data, designs, drawings, documents, specifications, software listings, source or object codes relating to the Supplier, any Intellectual Property Rights, and any information which relates to the business, affairs, activities, financial position, trade secrets, know how, personnel or suppliers of any party and the Software;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Contract
            </span>
            <span class="c1">
                means the contract between the Supplier and the Customer for the subscription and supply of the Services and incorporating the details set out in the Accepted Subscription, these Terms and the Privacy Policy;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Created Content
            </span>
            <span class="c1">
                means the 3D file formats, video file formats and animation data files downloaded by the Customer and containing videos/audio/images created by the Customer via the Platform in accordance with these Terms;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Customer
            </span>
            <span class="c1">
                &nbsp;means the person who purchases the Services from the Supplier;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Customer Content
            </span>
            <span class="c1">
                means any content and/or materials made available by the Customer and/or its Users through the Platform or through use of the Software, including any contributions made by Users, and any substantial amendments or changes to other Animotive Content but excluding the Created Content;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Customer Materials
            </span>
            <span class="c1">
                means any records, data and any other information and related materials directly or indirectly made available, provided by or input by the Customer and/or the Users for the purpose of using the Services or facilitating the Customer&#39;s use of the Services;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Data Protection Legislation
            </span>
            <span class="c1">
                means all applicable data protection and privacy legislation and regulatory requirements in force from time to time in the UK including without limitation the Data Protection Act 2018 (and regulations made thereunder); the UK GDPR as defined in section 3(1) (as supplemented by section 205(4)) of the Data Protection Act 2018 and the Privacy and Electronic Communications Regulations 2003 (SI 2003/2426) (as amended)
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Controller, processor, data subject, personal data, personal data breach, processing and appropriate technical measures
            </span>
            <span class="c1">
                &nbsp;shall have the meanings set out in the Data Protection Legislation;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Free Tier
            </span>
            <span class="c1">
                &nbsp;as set out in clause 3.1.1; &nbsp; &nbsp;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Indie Tier
            </span>
            <span class="c1">
                &nbsp;as set out in clause 3.1.2;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Initial Term
            </span>
            <span class="c1">
                means the initial term of subscription as set out in the Accepted Subscription;
            </span>
        </p>
        <p class="c0" id="h.gjdgxs">
            <span class="c9">
                Intellectual Property Rights
            </span>
            <span class="c1">
                patents, utility models, rights to inventions, copyright and neighbouring and related rights, moral rights, trademarks and service marks, business names and domain names, rights in get-up and trade dress, goodwill and the right to sue for passing off or unfair competition, rights in designs, rights in computer software, database rights, rights to use, and protect the confidentiality of, confidential information (including know-how and trade secrets), and all other intellectual property rights, in each case whether registered or unregistered and including all applications and rights to apply for and be granted, renewals or extensions of, and rights to claim priority from, such rights and all similar or equivalent rights or forms of protection which subsist or will subsist now or in the future in any part of the world;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Modification
            </span>
            <span class="c1">
                &nbsp;means any new version of the Software and any release of the Software which corrects faults, adds functionality or otherwise amends or upgrades the Software, in each case which the Supplier makes generally available. For the avoidance of doubt, the parties acknowledge that the Supplier is not under any obligation to make Modifications available;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Platform
            </span>
            <span class="c1">
                means the Supplier&rsquo;s online Animotive software application platform (accessible via a PC application or the web), an online collaborative 3D animation production tool, allowing users to embody 3D character and work remotely and simultaneously on the same projects while online;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Privacy Policy
            </span>
            <span class="c1">
                means the Suppliers privacy policy set out at
            </span>
            <span class="c24">
                <a class="c22" href="https://www.google.com/url?q=https://www.animotive.com/privacy-policy&amp;sa=D&amp;source=editors&amp;ust=1711122188847621&amp;usg=AOvVaw2_tj0JjktYORuIBPz1-h9_">
                    https://www.animotive.com/privacy-policy
                </a>
            </span>
            <span class="c1">
                ;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Pro Tier &nbsp;
            </span>
            <span class="c1">
                as set out in clause 3.1.3;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Renewal Date
            </span>
            <span class="c1">
                is as set out in clause 5.2 below.
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Services
            </span>
            <span class="c1">
                &nbsp;means the services to be supplied by the Supplier to the Customer in relation to the Platform pursuant to a Contract and as set out in the Accepted Subscription and references to the Services shall include a reference to any part(s) of the Services;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Software
            </span>
            <span class="c1">
                means the software to be supplied by the Supplier as part of the Services, together with any related documentation and/or user manual and any Modifications and references to the Software includes reference to any part(s) thereof;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Subscription
            </span>
            <span class="c1">
                means the Customer&rsquo;s application to subscribe for the Services under these Terms, in each case via the Website unless otherwise agreed;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Subscription Fee
            </span>
            <span class="c1">
                &nbsp;means the charges specified in a Subscription for the provision of the Services or as otherwise communicated to the Customer in writing by the Supplier from time to time;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Subscription Tier
            </span>
            <span class="c1">
                means either Free Tier, Indie Tier or Pro Tier, as shall be set out in the Subscription;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Supplier
            </span>
            <span class="c1">
                &nbsp;means Animotive Limited, a company incorporated in Northern Ireland with company number NI663613, whose registered office is at 2 Crescent Gardens, Belfast, Northern Ireland, BT7 1NS;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Term
            </span>
            <span class="c1">
                means the Initial Term and thereafter from month to month or year to year (as may be set out in the Subscription), subject to earlier termination in accordance with these Terms;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Total Investment
            </span>
            <span class="c1">
                &nbsp;means any form of financial contributions received by a Customer in the previous 12 calendar month period, including but not limited to equity investments, loans, and financial grants, intended for the startup and/or operation of their business.
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Users
            </span>
            <span class="c1">
                &nbsp;those employees, agents and independent contractors of the Customer who are authorised by the Customer to use the Services pursuant to the Accepted Subscription and in accordance with these Terms;
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Website
            </span>
            <span class="c1">
                means the Supplier&rsquo;s website at www.animotive.com
            </span>
        </p>
        <p class="c0">
            <span class="c9">
                Working Day
            </span>
            <span class="c1">
                &nbsp;means a day other than Saturday or Sunday or a public holiday in Northern Ireland;
            </span>
        </p>
        <p class="c0 c3">
            <span class="c1">
            </span>
        </p>
        <ol class="c5 lst-kix_list_8-1" start="2">
            <li class="c14 c4 li-bullet-1">
                <span class="c1">
                    In these Terms a reference to:-
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_10-2 start" start="1">
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    &nbsp;a clause or paragraph is a reference to a clause or paragraph of these Terms;
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    &nbsp;a person includes a natural person, a corporate or unincorporated body (whether or &nbsp; &nbsp;not having separate legal personality);
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    &nbsp;a company shall include any company, corporation or other body corporate, wherever and however incorporated or established;
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    &nbsp;written or writing and any similar expression includes a reference to any communication effected by electronic mail, or similar means; and
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    &nbsp;a statute or statutory provision is a reference to it as amended, extended or re-enacted from time to time. A reference to a statute or statutory provision includes all subordinate legislation made under that statute or statutory provision.
                </span>
            </li>
        </ol>
        <p class="c23 c4 c3 c27">
            <span class="c1">
            </span>
        </p>
        <ol class="c5 lst-kix_list_10-1 start" start="1">
            <li class="c14 c4 li-bullet-1">
                <span class="c1">
                    In these Terms:-
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_10-2 start" start="1">
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    unless the context otherwise requires, words in the singular shall include the plural and in the plural shall include the singular;
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    unless the context otherwise requires, a reference to one gender shall include a reference to the other genders;
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    Any obligation on a party not to do something includes an obligation not to allow that thing to be done;
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    unless the context otherwise requires, any reference to European Union law that is directly applicable or directly effective in the UK at any time is a reference to it as it applies in Northern Ireland from time to time including as retained, amended, extended, re-enacted or otherwise given effect on or after 11pm on 31 January 2020; and
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    any words following the terms including, include, in particular, for example or any similar expression shall be construed as illustrative and shall not limit the sense of the words, description, definition, phrase or term preceding those terms.
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_10-1" start="2">
            <li class="c14 c4 li-bullet-3">
                <span class="c1">
                    Each Contract shall be binding on, and enure to the benefit of, the parties to the relevant Contract and their respective personal representatives, successors and permitted assigns, and references to any party shall include that party&#39;s personal representatives, successors and permitted assigns.
                </span>
            </li>
            <li class="c14 c4 li-bullet-4">
                <span class="c1">
                    The headings in these Terms are for convenience only and shall not affect its interpretation.
                </span>
            </li>
        </ol>
        <p class="c0 c3">
            <span class="c1">
            </span>
        </p>
        <ol class="c5 lst-kix_list_2-0 start" start="2">
            <li class="c6 c4 li-bullet-0">
                <span class="c9">
                    Contract
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_2-1 start" start="1">
            <li class="c14 c4 li-bullet-3">
                <span class="c1">
                    All Services are provided pursuant to one or more Contracts. The Subscription constitutes an offer by the Customer to purchase Services in accordance with these Terms.
                </span>
            </li>
            <li class="c14 c4 li-bullet-1">
                <span class="c1">
                    A Subscription shall only be deemed to be accepted when the Supplier issues written acceptance of the Subscription (as may have been amended by agreement between the Client and Supplier) at which point and on which date a Contract shall come into existence. Each Accepted Subscription shall form a separate Contract;
                </span>
            </li>
            <li class="c14 c4 li-bullet-4">
                <span class="c1">
                    The Contract contains the entire agreement between the parties with respect to its subject matter and may not be varied except by a written agreement between the parties. If there is any conflict between any of the provisions of these Terms and an Accepted Subscription, the terms of the Accepted Subscription shall take precedence.
                </span>
            </li>
            <li class="c14 c4 li-bullet-3">
                <span class="c1">
                    These Terms apply to each Contract to the exclusion of any other terms that the Customer seeks to impose or incorporate or which are implied by law trade custom practice or course of dealing.
                </span>
            </li>
            <li class="c14 c4 li-bullet-1">
                <span class="c1">
                    These Terms apply to all the Supplier&rsquo;s contracts and any variation to these Terms and any representations shall have no effect unless expressly agreed in writing by an officer of the Supplier.
                </span>
            </li>
            <li class="c14 c4 li-bullet-4">
                <span class="c1">
                    The Supplier reserves the right to amend the Services if necessary to comply with any applicable law or regulatory requirement, or if the amendment will not materially affect the nature or quality of the Services.
                </span>
            </li>
            <li class="c14 c4 li-bullet-4">
                <span class="c1">
                    The Supplier may, in its sole discretion, make changes to these Terms from time to time. Any changes the Supplier makes will become effective when it posts a modified version to the Website. If the Supplier makes any material changes, it will also notify the Customer by email. If the Customer continues using the Services after any changes, it means the Customer has accepted them. If the Customer does not agree to any changes, it must stop using the Services, and can terminate its account with one month&rsquo;s notice (to terminate at the end of the following month). A pro-rata refund shall be issued by the Supplier of any portion of the Subscription Fee already received by the Supplier and applicable to any period after the Contract has terminated. It is the Customer&rsquo;s obligation to ensure that it has read, understand and agree to the latest version of the Terms.
                </span>
            </li>
        </ol>
        <p class="c0 c3">
            <span class="c1">
            </span>
        </p>
        <ol class="c5 lst-kix_list_2-0" start="3">
            <li class="c6 c4 li-bullet-5">
                <span class="c9">
                    Subscription Tiers and Usage Restrictions
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_2-1 start" start="1">
            <li class="c14 c4 li-bullet-3">
                <span>
                    The Services are available under the Subscription Tiers to accommodate the diverse needs and capacities of the Customers. Each Subscription Tier has specific restrictions to ensure fairness and appropriate use as set out in clauses 3.1-3.3 below. Customers must adhere to the eligibility criteria of their chosen Subscription Tier. Misrepresentation of eligibility or misuse of Subscription Tiers shall constitute a material breach of the Contract under clause 5.5 below .
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_2-2 start" start="1">
            <li class="c23 c4 c25 li-bullet-6">
                <span class="c16">
                    Free Tier:
                </span>
                <span class="c1">
                    &nbsp;shall apply to Customers (i) using the Services for non-commercial, personal, educational, or other non-revenue generating activities; and (ii) whose Annual Turnover and/or Total Investment is less than $100,000. Commercial Use shall be strictly prohibited; &nbsp; &nbsp;
                </span>
            </li>
            <li class="c23 c25 c4 li-bullet-7">
                <span class="c16">
                    Indie Tier:
                </span>
                <span class="c1">
                    &nbsp;shall apply to Customers whose Annual Turnover and/or Total Investment does not exceed $100,000 USD and who are using the Services either wholly or partly for Commercial Use.
                </span>
            </li>
            <li class="c23 c25 c4 li-bullet-7">
                <span class="c16">
                    Pro Tier:
                </span>
                <span class="c1">
                    &nbsp;shall apply to all Customers with an Annual Turnover and/or Total Investment in excess of $100,000.
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_2-1" start="2">
            <li class="c14 c4 li-bullet-4">
                <span>
                    Customers must declare their Subscription Tier eligibility annually, providing proof of Annual Turnover or Total Investment when requested.
                </span>
            </li>
            <li class="c14 c4 li-bullet-3">
                <span>
                    Customers can upgrade or downgrade their Subscription Tier at any time, subject to clauses 3.4 and 3.6 below.
                </span>
            </li>
            <li class="c14 c4 li-bullet-1">
                <span>
                    In the event that an upgrade occurs in the middle of a billing period (as set out in clause 6.2 below), the Contract shall be automatically terminated and a new Contract entered into for the upgraded Subscription Tier in accordance with these Terms and a Subscription Fee paid for such new Contract in full. A pro-rata refund shall be issued by the Supplier of any portion of the Subscription Fee already received by the Supplier in respect of the original Contract and applicable to any period after the original Contract has terminated.
                </span>
            </li>
            <li class="c4 c14 li-bullet-4">
                <span>
                    Customers exceeding the Indie Tier&#39;s Annual Turnover and/or Total Investment shall be automatically upgraded to the Pro Tier, as set out in clause 3.4 above.
                </span>
            </li>
        </ol>
        <p class="c0">
            <span>
                A downgrade request must be made at least 24 hours before the end of the Initial Term or Renewal Date (as applicable). Provided the Customer has given such notice, the downgrade shall only take effect on expiry of the Initial Term or Renewal Date (as applicable). If less notice is given, the cancellation will be effective from the following Renewal Date.
            </span>
        </p>
        <ol class="c5 lst-kix_list_2-1" start="6">
            <li class="c14 c4 li-bullet-1">
                <span>
                    The Supplier reserves the right to audit Customers&#39; financial statements to verify declared Annual Turnover or Total Investment. Customers will be notified in advance of any audit and are expected to provide reasonable assistance. &nbsp;Failure to provide reasonable assistance may result in immediate termination of the Contract and loss of access to the Services.
                </span>
            </li>
        </ol>
        <p class="c0 c3">
            <span class="c1">
            </span>
        </p>
        <p class="c0 c3">
            <span class="c1">
            </span>
        </p>
        <p class="c0 c3">
            <span class="c9">
            </span>
        </p>
        <ol class="c5 lst-kix_list_2-0" start="4">
            <li class="c6 c4 li-bullet-8">
                <span class="c9">
                    Provision and usage of the Services
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_12-1 start" start="1">
            <li class="c15 c4 li-bullet-9">
                <span class="c1">
                    The Customer shall not permit any other persons other than the Users to use the Services unless the Customer has obtained prior written consent from the Supplier. All Users must be over thirteen years of age.
                </span>
            </li>
            <li class="c15 c4 li-bullet-10">
                <span class="c1">
                    The Customer shall not, nor permit or allow the Users or others to:-
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_14-2 start" start="1">
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    permit, facilitate or assist a third party (other than the Users) to use or access the Services; or
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    make the Software/Platform available to or use the Services on behalf of or for the benefit of any third party (other than the Users) in any way whatsoever; or
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    reverse engineer, decompile, disassemble, amend, modify, vary, adapt, translate, create derivative works based on the Services, or perform any similar type of operation on the Software for any purpose; or
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    sub-licence, assign, rent, lease or transfer the licence, the rights granted to the Customer, or the Software or make or distribute copies of the Software or any Animotive Content except as permitted by the relevant Contract; or
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    vary, delete or obscure any notices of proprietary rights or any product identification or restrictions or watermarks; or
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    use the Services to store or transmit infringing, libellous or otherwise unlawful or tortious material or to store or transmit material in violation of third party privacy rights; or
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    access all or any part of the Services in order to build a product or service which competes with the Services; or
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    carry out itself, or request, permit or authorise any third party to provide any support or maintenance services in respect of the Services unless it has obtained the Supplier&rsquo;s prior written consent; or
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    use the Animotive Content or Created Content in a way that competes with the Supplier, including distributing through image library, stock video, 3D Model online market, or any similar service;
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    use the Animotive Content in the following situations or applications:
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_12-3 start" start="1">
            <li class="c11 c4 li-bullet-11">
                <span class="c1">
                    In-app content purchase;
                </span>
            </li>
            <li class="c11 c4 li-bullet-11">
                <span class="c1">
                    In-app character generation;
                </span>
            </li>
            <li class="c4 c11 li-bullet-12">
                <span class="c1">
                    Character generation API licensing;
                </span>
            </li>
            <li class="c11 c4 li-bullet-11">
                <span class="c1">
                    As embedded content in the AP or online service;
                </span>
            </li>
            <li class="c11 c4 li-bullet-13">
                <span class="c1">
                    AI training/ deep learning;
                </span>
            </li>
            <li class="c11 c4 li-bullet-14">
                <span class="c1">
                    3D Print for sale or for massive redistribution; create a mould for mass production.
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_12-1" start="3">
            <li class="c4 c15 li-bullet-15">
                <span class="c1">
                    The Customer shall be responsible for monitoring any Customer Content and Customer Materials, including without limitation any comments made by its Users and shall be responsible for deleting anything which does not comply with clause 4.4 or otherwise comply with the relevant Contract. The Supplier shall not be responsible or liable for the content of any Customer Content or Customer Materials. The Supplier does not control the submission of content but reserves the right (without any obligation to do so) to monitor, delete, move and edit any Animotive Content, Customer Content or Customer Materials.
                </span>
            </li>
            <li class="c15 c4 li-bullet-15">
                <span class="c1">
                    The Customer shall ensure that any Customer Content and/or Customer Materials shall not and that it shall not (nor permit or allow the Users or others to) use the Services in such a way as shall:-
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_15-2 start" start="1">
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    infringe or violate someone else&rsquo;s rights; or
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    contain or link to any unlawful, threatening, harassing, libellous, harmful, vulgar, obscene, abusive, defamatory, indecent material, material which is deliberately intended to upset other users or which is otherwise objectionable or breaches any law; or
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    encourage conduct that constitutes a criminal offence or otherwise breaches any applicable laws regulations or codes of practice; or
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    contain any material which the Customer does not have permission to use (including material which may be protected by copyright, trademarks, database rights or any other form of Intellectual Property Rights); or
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    contain viruses, malicious code, or any other components with harmful or contaminating effects; or
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    contain unauthorised commercial communications (such as spam); or
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    contain false or misleading information; or
                </span>
            </li>
            <li class="c2 c4 li-bullet-2">
                <span class="c1">
                    be used to bully or harass anyone.
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_15-1 start" start="1">
            <li class="c15 c4 li-bullet-9">
                <span class="c1">
                    The Customer shall during the Term effect and maintain adequate security measures to safeguard the Software and the Services from access or use by any unauthorised person, shall retain same and all copies thereof under the Customer&rsquo;s effective control and shall maintain a full and accurate record of the Customer&rsquo;s copying of any materials provided and produce such record to the Supplier on request from time to time.
                </span>
            </li>
            <li class="c15 c4 li-bullet-10">
                <span class="c1">
                    Where the Order sets out a maximum number of Users, where the maximum number of Users is exceeded the Customer shall pay an additional charge for each additional User.
                </span>
            </li>
            <li class="c15 c4 li-bullet-9">
                <span class="c1">
                    The Customer shall notify the Supplier immediately if it becomes aware of any unauthorised use of the whole or any part of the Software and/or Services by any person.
                </span>
            </li>
            <li class="c15 c4 li-bullet-10">
                <span class="c1">
                    The Supplier warrants to the Customer that the Services will be provided using reasonable care and skill. The Customer acknowledges that no service levels are applicable to the Services and that the Supplier does not warrant or guarantee that the Platform, or any Animotive Content, will always be available or be uninterrupted.
                </span>
            </li>
            <li class="c15 c4 li-bullet-16">
                <span class="c1">
                    The Customer shall ensure that its network and systems comply with the relevant specifications provided by the Supplier from time to time.
                </span>
            </li>
            <li class="c15 c4 li-bullet-17">
                <span class="c1">
                    Access to the Service may occasionally be restricted to allow for repairs, maintenance or the introduction of new facilities or services. The parties agree and acknowledge that the Supplier is unable to guarantee or predict the speed of operation of software, tools or download times.
                </span>
            </li>
            <li class="c15 c4 li-bullet-15">
                <span class="c1">
                    The Software may cause the Customer&rsquo;s computer, without notice, to automatically connect to the Internet and to communicate with the Website for purposes such as licence validation and providing the Customer with additional information, features, or functionality. Unless otherwise specified the Privacy Policy shall apply in relation to information collected and transmitted by the Supplier.
                </span>
            </li>
        </ol>
        <p class="c0 c3">
            <span class="c1">
            </span>
        </p>
        <ol class="c5 lst-kix_list_15-0 start" start="2">
            <li class="c6 c4 li-bullet-0">
                <span class="c9">
                    Term and Termination
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1 start" start="1">
            <li class="c7 c4 li-bullet-0">
                <span class="c1">
                    A Contract shall commence on the Commencement Date and shall continue for the Term subject to earlier termination in accordance with the Contract.
                </span>
            </li>
            <li class="c7 c4 li-bullet-18">
                <span class="c1">
                    Unless otherwise agreed in writing, after expiry of its Initial Term, a Contract shall continue from month to month or year to year (as may be set out in the Order). The Customer must cancel at least 24 hours before the next date its subscription is to automatically renew (
                </span>
                <span class="c9">
                    Renewal Date
                </span>
                <span class="c1">
                    ), in order to avoid incurring the following month&rsquo;s or year&rsquo;s payment (as applicable).
                </span>
            </li>
            <li class="c13 c4 li-bullet-19">
                <span class="c1">
                    Provided the Customer has given the notice set out in clause 5.2 above, its cancellation will be effective from the Renewal Date. If less notice is given, the cancellation will be effective from the following Renewal Date. All payment obligations hereunder are non-cancellable and all fees paid are non-refundable unless otherwise set out herein or agreed by the Supplier in each case.
                </span>
            </li>
            <li class="c13 c4 li-bullet-20">
                <span class="c1">
                    Without affecting any other right or remedy available to it, the Supplier may terminate a Contract with immediate effect by giving written notice to the Customer if:-
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-2 start" start="1">
            <li class="c8 c4 li-bullet-21">
                <span class="c1">
                    the Customer fails to pay the Subscription Fee in accordance with the relevant Contract (time being of the essence); or
                </span>
            </li>
            <li class="c8 c4 li-bullet-21">
                <span class="c1">
                    the Customer takes any step or action in connection with its entering administration, provisional liquidation or any composition or arrangement with its creditors (other than in relation to a solvent restructuring), being wound up (whether voluntarily or by order of the court, unless for the purpose of a solvent restructuring), having a receiver appointed to any of its assets or ceasing to carry on business or, if the step or action is taken in another jurisdiction, in connection with any analogous procedure in the relevant jurisdiction; or
                </span>
            </li>
            <li class="c8 c4 li-bullet-22">
                <span class="c1">
                    the Customer is unable to pay its debts as they fall due; or
                </span>
            </li>
            <li class="c8 c4 li-bullet-23">
                <span class="c1">
                    the Customer suspends, or threatens to suspend, or ceases or threatens to cease to carry on all or a substantial part of its business or
                </span>
            </li>
            <li class="c8 c4 li-bullet-21">
                <span class="c1">
                    there is an upgrade or downgrade of Subscription Tier in accordance with clause 3 above.
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1" start="5">
            <li class="c13 c4 li-bullet-20">
                <span class="c1">
                    The Supplier may (without limiting any other remedy) at any time terminate a Contract with immediate effect by giving written notice to the Customer if the Customer commits any material breach of that Contract and (if capable of remedy) fails to remedy the material breach within 14 days after being required by written notice to do so.
                </span>
            </li>
            <li class="c13 c4 li-bullet-20">
                <span class="c1">
                    Without affecting any other right or remedy available to it, the Supplier may suspend the supply of Services under a Contract between the Customer and Supplier if the Customer fails to pay any amount due under that Contract on the due date for payment (time being of the essence), the Customer becomes subject to any of the events listed in clause 5.4 above, or the Supplier reasonably believes that the Customer is about to become subject to any of them.
                </span>
            </li>
            <li class="c13 c4 li-bullet-24">
                <span class="c1">
                    If the Supplier believes that unauthorised or improper use is being made of the Platform or the relevant Subscription Tier, it may at any time, in its sole discretion and without notice, take such action as it deems appropriate, including without limitation, blocking or deleting Customer Content, suspending or terminating the Customer&rsquo;s account or access rights or blocking access from the Customer&rsquo;s ID in whole or in part.
                </span>
            </li>
            <li class="c13 c4 li-bullet-25">
                <span class="c1">
                    The Customer may terminate a Contract by giving written notice to the Supplier if the Supplier commits a material breach of that Contract and (if capable of remedy) fails to remedy the breach within 30 days after being required by written notice to do so. The Supplier shall be liable to refund to the Customer the portion of the Subscription Fee as represents the unexpired term calculated on a monthly pro rata basis and this shall be the Customer&rsquo;s sole remedy.
                </span>
            </li>
            <li class="c13 c4 li-bullet-19">
                <span class="c1">
                    Failure or delay by the Supplier in enforcing or partially enforcing any provision of a Contract will not be construed as a waiver of any of its rights under the Contract.
                </span>
            </li>
            <li class="c13 c4 li-bullet-20">
                <span class="c1">
                    Any waiver by the Supplier of any breach of, or any default under, any provision of a Contract will not be deemed a waiver of any subsequent breach or default and will in no way affect the other terms.
                </span>
            </li>
            <li class="c13 c4 li-bullet-26">
                <span class="c1">
                    The termination of a Contract for any reason shall not affect any accrued right or liability of either party and shall not affect any other right or remedy of either party. Each right or remedy is without prejudice to any other right or remedy whether under these Terms or not.
                </span>
            </li>
            <li class="c13 c4 li-bullet-25">
                <span class="c1">
                    The Supplier shall be entitled to terminate a Contract at any time without cause by giving to the Customer one month&rsquo;s written notice provided that upon termination of the Contract by the Supplier in accordance with this clause the Supplier shall be liable to refund to the Customer the portion of the Subscription Fee as represents the unexpired term calculated on a monthly pro rata basis. The Supplier shall not be liable to refund or otherwise pay to the Customer any sums other than those stated to be payable under this clause.
                </span>
            </li>
            <li class="c13 c4 li-bullet-26">
                <span class="c1">
                    On termination of this agreement for any reason:
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-2 start" start="1">
            <li class="c8 c4 li-bullet-27">
                <span class="c1">
                    the termination of a Contract shall not affect any payment which is owing by either party to the other or any provision of these Terms which is expressed to come into force or continue in force on or after termination;
                </span>
            </li>
            <li class="c8 c4 li-bullet-28">
                <span class="c1">
                    other than any Created Content which it has downloaded, the Customer shall no longer have access to any Animotive Content, or any Customer Content and Customer Materials stored through the Services pursuant to that Contract. It is the Customer&rsquo;s responsibility to ensure any Customer Materials and Customer Content are appropriately saved or backed up elsewhere both on an ongoing basis during the Term and on termination or expiry of a Contract (subject to clause 5.13.3 below). The Customer acknowledges that any Customer Content and Customer Materials stored through the Services shall be retained by the Supplier for a period of 12 months from expiry/termination of the Contract and shall be irrevocably deleted thereafter.
                </span>
            </li>
            <li class="c8 c4 li-bullet-29">
                <span class="c1">
                    the Customer shall and shall procure that the Users immediately cease to use the Services provided pursuant to that Contract, other than the Created Content. The Customer shall and shall procure that the Users delete the Software, any cache or store of Animotive Content held by it and any Confidential Information and Personal Data obtained or produced in the course of use of the Services pursuant to that Contract (in whatever form and whether or not same is incorporated into other documentation) and if requested by the Supplier shall certify in writing that this has been done.
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-0 start" start="5">
            <li class="c6 c4 li-bullet-0">
                <span class="c9">
                    Payment
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1 start" start="1">
            <li class="c7 c4 li-bullet-30">
                <span class="c1">
                    As consideration for the provision of the Services, the Customer shall pay the Subscription Fee in accordance with this clause 6.
                </span>
            </li>
            <li class="c7 c4 li-bullet-0">
                <span class="c1">
                    Payment for the Services is in advance. The first payment will be taken upon notice of the Accepted Subscription (or immediately on expiry of any &lsquo;free-trial&rsquo; period) and subsequent payments will be taken monthly or yearly in advance, in accordance with the Accepted Subscription.
                </span>
            </li>
            <li class="c7 c4 li-bullet-0">
                <span class="c1">
                    If, at any time whilst using the Services, the Customer exceeds the amount of disk storage space specified in the Accepted Subscription, the Supplier shall charge the Customer, and the Customer shall pay, the Supplier&#39;s then current excess data storage fees detailed on the Website.
                </span>
            </li>
            <li class="c7 c4 li-bullet-0">
                <span class="c1">
                    The Customer&rsquo;s payment will be processed by a third party provider and are subject to the relevant third party&rsquo;s terms and conditions in relation thereto, which the Customer agrees to be bound by. The third party provider is currently [Paddle]. Any change of provider shall be notified to the Customer in advance.
                </span>
            </li>
            <li class="c12 c4 li-bullet-31">
                <span>
                    All amounts payable by the Customer to the Supplier under a Contract are exclusive of (i) taxes, levies, duties or similar governmental assessments of any nature, including, for example, value-added, sales, use or withholding taxes, assessable by any jurisdiction (
                </span>
                <span class="c16">
                    Taxes
                </span>
                <span class="c1">
                    ); and (ii) currency conversion fees. Where Taxes or currency conversion fees are payable in respect of some or all of the Services the Customer shall pay such additional amounts in respect of same, at the applicable rate, at the same time as payment of the Subscription Fee.
                </span>
            </li>
            <li class="c12 c4 li-bullet-32">
                <span class="c1">
                    The Supplier may review and increase the Subscription Fee from time to time after the expiry of the Initial Term. The Supplier will give at least 30 days&rsquo; written notice of any increase to the Customer and the next payment will be at the new level.
                </span>
            </li>
            <li class="c12 c4 li-bullet-33">
                <span class="c1">
                    All payments payable to the Supplier under a Contract shall become due immediately upon termination of the Contract despite any other provision.
                </span>
            </li>
            <li class="c12 c4 li-bullet-34">
                <span class="c1">
                    The Customer shall make all payments due under a Contract without any deduction whether by way of set-off, counterclaim, discount, abatement or otherwise unless the Customer has a valid court order requiring an amount equal to such deduction to be paid by the Supplier to the Customer.
                </span>
            </li>
            <li class="c12 c4 li-bullet-35">
                <span class="c1">
                    If the Customer fails to pay in full on the due date for payment any amount which is payable to the Supplier pursuant to a Contract then, without limiting any other rights the Supplier may have, the amount outstanding shall bear interest, both before and after any judgment, at 5% above the Bank of England base rate from time to time accruing on a daily basis from the due date until payment is made in full.
                </span>
            </li>
            <li class="c12 c4 li-bullet-36">
                <span class="c1">
                    If the Supplier has to refer unpaid invoices to its legal representatives as well as recovering the invoiced amount and interest it will seek to recover any legal fees incurred.
                </span>
            </li>
        </ol>
        <p class="c0 c3">
            <span class="c1">
            </span>
        </p>
        <ol class="c5 lst-kix_list_22-0" start="6">
            <li class="c4 c6 li-bullet-0">
                <span class="c9">
                    Ownership and Rights
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1 start" start="1">
            <li class="c7 c4 li-bullet-37">
                <span class="c1">
                    The Software, the Platform, the Animotive Content and all Intellectual Property Rights in respect of same or arising out of or in connection with the Services (other than in respect of the Customer Content) shall belong exclusively to the Supplier. Nothing in any Contract shall function to transfer any Intellectual Property Rights to the Customer and all rights not expressly granted to the Customer are reserved by the Supplier.
                </span>
            </li>
            <li class="c7 c4 li-bullet-0">
                <span class="c1">
                    Provided that the Customer has paid the applicable Subscription Fee, the Supplier grants to the Customer, a worldwide, non-exclusive, royalty-free licence:
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-2 start" start="1">
            <li class="c8 c4 li-bullet-38">
                <span class="c1">
                    during the Term to use (and permit the Users to use) the Services and the Software subject to any maximum number of Users and data storage and transfer limitations. The Customer shall be responsible for all Users&rsquo; compliance with all Contracts and is liable for the acts and omissions of all Users; and
                </span>
            </li>
            <li class="c8 c4 li-bullet-22">
                <span class="c1">
                    in perpetuity to use any Intellectual Property Rights of the Supplier as contained in the Created Content and for the purposes of exploiting the Created Content only and subject to the usage restrictions with regard the Customer&rsquo;s applicable Subscription Tier (provided always that such Created Content has been created in accordance with these Terms and not otherwise).
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1" start="3">
            <li class="c7 c4 li-bullet-5">
                <span class="c1">
                    The Customer, as legal and beneficial owner, hereby irrevocably and unconditionally grants to the Supplier a worldwide, non-exclusive, royalty free licence to access and use any Customer Content and Customer Materials and any Intellectual Property Rights in respect of same during the Term for the purposes of providing the Services (which includes the right to collect, duplicate, rearrange, adapt, store, sort, process, analyse, present and use the Customer Materials and Customer Content in conjunction with the Software), complying with any Contract, responding to service or technical problems or Customer requests.
                </span>
            </li>
        </ol>
        <p class="c0 c3">
            <span class="c1">
            </span>
        </p>
        <ol class="c5 lst-kix_list_22-0" start="7">
            <li class="c6 c4 li-bullet-0">
                <span class="c9">
                    Modifications
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1 start" start="1">
            <li class="c7 c4 li-bullet-5">
                <span class="c1">
                    The Supplier will notify the Customer promptly in writing of the issue of any Modification, specifying in what way the Modification differs from the previous version in terms of functionality, performance and compatibility. Unless otherwise agreed, there shall be no increase in the Subscription Fee for Modifications.
                </span>
            </li>
            <li class="c7 c4 li-bullet-37">
                <span class="c1">
                    Customer will accept Modifications in a timely fashion. The Supplier has no obligation to provide maintenance and support services for versions or releases of the Software/Platform that are not the most current versions or releases or for any copy of Software for which all previously issued Modifications have not been installed. The Supplier can also disallow access to versions or releases of the Software/Platform that are not the most current versions or releases at any time.
                </span>
            </li>
        </ol>
        <p class="c4 c3 c23">
            <span class="c9">
            </span>
        </p>
        <ol class="c5 lst-kix_list_22-0" start="8">
            <li class="c6 c4 li-bullet-5">
                <span class="c9">
                    Warranties and Undertakings
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1 start" start="1">
            <li class="c4 c7 li-bullet-5">
                <span class="c1">
                    The Customer hereby undertakes, agrees and warrants as follows:-
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-2 start" start="1">
            <li class="c8 c4 li-bullet-39">
                <span class="c1">
                    Subject to clause 9.1.2 below, that the Customer Content does not contain any Personal Data and that the Customer shall protect Personal Data in accordance with the principles and provisions defined in the Data Protection Legislation and will ensure the reliability of its staff and Users who have access to data (and that all necessary steps and procedures have been undertaken to anonymise data where appropriate); and
                </span>
            </li>
            <li class="c8 c4 li-bullet-28">
                <span class="c1">
                    That any authors of the Customer Content and Customer Materials have given their consent to such publication, use and processing; and
                </span>
            </li>
            <li class="c8 c4 li-bullet-40">
                <span class="c1">
                    it owns or has obtained valid licences to use any Intellectual Property Rights necessary for the fulfilment of its obligations hereunder and otherwise in respect of the Customer Content and Customer Materials including without limitation the obligations under clause 7; and
                </span>
            </li>
            <li class="c8 c4 li-bullet-41">
                <span class="c1">
                    that the Customer Content and Customer Materials will not infringe any Intellectual Property Rights and it is legal to use same as envisaged by this Agreement; and
                </span>
            </li>
            <li class="c4 c8 li-bullet-42">
                <span class="c1">
                    that it has (and will continue to have) all necessary licences, rights, consents, and permissions which are required to grant the licence in clause 7.3; and
                </span>
            </li>
            <li class="c8 c4 li-bullet-43">
                <span class="c1">
                    that it shall and shall procure that the Users shall comply with all applicable laws, statutes, regulations and codes from time to time in force; and
                </span>
            </li>
            <li class="c8 c4 li-bullet-44">
                <span class="c1">
                    &nbsp;To ensure that, prior to use of the Software and/or Services by the Users all such Users are notified of these Terms and the terms of the relevant Contract;
                </span>
            </li>
            <li class="c8 c4 li-bullet-39">
                <span class="c1">
                    that the signatory to the relevant Contract for and on behalf of the Customer is authorised and fully empowered to execute on its behalf.
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1" start="2">
            <li class="c7 c4 li-bullet-0">
                <span class="c1">
                    The Customer accepts that the Supplier shall have no liability whatsoever for any Customer Content or Customer Materials and that the Customer accepts full responsibility and liability for any Customer Content or Customer Materials.
                </span>
            </li>
            <li class="c7 c4 li-bullet-5">
                <span class="c1">
                    The Customer shall indemnify the Supplier against all claims, costs, demands, actions, expenses (including but not limited to legal costs and disbursements on a solicitor and client basis), losses and damages arising from or incurred by reason of any breach of this clause 9.
                </span>
            </li>
        </ol>
        <p class="c0 c3">
            <span class="c1">
            </span>
        </p>
        <ol class="c5 lst-kix_list_22-0" start="9">
            <li class="c6 c4 li-bullet-0">
                <span class="c9">
                    Data Protection
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1 start" start="1">
            <li class="c7 c4 li-bullet-8">
                <span class="c1">
                    The parties undertake to comply with all applicable requirements of the Data Protection Legislation in so far as same relate to the provisions and obligations of the relevant Contract. This clause is in addition to, and does not relieve, remove or replace a party&rsquo;s obligations or rights under the Data Protection Legislation;
                </span>
            </li>
            <li class="c7 c4 li-bullet-0">
                <span class="c1">
                    Without prejudice to the generality of clause 10.1, the Customer will ensure that it has all necessary and appropriate consents and notices in place to enable lawful transfer of any Personal Data to the Supplier. The Customer shall indemnify and keep the Supplier fully and effectually indemnified from and against any actions, losses, demands, liabilities and expenses (including without limitation any legal costs) arising out of any breach or non-performance by the Customer of this clause 10.
                </span>
            </li>
            <li class="c7 li-bullet-30">
                <span class="c1">
                    The Supplier will only process Personal Data to the extent, and in such a manner, as is necessary for the provision of the Services or in accordance with the Customer&rsquo;s written instructions from time to time, unless required by applicable laws to otherwise process that Personal Data, as further set out below:
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_18-2 start" start="1">
            <li class="c2 li-bullet-2">
                <span class="c9">
                    Duration.
                </span>
                <span class="c1">
                    &nbsp;As between the Supplier and Customer, the duration of the data processing is determined by the duration of the contract and is retained after termination of the contract for a period of 12 months until deleted in accordance with the Supplier&rsquo;s cancellation policy although it may take a further 12 months for all data to roll out of encrypted back ups. The Supplier may retain personal data for a longer period in the event of a complaint or if it reasonably believes there is a prospect of litigation.
                </span>
            </li>
            <li class="c2 li-bullet-2">
                <span class="c9">
                    Purpose.
                </span>
                <span class="c1">
                    &nbsp;The purpose of the data processing is the provision, maintenance, development, analysis, improvement and enhancement of the Services initiated by the Customer from time to time (including without limitation customer and technical support and for internal training/machine learning processes).
                </span>
            </li>
            <li class="c2 li-bullet-2">
                <span class="c9">
                    Nature of the processing:
                </span>
                <span class="c1">
                    &nbsp;Compute, storage and such other services as described in the contract and maintenance, development, analysis, improvement and enhancement of the Services and customer and technical support, and initiated by Customer from time to time.
                </span>
            </li>
            <li class="c2 li-bullet-2">
                <span class="c9">
                    Type of personal data
                </span>
                <span class="c1">
                    : name, email address, technical data such as IP address, browser type and version, location, operating system/platform, usage data on how users use the Services, animation data (including the recorded movement and audio of the Customer).
                </span>
            </li>
            <li class="c2 li-bullet-2">
                <span class="c9">
                    Categories of data subjects:
                </span>
                <span class="c1">
                    &nbsp;The data subjects may include Customer&rsquo;s employees, and Users.
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_21-1 start" start="1">
            <li class="c4 c17 li-bullet-45">
                <span class="c1">
                    For the avoidance of doubt, the Supplier shall be entitled to collect anonymous and/or aggregated data regarding the Customers&rsquo; employees and Users use of the Services, provided that no individual natural person can be identified from such data (&ldquo;Aggregate Data&rdquo;). The Aggregate Data will be used to analyse behaviour, trends and needs and to improve, and enhance the Services and for other development, creation of new features, diagnostic and corrective purposes in connection with the Services. The Supplier shall own all right, title and interest in and to the Aggregate Data and the Supplier shall not be required to process such data in accordance with this clause 11 nor delete such data.
                </span>
            </li>
            <li class="c17 c4 li-bullet-46" id="h.tyjcwt">
                <span class="c1">
                    The Supplier shall also be entitled to use any information submitted by Customers&rsquo; employees, suppliers and end-users to provide further information about the products/services it offers, unless the relevant employee/supplier/end-user has opted out.The Supplier must at all times implement appropriate technical and organisational measures to ensure a level of security appropriate to the risk of accidental or unlawful destruction, loss, alteration, unauthorised disclosure of, or access to the data, and taking into account the nature of the data to be protected having regard to the state of technological development and the cost of implementing any measures. Such measures may include, where appropriate, pseudonymising and encrypting Personal Data, ensuring confidentiality, integrity, availability and resilience of its systems and services, ensuring that availability of and access to Personal Data can be restored in a timely manner after an incident, and regularly assessing and evaluating the effectiveness of the technical and organisational measures adopted by it.
                </span>
            </li>
            <li class="c17 c4 li-bullet-47">
                <span class="c1">
                    The Supplier may only authorise a third party to process the Personal Data if the Supplier enters into a written contract with the subcontractor that contains terms substantially similar to those set out in this clause, in particular, in relation to requiring appropriate technical and organisational data security measures. Subject to the foregoing, the Customer consents to the Supplier appointing sub-processors in connection with providing the Services and provides a general authorisation to engage such sub-processors and the Website lists those engaged by the Supplier from time to time. The Supplier may also disclose Personal Data to third parties where required by a law, court, regulator or supervisory authority or in connection with any possible sale merger or restructuring of all or any part of the Supplier&rsquo;s business or assets and to other companies in its group.
                </span>
            </li>
            <li class="c17 c4 li-bullet-48">
                <span class="c1">
                    The Supplier will reasonably assist the Customer, at the Customer&rsquo;s cost, in responding to any reasonable request from a Data Subject and in ensuring compliance with its obligations under the Data Protection Legislation with respect to security, breach notifications, impact assessments and consultations with supervisory authorities or regulators, taking into account the nature of the Supplier&rsquo;s processing and the information available to the Supplier.
                </span>
            </li>
            <li class="c17 c4 li-bullet-49">
                <span class="c1">
                    The Supplier shall notify the Customer without undue delay on becoming aware of a Personal Data Breach;
                </span>
            </li>
            <li class="c17 c4 li-bullet-50">
                <span class="c1">
                    On termination of a Contract for any reason the Supplier will securely delete or destroy or, if directed in writing by the Customer, return and not retain all or any Personal Data related to the Contract in its possession or control (other than any anonymised data) unless required by applicable law to store the Personal Data;.
                </span>
            </li>
            <li class="c19 c4 li-bullet-51">
                <span class="c1">
                    The Supplier will make available on request all information necessary to demonstrate compliance with the obligations set out in this clause.
                </span>
            </li>
            <li class="c4 c19 li-bullet-47">
                <span class="c1">
                    It is agreed and acknowledged that the Services are hosted and accordingly that the Customer Content stored through same will be hosted within the UK,EEA or USA (as applicable to the Accepted Subscription). The Supplier shall not transfer the Customer Content outside of the UK, EEA or USA (as applicable) unless the transfer complies with the Data Protection Legislation, or as necessary to provide the Services initiated by Customer, or as necessary to comply with the law or binding order of a governmental body or the Supplier has obtained the Customer&rsquo;s prior written consent (not to be unreasonably withheld or delayed).
                </span>
            </li>
            <li class="c19 c4 li-bullet-52">
                <span class="c1">
                    Where requested by the Supplier, the Customer shall enter into standard contractual clauses, international data transfer agreements (IDTA) or similar terms forming part of an applicable certification scheme, and where this happens if there is a conflict between any other agreement between the parties including without limitation these Terms, the terms of the standard contractual clauses/IDTA or similar terms forming part of an applicable certification scheme shall take precedence.
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-0" start="10">
            <li class="c18 c4 c32 li-bullet-0">
                <span class="c16">
                    Virus and Firewall
                </span>
                <span class="c1">
                    &nbsp;
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1 start" start="1">
            <li class="c10 c4 li-bullet-0">
                <span class="c1">
                    The Customer is responsible, in accordance with good industry standard, for virus checking the Customer Content and Customer Materials it uploads and any programs, macros, data files or other material accessed through the software.
                </span>
            </li>
            <li class="c10 c4 li-bullet-0">
                <span class="c1">
                    The Supplier does not warrant that the Software is free of viruses or other harmful components nor that the function contained in the materials will be uninterrupted or error free or that defects will be corrected. If the Supplier becomes aware of a virus or harmful component in the Software it will use reasonable endeavours to correct this in a timely manner.
                </span>
            </li>
            <li class="c10 c4 li-bullet-5">
                <span class="c1">
                    The Customer is responsible for ensuring it has adequate firewall protection or such other network security system used to restrict external or internal traffic as appropriate and the parties agree that the Supplier shall have no liability for any loss, damage, costs or expenses incurred by the Customer due to a virus or other network security failure howsoever caused.
                </span>
            </li>
            <li class="c4 c10 li-bullet-0">
                <span>
                    The Customer will indemnify the Supplier for any costs, losses damages or expenses the Supplier incurs as a result of a virus introduced by the Customer or the Users due to any failure to comply with clauses 11.1 and 11.3.
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-0" start="11">
            <li class="c6 c4 li-bullet-0">
                <span class="c9">
                    Limitation of Liability
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1 start" start="1">
            <li class="c12 c4 li-bullet-35">
                <span>
                    Although the Services may allow you to access or use a third party payment processor (as set out above) or other third party products, applications, websites, implementations or services (
                </span>
                <span class="c16">
                    Third Party Offerings
                </span>
                <span>
                    ), they are not &ldquo;Services&rdquo; under this Agreement and are not subject to any of the warranties, service commitments or other obligations with respect to Services hereunder. The availability of any Third Party Offerings through the Services does not imply our endorsement of or affiliation with the provider. We do not control Third Party Offerings and will have no liability to you or any User in connection with any Third Party Offerings. We have no obligation to monitor or maintain Third Party Offerings, and may disable or restrict access to any Third Party Offerings at any time. By using or enabling any Third Party Offering, you are expressly permitting us to disclose your data or other information to the extent necessary to utilise the Third Party Offering.
                </span>
                <span>
                    YOUR USE OF THIRD PARTY OFFERINGS IS AT YOUR OWN RISK AND IS SUBJECT TO ANY ADDITIONAL TERMS, CONDITIONS AND POLICIES APPLICABLE TO SUCH THIRD PARTY OFFERINGS (SUCH AS TERMS OF SERVICE OR PRIVACY POLICIES OF THE PROVIDERS OF SUCH THIRD PARTY OFFERINGS).
                </span>
                <span class="c1">
                    &nbsp;
                </span>
            </li>
            <li class="c12 c4 li-bullet-36">
                <span class="c1">
                    The Services may contain content provided/posted by other users and also public areas that allow feedback and/or interaction between users. The opinions, advice and statements contained in content provided/posted are those of such users and not those of the Supplier. The Supplier does not endorse any material published by other users and does not give any warranty or guarantee in relation to such content or the accuracy, integrity, or quality of same. The Supplier does not monitor Customer Content.
                </span>
            </li>
            <li class="c12 c4 li-bullet-53">
                <span class="c1">
                    The following provisions set out the entire financial liability of the Supplier to the Customer in respect of:
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-2 start" start="1">
            <li class="c23 c4 c31 li-bullet-54">
                <span class="c1">
                    any breach of Contract; and
                </span>
            </li>
            <li class="c23 c31 c4 li-bullet-55">
                <span class="c1">
                    any representation, statement or tortious act or omission including negligence arising under or in connection with any Contract.
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1" start="4">
            <li class="c12 c4 li-bullet-56">
                <span class="c1">
                    All warranties, conditions and other terms implied by statute or common law or otherwise are, to the fullest extent permitted by law, excluded from any Contract.
                </span>
            </li>
            <li class="c12 c4 li-bullet-57">
                <span class="c1">
                    Nothing in these Terms excludes or limits the liability of the Supplier for death or personal injury caused by the Supplier&rsquo;s negligence or affects the Customer&rsquo;s statutory rights as a consumer (if the Customer is contracting as a consumer).
                </span>
            </li>
            <li class="c12 c4 li-bullet-34">
                <span class="c1">
                    Any descriptions or illustrations on the Website are published for the sole purpose of giving an approximate idea of the Services. They will not form part of the Contract or have any contractual force.
                </span>
            </li>
            <li class="c12 c4 li-bullet-35">
                <span class="c1">
                    Subject to clause 12.5, the Supplier&rsquo;s total liability in contract, tort (including negligence or breach of statutory duty), misrepresentation or otherwise, arising in connection with the performance or contemplated performance of a Contract shall be limited to the yearly Subscription Fee under that Contract and subject to that overall limit to the part of any loss suffered which is proportionate to its responsibility; and
                </span>
            </li>
            <li class="c12 c4 li-bullet-36">
                <span class="c1">
                    Notwithstanding any other provision of any Contract, the Supplier shall not be liable to the Customer for:-
                </span>
            </li>
        </ol>
        <p class="c0">
            <span class="c1">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(a) loss of profit;
            </span>
        </p>
        <p class="c0">
            <span class="c1">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(b) loss of business;
            </span>
        </p>
        <p class="c0">
            <span class="c1">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(c) depletion of goodwill and/or similar losses;
            </span>
        </p>
        <p class="c0">
            <span class="c1">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(d) loss of anticipated savings;
            </span>
        </p>
        <p class="c0">
            <span class="c1">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(e) loss of goods;
            </span>
        </p>
        <p class="c0">
            <span class="c1">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(f) loss of contract;
            </span>
        </p>
        <p class="c0">
            <span class="c1">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(g) loss of use;
            </span>
        </p>
        <p class="c0">
            <span class="c1">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(h) (subject always to clause 10.4) loss or corruption of data or information; or
            </span>
        </p>
        <p class="c23 c4 c34">
            <span class="c1">
                (i) any special, indirect, consequential or pure economic loss, costs, damages, charges or expenses;
            </span>
        </p>
        <ol class="c5 lst-kix_list_22-1" start="9">
            <li class="c13 c4 li-bullet-24">
                <span class="c1">
                    The Customer acknowledges and agrees that the limitations and exclusions contained in this clause 12 are reasonable in light of all the circumstances.
                </span>
            </li>
            <li class="c4 c13 li-bullet-58">
                <span class="c1">
                    The Supplier shall not be liable to the Customer or be deemed to be in breach of contract by reason of failure to comply with the Supplier&rsquo;s relevant system requirements provided from time to time. The Customer acknowledges that the Services, Platform and Software shall only be available online.
                </span>
            </li>
            <li class="c13 c4 li-bullet-24">
                <span class="c1">
                    The Supplier does not warrant that the Customer&rsquo;s or Users&rsquo; use of the Services will be uninterrupted or error-free; or that the Services will meet the Customer&rsquo;s requirements. The Supplier shall not be responsible for any delays, delivery failures, or any other loss or damage resulting from the transfer of data over communications networks and facilities, including the internet, and the Customer acknowledges that the Services may be subject to limitations, delays and other problems inherent in the use of such communications facilities. The Services are provided on an &lsquo;as is&rsquo; bases and solely for the Customer&rsquo;s use in accordance with these Terms.
                </span>
            </li>
        </ol>
        <p class="c0 c3">
            <span class="c1">
            </span>
        </p>
        <ol class="c5 lst-kix_list_22-0" start="12">
            <li class="c6 c4 li-bullet-0">
                <span class="c9">
                    Customer Indemnity
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1 start" start="1">
            <li class="c12 c4 li-bullet-36">
                <span class="c1">
                    The Customer hereby indemnifies and agrees to hold fully indemnified the Supplier against all claims, costs, proceedings, demands, losses, damages or liabilities arising as a result of any breach or non-performance by the Customer of any of these Terms or the relevant Contract including without limitation a breach by the Customer of its obligations under applicable Data Protection Legislation, that the Customer Content, Customer Materials or Customer&rsquo;s use of the Software and/or Services infringes the rights of or has otherwise harmed a third party.
                </span>
            </li>
        </ol>
        <p class="c0 c3">
            <span class="c9">
            </span>
        </p>
        <ol class="c5 lst-kix_list_22-0" start="13">
            <li class="c6 c4 li-bullet-30">
                <span class="c9">
                    Force Majeure
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1 start" start="1">
            <li class="c12 c4 li-bullet-57">
                <span>
                    The Supplier reserves the right to delay or suspend provision of the Services (without liability to the Customer) if it is prevented from or delayed in the carrying on of its business or performance of its obligations under a Contract due to circumstances beyond its reasonable control including, without limitation, acts of God, governmental actions, imposition of sanctions, embargo or breaking off of diplomatic relations, nuclear, chemical or biological contamination or sonic boom, collapse of buildings, terrorist attack, civil war, war or national emergency, threat or preparation for war, armed conflict, riot, civil commotion, fire, explosion, accident, flood or other weather event, drought, earthquake or other natural disaster, epidemic, pandemic, disease, infestation, restrictions on transport or movement, lock-outs, strikes or other labour disputes (whether or not relating to either party&rsquo;s workforce), or restraints or delays affecting carriers non-performance by suppliers or subcontractors and interruption or failure of utility service Provided that, if the event in question continues for a continuous period in excess of 90 days either party shall be entitled to give notice in writing to the other party to terminate the Contract.
                </span>
            </li>
        </ol>
        <p class="c0 c3">
            <span class="c1">
            </span>
        </p>
        <ol class="c5 lst-kix_list_22-0" start="14">
            <li class="c6 c4 li-bullet-0">
                <span class="c9">
                    Notices
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1 start" start="1">
            <li class="c4 c12 li-bullet-53">
                <span class="c1">
                    A notice relating to a Contract will be validly given only if it is in writing and delivered personally or by courier, or sent by first class post (or air mail if overseas), recorded delivery, or electronic mail, to the party in question (marked for the attention of the person specified in the relevant Order, or such other officer of that party as is notified to the other party in writing for this purpose) at the address or email address set out in the Contract or such other address or email address as the party in question may specify by notice.
                </span>
            </li>
            <li class="c12 c4 li-bullet-36">
                <span class="c1">
                    In the absence of evidence of earlier receipt, a notice is deemed given:
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-2 start" start="1">
            <li class="c20 c4 li-bullet-59">
                <span class="c1">
                    if delivered personally or by courier, when left at the relevant address;
                </span>
            </li>
            <li class="c20 c4 li-bullet-60">
                <span class="c1">
                    if sent by post, two days (excluding Saturdays, Sundays and bank and public &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;holidays) after posting it (exclusive of the day of posting) or if sent by air mail, six &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;days after posting it (exclusive of the day of posting); and
                </span>
            </li>
            <li class="c20 c4 li-bullet-61">
                <span class="c1">
                    if sent by electronic mail, on a Working Day prior to 4.00pm, at the time of &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;transmission or sending and otherwise on the next Working Day.
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1" start="3">
            <li class="c12 c4 li-bullet-62">
                <span class="c1">
                    Each party shall immediately give notice to the other of a change in its address or email address.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
            </li>
        </ol>
        <p class="c0 c3">
            <span class="c9">
            </span>
        </p>
        <ol class="c5 lst-kix_list_22-0" start="15">
            <li class="c6 c4 li-bullet-5">
                <span class="c9">
                    Confidentiality
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1 start" start="1">
            <li class="c23 c4 c28 li-bullet-63">
                <span class="c1">
                    Each party undertakes that it shall not at any time during the Term, and for a period of five &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;years thereafter, disclose to any person any Confidential Information except as permitted by &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;the Contract.
                </span>
            </li>
            <li class="c23 c28 c4 li-bullet-64">
                <span class="c1">
                    Each party may disclose the other party&#39;s confidential information:
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-2 start" start="1">
            <li class="c20 c4 li-bullet-65">
                <span class="c1">
                    to its employees, officers, representatives, subcontractors or advisers who need to &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;know such information for the purposes of carrying out the party&#39;s obligations under &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;the relevant Contract. Each party shall ensure that its employees, officers, &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;representatives, subcontractors or advisers to whom it discloses the other party&#39;s &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;confidential information comply with this clause 16; and
                </span>
            </li>
            <li class="c4 c20 li-bullet-66">
                <span class="c1">
                    as may be required by law, a court of competent jurisdiction or any governmental or &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;regulatory authority.
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1" start="3">
            <li class="c12 c4 li-bullet-67">
                <span class="c1">
                    Neither party shall use the other party&#39;s confidential information for any purpose other than to perform its obligations under a Contract.
                </span>
            </li>
            <li class="c12 c4 li-bullet-31">
                <span class="c1">
                    The Supplier may wish to seek publicity for work undertaken on the Customer&rsquo;s behalf. It may use references to the Customer and the Services dealt with in proposals or other similar submissions made to other prospective clients
                </span>
            </li>
        </ol>
        <p class="c0 c3">
            <span class="c1">
            </span>
        </p>
        <p class="c23 c4 c3 c26">
            <span class="c9">
            </span>
        </p>
        <ol class="c5 lst-kix_list_22-0" start="16">
            <li class="c6 c4 li-bullet-8">
                <span class="c9">
                    Miscellaneous
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1 start" start="1">
            <li class="c12 c4 li-bullet-35">
                <span class="c1">
                    The Customer shall not be entitled to assign a Contract or any part of it without the prior written consent of the Supplier, such consent not to be unreasonably withheld or delayed.
                </span>
            </li>
            <li class="c12 c4 li-bullet-68">
                <span class="c1">
                    The Supplier may assign or subcontract a Contract or any part of it to any person, firm or company.
                </span>
            </li>
            <li class="c12 c4 li-bullet-31">
                <span class="c1">
                    A person who is not a party to a Contract has no right under the Contracts (Rights of Third Parties) Act 1999 to rely upon or enforce any term of the Contract, but nothing in the Contract shall affect any right or remedy of a third party which exists or is available otherwise than as a result of that Act.
                </span>
            </li>
            <li class="c12 c4 li-bullet-34">
                <span class="c1">
                    If any provision of a Contract is held by any court or other competent authority to be invalid or unenforceable in whole or in part, the Contract shall continue to be valid as to its other provisions and the remainder of the affected provision.
                </span>
            </li>
            <li class="c12 c4 li-bullet-31">
                <span class="c1">
                    Each party shall from time to time do all such acts and execute all such documents as may be reasonably necessary in order to give effect to the provisions of a Contract.
                </span>
            </li>
            <li class="c12 c4 li-bullet-69">
                <span class="c1">
                    Customer agrees that, in addition to any licence compliance checking performed by the Software, Supplier or its authorised representatives have the right, no more than once every twelve (12) months, upon seven (7) business days prior notice to Customer, to inspect Customer&rsquo;s records, systems, and facilities to verify that its use of any and all Services is in conformity with these Terms. Additionally, the Customer shall provide Supplier with all records and information requested by Supplier in order to verify that its use of any and all Services is in conformity with these Terms within thirty (30) days of Supplier&lsquo;s request.
                </span>
            </li>
        </ol>
        <p class="c0 c3">
            <span class="c9">
            </span>
        </p>
        <ol class="c5 lst-kix_list_22-0" start="17">
            <li class="c6 c4 li-bullet-0">
                <span class="c9">
                    Freedom of Information
                </span>
            </li>
        </ol>
        <ol class="c5 lst-kix_list_22-1 start" start="1">
            <li class="c12 c4 li-bullet-31">
                <span class="c1">
                    Where the Customer is subject to the requirements of the Freedom of Information Act 2000 (FOIA) and the Environmental Information Regulations 2004 (EIR) and notifies the Supplier accordingly, the Supplier undertakes to use reasonable endeavours to assist and cooperate with the Customer to enable the Customer to comply with its obligations under the FOIA and EIR within the relevant timescales.
                </span>
            </li>
            <li class="c12 c4 li-bullet-57">
                <span class="c1">
                    Where the Customer is obliged under FOIA or EIR to disclose information concerning the Supplier or the Services it shall only do so following consultation with the Supplier and having taken its views into account, unless consultation is not reasonable or appropriate based on the circumstances known to the Customer at the relevant time. Where the Supplier has not been consulted the Customer shall give the Supplier reasonable advance written notice before any such disclosure is made.
                </span>
            </li>
        </ol>
        <p class="c0 c3">
            <span class="c1">
            </span>
        </p>
        <ol class="c5 lst-kix_list_22-0" start="18">
            <li class="c6 c4 li-bullet-30">
                <span class="c9">
                    Governing Law and Jurisdiction
                </span>
            </li>
        </ol>
        <p class="c18 c4">
            <span class="c1">
                The formation, existence, construction, performance, validity and all aspects of any Contract shall be governed by Northern Irish law and the parties submit to the non-exclusive jurisdiction of the Northern Irish Courts.
            </span>
        </p>
        <hr style="page-break-before:always;display:none;">
        <p class="c3 c30">
            <span class="c1">
            </span>
        </p>
        <p class="c18 c4 c3">
            <span class="c1">
            </span>
        </p>
        <hr style="page-break-before:always;display:none;">
        <p class="c30 c3">
            <span class="c1">
            </span>
        </p>
        <p class="c4 c3 c18">
            <span class="c1">
            </span>
        </p>
    </body>
</html>`;

export const privacyPolicyHtml = String.raw`<html>
    <head>
        <meta content="text/html; charset=UTF-8" http-equiv="content-type">
        <style type="text/css">
            ol{
                margin:0;
                padding:0;
            }
            table td,table th{
                padding:0;
            }
            .c1{
                -webkit-text-decoration-skip:none;
                color:#0000ff;
                font-weight:400;
                text-decoration:underline;
                vertical-align:baseline;
                text-decoration-skip-ink:none;
                font-size:10pt;
                font-family:"Verdana";
                font-style:normal;
            }
            .c41{
                -webkit-text-decoration-skip:none;
                color:#000080;
                font-weight:400;
                text-decoration:underline;
                vertical-align:baseline;
                text-decoration-skip-ink:none;
                font-size:10pt;
                font-family:"Verdana";
                font-style:normal;
            }
            .c24{
                margin-left:30.1pt;
                padding-top:10.2pt;
                text-indent:-29.5pt;
                padding-bottom:0pt;
                line-height:1.0186684131622314;
                text-align:justify;
                margin-right:8.6pt;
            }
            .c33{
                margin-left:30.5pt;
                padding-top:0.4pt;
                text-indent:-0.4pt;
                padding-bottom:0pt;
                line-height:1.0362309217453003;
                text-align:left;
                margin-right:7.1pt;
            }
            .c21{
                margin-left:30.1pt;
                padding-top:10.5pt;
                text-indent:-30.1pt;
                padding-bottom:0pt;
                line-height:1.0211738348007202;
                text-align:left;
                margin-right:25.9pt;
            }
            .c94{
                margin-left:30.5pt;
                padding-top:10.1pt;
                text-indent:-30.1pt;
                padding-bottom:0pt;
                line-height:1.0236836671829224;
                text-align:left;
                margin-right:11.6pt;
            }
            .c8{
                color:#0000ff;
                font-weight:400;
                text-decoration:none;
                vertical-align:baseline;
                font-size:10pt;
                font-family:"Verdana";
                font-style:normal;
            }
            .c17{
                margin-left:30.1pt;
                padding-top:10pt;
                text-indent:-29.1pt;
                padding-bottom:0pt;
                line-height:1.0169951915740967;
                text-align:left;
                margin-right:5.1pt;
            }
            .c31{
                margin-left:30pt;
                padding-top:10.1pt;
                text-indent:-29.8pt;
                padding-bottom:0pt;
                line-height:1.0190881490707397;
                text-align:left;
                margin-right:-0.3pt;
            }
            .c9{
                margin-left:30.5pt;
                padding-top:10.3pt;
                text-indent:-29.5pt;
                padding-bottom:0pt;
                line-height:1.0236836671829224;
                text-align:left;
                margin-right:3.5pt;
            }
            .c72{
                margin-left:60.1pt;
                padding-top:10.2pt;
                text-indent:-29.6pt;
                padding-bottom:0pt;
                line-height:1.0236836671829224;
                text-align:justify;
                margin-right:5.9pt;
            }
            .c52{
                margin-left:0.9pt;
                padding-top:10.4pt;
                text-indent:0.1pt;
                padding-bottom:0pt;
                line-height:1.8466509580612183;
                text-align:left;
                margin-right:73.3pt;
            }
            .c90{
                margin-left:30.1pt;
                padding-top:10.3pt;
                text-indent:-29.7pt;
                padding-bottom:0pt;
                line-height:1.017413854598999;
                text-align:left;
                margin-right:1.2pt;
            }
            .c76{
                margin-left:30.1pt;
                padding-top:10.2pt;
                text-indent:-29.1pt;
                padding-bottom:0pt;
                line-height:1.0236893892288208;
                text-align:left;
                margin-right:20.9pt;
            }
            .c13{
                margin-left:29.9pt;
                padding-top:10.3pt;
                text-indent:-29.5pt;
                padding-bottom:0pt;
                line-height:1.020340085029602;
                text-align:left;
                margin-right:1.5pt;
            }
            .c95{
                margin-left:60.5pt;
                padding-top:10.3pt;
                text-indent:-30pt;
                padding-bottom:0pt;
                line-height:1.0236836671829224;
                text-align:left;
                margin-right:22.9pt;
            }
            .c69{
                margin-left:30.1pt;
                padding-top:10.3pt;
                text-indent:-29.7pt;
                padding-bottom:0pt;
                line-height:1.0176645517349243;
                text-align:left;
                margin-right:2.5pt;
            }
            .c63{
                margin-left:30pt;
                padding-top:10.2pt;
                text-indent:-29.1pt;
                padding-bottom:0pt;
                line-height:1.0236867666244507;
                text-align:left;
                margin-right:39.3pt;
            }
            .c56{
                margin-left:29.9pt;
                padding-top:10.2pt;
                text-indent:-28.9pt;
                padding-bottom:0pt;
                line-height:1.0236836671829224;
                text-align:left;
                margin-right:13.5pt;
            }
            .c83{
                margin-left:29.9pt;
                padding-top:10.1pt;
                text-indent:-29.4pt;
                padding-bottom:0pt;
                line-height:1.0179153680801392;
                text-align:left;
                margin-right:0.2pt;
            }
            .c89{
                margin-left:30.1pt;
                padding-top:10.2pt;
                text-indent:-29.8pt;
                padding-bottom:0pt;
                line-height:1.0169970989227295;
                text-align:left;
                margin-right:11.5pt;
            }
            .c71{
                margin-left:60pt;
                padding-top:10.2pt;
                text-indent:-29.5pt;
                padding-bottom:0pt;
                line-height:1.023688793182373;
                text-align:left;
                margin-right:23.5pt;
            }
            .c46{
                margin-left:30pt;
                padding-top:10.3pt;
                text-indent:-29.6pt;
                padding-bottom:0pt;
                line-height:1.0186671018600464;
                text-align:left;
                margin-right:7.6pt;
            }
            .c11{
                color:#000000;
                font-weight:700;
                text-decoration:none;
                vertical-align:baseline;
                font-size:14pt;
                font-family:"Verdana";
                font-style:normal;
            }
            .c29{
                margin-left:29.9pt;
                padding-top:10.3pt;
                text-indent:-29.6pt;
                padding-bottom:0pt;
                line-height:1.0236836671829224;
                text-align:justify;
                margin-right:7.9pt;
            }
            .c32{
                margin-left:29.6pt;
                padding-top:0pt;
                text-indent:-28.6pt;
                padding-bottom:0pt;
                line-height:1.0208947658538818;
                text-align:left;
                margin-right:6.3pt;
            }
            .c73{
                margin-left:60.5pt;
                padding-top:10.2pt;
                text-indent:-30pt;
                padding-bottom:0pt;
                line-height:1.0186703205108643;
                text-align:left;
                margin-right:9.5pt;
            }
            .c51{
                margin-left:29.9pt;
                padding-top:10.5pt;
                text-indent:-29.4pt;
                padding-bottom:0pt;
                line-height:1.0236880779266357;
                text-align:left;
                margin-right:3.9pt;
            }
            .c23{
                margin-left:59.9pt;
                padding-top:10.1pt;
                text-indent:-29.5pt;
                padding-bottom:0pt;
                line-height:1.0236880779266357;
                text-align:left;
                margin-right:15pt;
            }
            .c88{
                margin-left:30.2pt;
                padding-top:10.3pt;
                text-indent:-29.9pt;
                padding-bottom:0pt;
                line-height:1.0186703205108643;
                text-align:left;
                margin-right:1.3pt;
            }
            .c44{
                margin-left:30.1pt;
                padding-top:10.2pt;
                text-indent:-29.7pt;
                padding-bottom:0pt;
                line-height:1.0176632404327393;
                text-align:left;
                margin-right:1pt;
            }
            .c58{
                margin-left:30.2pt;
                padding-top:0.3pt;
                text-indent:0.3pt;
                padding-bottom:0pt;
                line-height:1.0337224006652832;
                text-align:left;
                margin-right:34.1pt;
            }
            .c82{
                margin-left:29.9pt;
                padding-top:10.2pt;
                text-indent:-29.5pt;
                padding-bottom:0pt;
                line-height:1.0189484357833862;
                text-align:left;
                margin-right:7.6pt;
            }
            .c84{
                margin-left:30.1pt;
                padding-top:10.3pt;
                text-indent:-29.7pt;
                padding-bottom:0pt;
                line-height:1.0176663398742676;
                text-align:left;
                margin-right:0.3pt;
            }
            .c12{
                margin-left:30.1pt;
                padding-top:10.3pt;
                text-indent:-29.1pt;
                padding-bottom:0pt;
                line-height:1.0337222814559937;
                text-align:left;
                margin-right:13.8pt;
            }
            .c27{
                margin-left:29.6pt;
                padding-top:10.3pt;
                text-indent:-29.2pt;
                padding-bottom:0pt;
                line-height:1.0176658630371094;
                text-align:left;
                margin-right:5.7pt;
            }
            .c62{
                margin-left:30pt;
                padding-top:10.2pt;
                text-indent:-29.1pt;
                padding-bottom:0pt;
                line-height:1.0236836671829224;
                text-align:left;
                margin-right:17.8pt;
            }
            .c26{
                margin-left:60.1pt;
                padding-top:10.3pt;
                text-indent:-29.6pt;
                padding-bottom:0pt;
                line-height:1.0236867666244507;
                text-align:left;
                margin-right:47.4pt;
            }
            .c74{
                margin-left:30.1pt;
                padding-top:10.3pt;
                text-indent:-29.7pt;
                padding-bottom:0pt;
                line-height:1.0186688899993896;
                text-align:left;
                margin-right:0.5pt;
            }
            .c70{
                margin-left:30.5pt;
                padding-top:10.5pt;
                text-indent:-30.2pt;
                padding-bottom:0pt;
                line-height:1.0203423500061035;
                text-align:left;
                margin-right:0.9pt;
            }
            .c25{
                margin-left:30.5pt;
                padding-top:10.5pt;
                text-indent:-30.1pt;
                padding-bottom:0pt;
                line-height:1.0236836671829224;
                text-align:left;
                margin-right:21.7pt;
            }
            .c2{
                color:#000000;
                font-weight:700;
                text-decoration:none;
                vertical-align:baseline;
                font-size:10pt;
                font-family:"Verdana";
                font-style:normal;
            }
            .c93{
                margin-left:29.9pt;
                padding-top:10.1pt;
                text-indent:-29.9pt;
                padding-bottom:0pt;
                line-height:1.0189484357833862;
                text-align:left;
                margin-right:0.5pt;
            }
            .c79{
                margin-left:60.1pt;
                padding-top:0pt;
                text-indent:-29.6pt;
                padding-bottom:0pt;
                line-height:1.0337194204330444;
                text-align:left;
                margin-right:8.1pt;
            }
            .c42{
                margin-left:29.9pt;
                padding-top:10.3pt;
                text-indent:-29.5pt;
                padding-bottom:0pt;
                line-height:1.0181920528411865;
                text-align:left;
                margin-right:1.6pt;
            }
            .c53{
                margin-left:59.9pt;
                padding-top:10.3pt;
                text-indent:-29.5pt;
                padding-bottom:0pt;
                line-height:1.0337194204330444;
                text-align:left;
                margin-right:21.9pt;
            }
            .c0{
                color:#000000;
                font-weight:400;
                text-decoration:none;
                vertical-align:baseline;
                font-size:10pt;
                font-family:"Verdana";
                font-style:normal;
            }
            .c43{
                margin-left:59.9pt;
                padding-top:10.5pt;
                text-indent:-29.5pt;
                padding-bottom:0pt;
                line-height:1.0236836671829224;
                text-align:left;
                margin-right:7.4pt;
            }
            .c3{
                margin-left:30.5pt;
                padding-top:10.5pt;
                text-indent:-30.1pt;
                padding-bottom:0pt;
                line-height:1.0236865282058716;
                text-align:left;
                margin-right:49.2pt;
            }
            .c68{
                margin-left:30pt;
                padding-top:10.5pt;
                text-indent:-29.9pt;
                padding-bottom:0pt;
                line-height:1.0186690092086792;
                text-align:left;
                margin-right:24.8pt;
            }
            .c14{
                margin-left:30.1pt;
                padding-top:10.5pt;
                text-indent:-29.2pt;
                padding-bottom:0pt;
                line-height:1.0236867666244507;
                text-align:left;
                margin-right:9.3pt;
            }
            .c7{
                margin-left:30.1pt;
                padding-top:10.3pt;
                text-indent:-29.7pt;
                padding-bottom:0pt;
                line-height:1.0203404426574707;
                text-align:left;
                margin-right:4.4pt;
            }
            .c6{
                margin-left:30.5pt;
                padding-top:10.1pt;
                text-indent:-29.5pt;
                padding-bottom:0pt;
                line-height:1.0337194204330444;
                text-align:left;
                margin-right:42.5pt;
            }
            .c92{
                margin-left:60.5pt;
                padding-top:10pt;
                text-indent:-30pt;
                padding-bottom:0pt;
                line-height:1.0337244272232056;
                text-align:left;
                margin-right:28.8pt;
            }
            .c28{
                margin-left:29.9pt;
                padding-top:10.3pt;
                text-indent:-29.5pt;
                padding-bottom:0pt;
                line-height:1.017598032951355;
                text-align:left;
                margin-right:12.1pt;
            }
            .c49{
                margin-left:60.5pt;
                padding-top:10.3pt;
                text-indent:-30pt;
                padding-bottom:0pt;
                line-height:1.0333887338638306;
                text-align:left;
                margin-right:33.4pt;
            }
            .c37{
                margin-left:0.4pt;
                padding-top:10.2pt;
                padding-bottom:0pt;
                line-height:1.0192952156066895;
                text-align:center;
                margin-right:11.1pt;
            }
            .c87{
                margin-left:1pt;
                padding-top:10.1pt;
                padding-bottom:0pt;
                line-height:1.0236836671829224;
                text-align:center;
                margin-right:20.1pt;
            }
            .c15{
                margin-left:29.9pt;
                padding-top:0pt;
                padding-bottom:0pt;
                line-height:1.024520754814148;
                text-align:left;
                margin-right:12.3pt;
            }
            .c48{
                margin-left:30.5pt;
                padding-top:0pt;
                padding-bottom:0pt;
                line-height:1.0337194204330444;
                text-align:left;
                margin-right:40.9pt;
            }
            .c75{
                margin-left:0.4pt;
                padding-top:10.5pt;
                padding-bottom:0pt;
                line-height:1.0186657905578613;
                text-align:center;
                margin-right:3.5pt;
            }
            .c77{
                margin-left:30.5pt;
                padding-top:10.1pt;
                padding-bottom:0pt;
                line-height:1.0236880779266357;
                text-align:center;
                margin-right:36pt;
            }
            .c85{
                margin-left:0.3pt;
                padding-top:10.2pt;
                padding-bottom:0pt;
                line-height:1.023688793182373;
                text-align:center;
                margin-right:10.1pt;
            }
            .c86{
                margin-left:30.5pt;
                padding-top:10.5pt;
                padding-bottom:0pt;
                line-height:1.023685336112976;
                text-align:center;
                margin-right:39.3pt;
            }
            .c64{
                margin-left:0.5pt;
                padding-top:10.3pt;
                padding-bottom:0pt;
                line-height:1.0134837627410889;
                text-align:right;
                margin-right:4pt;
            }
            .c19{
                margin-left:1pt;
                padding-top:10.5pt;
                padding-bottom:0pt;
                line-height:1.0236867666244507;
                text-align:center;
                margin-right:11.4pt;
            }
            .c65{
                margin-left:30.5pt;
                padding-top:10.5pt;
                padding-bottom:0pt;
                line-height:1.0236836671829224;
                text-align:center;
                margin-right:24.2pt;
            }
            .c30{
                margin-left:0.4pt;
                padding-top:10pt;
                padding-bottom:0pt;
                line-height:1.0186657905578613;
                text-align:center;
                margin-right:2.7pt;
            }
            .c81{
                margin-left:30.5pt;
                padding-top:0.3pt;
                padding-bottom:0pt;
                line-height:1.013653039932251;
                text-align:left;
                margin-right:23pt;
            }
            .c80{
                margin-left:30.5pt;
                padding-top:10pt;
                padding-bottom:0pt;
                line-height:1.023688793182373;
                text-align:center;
                margin-right:46.1pt;
            }
            .c59{
                margin-left:0.4pt;
                padding-top:10pt;
                padding-bottom:0pt;
                line-height:1.0337194204330444;
                text-align:center;
                margin-right:31.5pt;
            }
            .c47{
                margin-left:0.4pt;
                padding-top:10.1pt;
                padding-bottom:0pt;
                line-height:1.01850163936615;
                text-align:center;
                margin-right:19.5pt;
            }
            .c91{
                margin-left:0pt;
                padding-top:10.3pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c36{
                margin-left:30.5pt;
                padding-top:10.1pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c78{
                margin-left:0.9pt;
                padding-top:10.1pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c4{
                margin-left:30.5pt;
                padding-top:10.4pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c22{
                margin-left:0.1pt;
                padding-top:10.1pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c55{
                margin-left:1pt;
                padding-top:2.1pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c39{
                padding-top:10.5pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:right;
                margin-right:24.3pt;
            }
            .c96{
                padding-top:10.2pt;
                padding-bottom:0pt;
                line-height:1.023688793182373;
                text-align:center;
                margin-right:12pt;
            }
            .c50{
                margin-left:0.5pt;
                padding-top:10.2pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c34{
                margin-left:0.9pt;
                padding-top:10.9pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c18{
                margin-left:0.4pt;
                padding-top:10.4pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c16{
                margin-left:0.9pt;
                padding-top:10.4pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c40{
                margin-left:1pt;
                padding-top:10.3pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c35{
                margin-left:0.3pt;
                padding-top:10.2pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c5{
                margin-left:0.4pt;
                padding-top:10.3pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c38{
                margin-left:30.5pt;
                padding-top:10.5pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c10{
                margin-left:0.3pt;
                padding-top:10.4pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c67{
                margin-left:30.5pt;
                padding-top:10.6pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c61{
                padding-top:10.1pt;
                padding-bottom:0pt;
                line-height:1.0211790800094604;
                text-align:center;
                margin-right:1.7pt;
            }
            .c54{
                margin-left:0.9pt;
                padding-top:10.2pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c60{
                margin-left:0.3pt;
                padding-top:0pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c57{
                padding-top:10.3pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:right;
                margin-right:24.5pt;
            }
            .c45{
                margin-left:0.1pt;
                padding-top:10.4pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:left;
            }
            .c66{
                padding-top:0pt;
                padding-bottom:0pt;
                line-height:1.0;
                text-align:center;
            }
            .c20{
                background-color:#ffffff;
                max-width:595pt;
                padding:0pt 0pt 0pt 0pt;
            }
            .title{
                padding-top:24pt;
                color:#000000;
                font-weight:700;
                font-size:36pt;
                padding-bottom:6pt;
                font-family:"Arial";
                line-height:1.15;
                page-break-after:avoid;
                orphans:2;
                widows:2;
                text-align:left;
            }
            .subtitle{
                padding-top:18pt;
                color:#666666;
                font-size:24pt;
                padding-bottom:4pt;
                font-family:"Georgia";
                line-height:1.15;
                page-break-after:avoid;
                font-style:italic;
                orphans:2;
                widows:2;
                text-align:left;
            }
            li{
                color:#000000;
                font-size:11pt;
                font-family:"Arial";
            }
            p{
                margin:0;
                color:#000000;
                font-size:11pt;
                font-family:"Arial";
            }
            h1{
                padding-top:24pt;
                color:#000000;
                font-weight:700;
                font-size:24pt;
                padding-bottom:6pt;
                font-family:"Arial";
                line-height:1.15;
                page-break-after:avoid;
                orphans:2;
                widows:2;
                text-align:left;
            }
            h2{
                padding-top:18pt;
                color:#000000;
                font-weight:700;
                font-size:18pt;
                padding-bottom:4pt;
                font-family:"Arial";
                line-height:1.15;
                page-break-after:avoid;
                orphans:2;
                widows:2;
                text-align:left;
            }
            h3{
                padding-top:14pt;
                color:#000000;
                font-weight:700;
                font-size:14pt;
                padding-bottom:4pt;
                font-family:"Arial";
                line-height:1.15;
                page-break-after:avoid;
                orphans:2;
                widows:2;
                text-align:left;
            }
            h4{
                padding-top:12pt;
                color:#000000;
                font-weight:700;
                font-size:12pt;
                padding-bottom:2pt;
                font-family:"Arial";
                line-height:1.15;
                page-break-after:avoid;
                orphans:2;
                widows:2;
                text-align:left;
            }
            h5{
                padding-top:11pt;
                color:#000000;
                font-weight:700;
                font-size:11pt;
                padding-bottom:2pt;
                font-family:"Arial";
                line-height:1.15;
                page-break-after:avoid;
                orphans:2;
                widows:2;
                text-align:left;
            }
            h6{
                padding-top:10pt;
                color:#000000;
                font-weight:700;
                font-size:10pt;
                padding-bottom:2pt;
                font-family:"Arial";
                line-height:1.15;
                page-break-after:avoid;
                orphans:2;
                widows:2;
                text-align:left;
            }
        </style>
    </head>
    <body class="c20 doc-content">
        <p class="c66">
            <span class="c11">
                Privacy policy
            </span>
        </p>
        <p class="c34">
            <span class="c2">
                1. Introduction
            </span>
        </p>
        <p class="c9">
            <span class="c0">
                1.1 We are committed to safeguarding the privacy of our website visitors, service &nbsp;users, individual customers and customer personnel.
            </span>
        </p>
        <p class="c56">
            <span class="c0">
                1.2 This policy applies where we are acting as a data controller with respect to &nbsp;the personal data of such persons; in other words, where we determine the &nbsp;purposes and means of the processing of that personal data.
            </span>
        </p>
        <p class="c87">
            <span class="c0">
                1.3 We use cookies on our website. Insofar as those cookies are not strictly &nbsp;necessary for the provision of our website and services, we will ask you to &nbsp;consent to our use of cookies when you first visit our website.
            </span>
        </p>
        <p class="c6">
            <span class="c0">
                1.4 In this policy, &quot;we&quot;, &quot;us&quot; and &quot;our&quot; refer to Animotive Limited. For more &nbsp;information about us, see Section 13.
            </span>
        </p>
        <p class="c50">
            <span class="c2">
                2. The personal data that we collect
            </span>
        </p>
        <p class="c75">
            <span class="c0">
                2.1 In this Section 2 we have set out the general categories of personal data that &nbsp;we process and, in the case of personal data that we did not obtain directly &nbsp;from you, information about the source and specific categories of that data.
            </span>
        </p>
        <p class="c27">
            <span class="c0">
                2.2 We may process data enabling us to get in touch with you (&quot;
            </span>
            <span class="c2">
                contact data
            </span>
            <span class="c0">
                &quot;). &nbsp;The contact data may include your name, email address, telephone number, &nbsp;postal address and/or social media account identifiers. The source of the &nbsp;contact data is you and/or your employer. If you log into our website using a &nbsp;social media account, we will obtain elements of the contact data from the &nbsp;relevant social media account provider.
            </span>
        </p>
        <p class="c42">
            <span class="c0">
                2.3 We may process your website user account data (&quot;
            </span>
            <span class="c2">
                account data
            </span>
            <span class="c0">
                &quot;). The &nbsp;account data may include your account identifier, name, email address, &nbsp;business name, account creation and modification dates, website settings and &nbsp;marketing preferences. The primary source of the account data is you and/or &nbsp;your employer, although some elements of the account data may be &nbsp;generated by our website. If you log into our website using a social media &nbsp;account, we will obtain elements of the account data from the relevant social &nbsp;media account provider.
            </span>
        </p>
        <p class="c74">
            <span class="c0">
                2.4 We may process information relating to transactions, including purchases of &nbsp;goods and/or services, that you enter into with us and/or through our website &nbsp;(&quot;
            </span>
            <span class="c2">
                transaction data
            </span>
            <span class="c0">
                &quot;). The transaction data may include your name, your &nbsp;contact details and the transaction details. The source of the transaction data &nbsp;is you and/or our payment services provider.
            </span>
        </p>
        <p class="c37">
            <span class="c0">
                2.5 We may process information contained in or relating to any communication &nbsp;that you send to us or that we send to you (&quot;
            </span>
            <span class="c2">
                communication data
            </span>
            <span class="c0">
                &quot;). The &nbsp;communication data may include the communication content and metadata &nbsp;associated with the communication. Our website will generate the metadata &nbsp;associated with communications made using the website contact forms.
            </span>
        </p>
        <p class="c28">
            <span class="c0">
                2.6 We may process data about your use of our website and services (&quot;
            </span>
            <span class="c2">
                usage &nbsp;data
            </span>
            <span class="c0">
                &quot;). The usage data may include your IP address, geographical location, &nbsp;browser type and version, operating system, referral source, length of visit, &nbsp;page views and website navigation paths, as well as information about the &nbsp;timing, frequency and pattern of your service use. The source of the usage &nbsp;data is our analytics tracking system.
            </span>
        </p>
        <p class="c60">
            <span class="c2">
                3. Purposes of processing and legal bases
            </span>
        </p>
        <p class="c25">
            <span class="c0">
                3.1 In this Section 3, we have set out the purposes for which we may process &nbsp;personal data and the legal bases of the processing.
            </span>
        </p>
        <p class="c44">
            <span class="c0">
                3.2
            </span>
            <span class="c2">
                Operations
            </span>
            <span class="c0">
                - We may process your personal data for the purposes of &nbsp;operating our website, the processing and fulfilment of orders, providing our &nbsp;services, generating invoices, bills and other payment-related documentation, &nbsp;and credit control. The legal basis for this processing is our legitimate &nbsp;interests, namely the proper administration of our website, services and &nbsp;business.
            </span>
        </p>
        <p class="c46">
            <span class="c0">
                3.3
            </span>
            <span class="c2">
                Publications
            </span>
            <span class="c0">
                - We may process account data for the purposes of publishing &nbsp;such data on our website and elsewhere through our services in accordance &nbsp;with your express instructions. The legal basis for this processing is our &nbsp;legitimate interests, namely the publication of content in the ordinary course &nbsp;of our operations.
            </span>
        </p>
        <p class="c90">
            <span class="c0">
                3.4
            </span>
            <span class="c2">
                Relationships and communications
            </span>
            <span class="c0">
                - We may process contact data, &nbsp;account data, transaction data and/or communication data for the purposes &nbsp;of managing our relationships, communicating with you (excluding &nbsp;communicating for the purposes of direct marketing) by email, SMS, post, fax &nbsp;and/or telephone, providing support services and complaint handling. The &nbsp;legal basis for this processing is our legitimate interests, namely &nbsp;communications with our website visitors, service users, individual customers &nbsp;and customer personnel, the maintenance of relationships, and the proper &nbsp;administration of our website, services and business.
            </span>
        </p>
        <p class="c82">
            <span class="c0">
                3.5
            </span>
            <span class="c2">
                Direct marketing
            </span>
            <span class="c0">
                - We may process contact data, account data and/or &nbsp;transaction data for the purposes of creating, targeting and sending direct &nbsp;marketing communications by email, SMS, post and/or fax and making &nbsp;contact by telephone for marketing-related purposes. The legal basis for this &nbsp;processing is our legitimate interests, namely promoting our business and &nbsp;communicating marketing messages and offers to our website visitors and &nbsp;service users.
            </span>
        </p>
        <p class="c84">
            <span class="c0">
                3.6
            </span>
            <span class="c2">
                Research and analysis
            </span>
            <span class="c0">
                - We may process usage data and/or transaction &nbsp;data for the purposes of researching and analysing the use of our website and &nbsp;services, as well as researching and analysing other interactions with our &nbsp;business. The legal basis for this processing is our legitimate interests, &nbsp;namely monitoring, supporting, improving and securing our website, services &nbsp;and business generally.
            </span>
        </p>
        <p class="c69">
            <span class="c0">
                3.7
            </span>
            <span class="c2">
                Record keeping
            </span>
            <span class="c0">
                - We may process your personal data for the purposes of &nbsp;creating and maintaining our databases, back-up copies of our databases and &nbsp;our business records generally. The legal basis for this processing is our &nbsp;legitimate interests, namely ensuring that we have access to all the &nbsp;information we need to properly and efficiently run our business in &nbsp;accordance with this policy.
            </span>
        </p>
        <p class="c7">
            <span class="c0">
                3.8
            </span>
            <span class="c2">
                Security
            </span>
            <span class="c0">
                - We may process your personal data for the purposes of security &nbsp;and the prevention of fraud and other criminal activity. The legal basis of this &nbsp;processing is our legitimate interests, namely the protection of our website, &nbsp;services and business, and the protection of others.
            </span>
        </p>
        <p class="c47">
            <span class="c0">
                3.9
            </span>
            <span class="c2">
                Insurance and risk management
            </span>
            <span class="c0">
                - We may process your personal data &nbsp;where necessary for the purposes of obtaining or maintaining insurance &nbsp;coverage, managing risks and/or obtaining professional advice. The legal
            </span>
        </p>
        <p class="c48">
            <span class="c0">
                basis for this processing is our legitimate interests, namely the proper &nbsp;protection of our business against risks.
            </span>
        </p>
        <p class="c30">
            <span class="c0">
                3.10
            </span>
            <span class="c2">
                Legal claims
            </span>
            <span class="c0">
                - We may process your personal data where necessary for the &nbsp;establishment, exercise or defence of legal claims, whether in court &nbsp;proceedings or in an administrative or out-of-court procedure. The legal basis &nbsp;for this processing is our legitimate interests, namely the protection and &nbsp;assertion of our legal rights, your legal rights and the legal rights of others.
            </span>
        </p>
        <p class="c13">
            <span class="c0">
                3.11
            </span>
            <span class="c2">
                Legal compliance and vital interests
            </span>
            <span class="c0">
                - We may also process your personal &nbsp;data where such processing is necessary for compliance with a legal &nbsp;obligation to which we are subject or in order to protect your vital interests or &nbsp;the vital interests of another natural person.
            </span>
        </p>
        <p class="c91">
            <span class="c2">
                4. Providing your personal data to others
            </span>
        </p>
        <p class="c21">
            <span class="c0">
                4.1 We may disclose your personal data to our insurers and/or professional &nbsp;advisers insofar as reasonably necessary for the purposes of obtaining or &nbsp;maintaining insurance coverage, managing risks, obtaining professional &nbsp;advice.
            </span>
        </p>
        <p class="c96">
            <span class="c0">
                4.2 Your personal data held in our website or service database will be stored on &nbsp;the servers of our hosting services providers in the UK, EEA or USA.
            </span>
        </p>
        <p class="c61">
            <span class="c0">
                4.3 Financial transactions relating to our website and services are handled by our &nbsp;payment services providers, currently paddle.com. We will share transaction &nbsp;data with our payment services providers only to the extent necessary for the &nbsp;purposes of processing your payments, refunding such payments and dealing &nbsp;with complaints and queries relating to such payments and refunds. &nbsp;
            </span>
        </p>
        <p class="c93">
            <span class="c0">
                4.4 In addition to the specific disclosures of personal data set out in this Section &nbsp;4, we may disclose your personal data where such disclosure is necessary for &nbsp;compliance with a legal obligation to which we are subject, or in order to &nbsp;protect your vital interests or the vital interests of another natural person. We &nbsp;may also disclose your personal data where such disclosure is necessary for &nbsp;the establishment, exercise, or defence of legal claims, whether in court &nbsp;proceedings or in an administrative or out-of-court procedure.
            </span>
        </p>
        <p class="c5">
            <span class="c2">
                5. International transfers of your personal data
            </span>
        </p>
        <p class="c51">
            <span class="c0">
                5.1 In this Section 5, we provide information about the circumstances in which &nbsp;your personal data may be transferred to a third country under UK and/or EU &nbsp;data protection law.
            </span>
        </p>
        <p class="c83">
            <span class="c0">
                5.2 We may transfer your personal data from the European Economic Area (EEA) &nbsp;to the UK and process that personal data in the UK for the purposes set out in &nbsp;this policy, and may permit our suppliers and subcontractors to do so, during &nbsp;any period with respect to which the UK is not treated as a third country &nbsp;under EU data protection law or benefits from an adequacy decision under EU &nbsp;data protection law; and we may transfer your personal data from the UK to &nbsp;the EEA and process that personal data in the EEA for the purposes set out in &nbsp;this policy, and may permit our suppliers and subcontractors to do so, during &nbsp;any period with respect to which EEA states are not treated as third countries &nbsp;under UK data protection law or benefit from adequacy regulations under UK &nbsp;data protection law.
            </span>
        </p>
        <p class="c64">
            <span class="c0">
                5.3 The hosting facilities for our website are situated in UK, EEA and USA. The &nbsp;competent data protection authorities have made an adequacy determination &nbsp;with respect to the data protection laws of each of these countries. Transfers
            </span>
        </p>
        <p class="c15">
            <span class="c0">
                to each of these countries will be protected by appropriate safeguards, &nbsp;namely the use of standard data protection clauses adopted or approved by &nbsp;the competent data protection authorities.
            </span>
        </p>
        <p class="c24">
            <span class="c0">
                5.5 You acknowledge that personal data that you submit for publication through &nbsp;our website or services may be available, via the internet, around the world. &nbsp;We cannot prevent the use (or misuse) of such personal data by others.
            </span>
        </p>
        <p class="c10">
            <span class="c2">
                6. Retaining and deleting personal data
            </span>
        </p>
        <p class="c29">
            <span class="c0">
                6.1 This Section 6 sets out our data retention policies and procedures, which are &nbsp;designed to help ensure that we comply with our legal obligations in relation &nbsp;to the retention and deletion of personal data.
            </span>
        </p>
        <p class="c85">
            <span class="c0">
                6.2 Personal data that we process for any purpose or purposes shall not be kept &nbsp;for longer than is necessary for that purpose or those purposes.
            </span>
        </p>
        <p class="c35">
            <span class="c0">
                6.3 We will retain your personal data as follows:
            </span>
        </p>
        <p class="c43">
            <span class="c0">
                (a) contact data will be retained for a minimum period of 12 months following the date of the most recent contact between you and us, and &nbsp;for a maximum period of 12 months following that date;
            </span>
        </p>
        <p class="c77">
            <span class="c0">
                (b) account data will be retained for a minimum period of 12 months &nbsp;following the date of closure of the relevant account, and for a &nbsp;maximum period of 12 months following that date;
            </span>
        </p>
        <p class="c23">
            <span class="c0">
                (c) transaction data will be retained for a minimum period of 12 months &nbsp;following the date of the transaction, and for a maximum period of 12 months following that date;
            </span>
        </p>
        <p class="c73">
            <span class="c0">
                (d) communication data will be retained for a minimum period of 12 months following the date of the communication in question, and for a &nbsp;maximum period of 12 months following that date;
            </span>
        </p>
        <p class="c26">
            <span class="c0">
                (e) usage data will be retained for 12 months following the date of &nbsp;collection.
            </span>
        </p>
        <p class="c89">
            <span class="c0">
                6.4 Notwithstanding the other provisions of this Section 6, we may retain your &nbsp;personal data where such retention is necessary for compliance with a legal &nbsp;obligation to which we are subject, or in order to protect your vital interests &nbsp;or the vital interests of another natural person.
            </span>
        </p>
        <p class="c18">
            <span class="c2">
                7. Your rights
            </span>
        </p>
        <p class="c3">
            <span class="c0">
                7.1 In this Section 7, we have listed the rights that you have under data &nbsp;protection law.
            </span>
        </p>
        <p class="c5">
            <span class="c0">
                7.2 Your principal rights under data protection law are:
            </span>
        </p>
        <p class="c39">
            <span class="c0">
                (a)
            </span>
            <span class="c2">
                the right to access
            </span>
            <span class="c0">
                - you can ask for copies of your personal data;
            </span>
        </p>
        <p class="c86">
            <span class="c0">
                (b)
            </span>
            <span class="c2">
                the right to rectification
            </span>
            <span class="c0">
                - you can ask us to rectify inaccurate &nbsp;personal data and to complete incomplete personal data;
            </span>
        </p>
        <p class="c57">
            <span class="c0">
                (c)
            </span>
            <span class="c2">
                the right to erasure
            </span>
            <span class="c0">
                - you can ask us to erase your personal data;
            </span>
        </p>
        <p class="c49">
            <span class="c0">
                (d)
            </span>
            <span class="c2">
                the right to restrict processing
            </span>
            <span class="c0">
                - you can ask us to restrict the &nbsp;processing of your personal data;
            </span>
        </p>
        <p class="c79">
            <span class="c0">
                (e)
            </span>
            <span class="c2">
                the right to object to processing
            </span>
            <span class="c0">
                - you can object to the processing &nbsp;of your personal data;
            </span>
        </p>
        <p class="c92">
            <span class="c0">
                (f)
            </span>
            <span class="c2">
                the right to data portability
            </span>
            <span class="c0">
                - you can ask that we transfer your &nbsp;personal data to another organisation or to you;
            </span>
        </p>
        <p class="c80">
            <span class="c0">
                (g)
            </span>
            <span class="c2">
                the right to complain to a supervisory authority
            </span>
            <span class="c0">
                - you can &nbsp;complain about our processing of your personal data; and
            </span>
        </p>
        <p class="c72">
            <span class="c0">
                (h)
            </span>
            <span class="c2">
                the right to withdraw consent
            </span>
            <span class="c0">
                - to the extent that the legal basis of &nbsp;our processing of your personal data is consent, you can withdraw that &nbsp;consent.
            </span>
        </p>
        <p class="c94">
            <span class="c0">
                7.3 These rights are subject to certain limitations and exceptions. You can learn &nbsp;more about the rights of data subjects by visiting &nbsp;
            </span>
        </p>
        <p class="c81">
            <span class="c41">
                https://edpb.europa.eu/our-work-tools/general-guidance/gdpr-guidelines recommendations-best-practices_en
            </span>
            <span class="c0">
                and
            </span>
            <span class="c1">
                https://ico.org.uk/for
            </span>
        </p>
        <p class="c33">
            <span class="c1">
                organisations/guide-to-data-protection/guide-to-the-general-data-protection regulation-gdpr/individual-rights/
            </span>
            <span class="c0">
                .
            </span>
        </p>
        <p class="c59">
            <span class="c0">
                7.4 You may exercise any of your rights in relation to your personal data by &nbsp;written notice to us, using the contact details set out below.
            </span>
        </p>
        <p class="c22">
            <span class="c2">
                8. About cookies
            </span>
        </p>
        <p class="c70">
            <span class="c0">
                8.1 A cookie is a file containing an identifier (a string of letters and numbers) that &nbsp;is sent by a web server to a web browser and is stored by the browser. The &nbsp;identifier is then sent back to the server each time the browser requests a &nbsp;page from the server.
            </span>
        </p>
        <p class="c31">
            <span class="c0">
                8.2 Cookies may be either &quot;persistent&quot; cookies or &quot;session&quot; cookies: a persistent &nbsp;cookie will be stored by a web browser and will remain valid until its set &nbsp;expiry date, unless deleted by the user before the expiry date; a session &nbsp;cookie, on the other hand, will expire at the end of the user session, when the &nbsp;web browser is closed.
            </span>
        </p>
        <p class="c88">
            <span class="c0">
                8.3 Cookies may not contain any information that personally identifies a user, but &nbsp;personal data that we store about you may be linked to the information &nbsp;stored in and obtained from cookies.
            </span>
        </p>
        <p class="c45">
            <span class="c2">
                9. Cookies that we use
            </span>
        </p>
        <p class="c68">
            <span class="c0">
                9.1 We use cookies to identify you when you visit our website and as you &nbsp;navigate our website, and to help us determine if you are logged into our &nbsp;website &nbsp;
            </span>
        </p>
        <p class="c16">
            <span class="c2">
                10. Cookies used by our service providers
            </span>
        </p>
        <p class="c12">
            <span class="c0">
                10.1 Our service providers use cookies and those cookies may be stored on your &nbsp;computer when you visit our website.
            </span>
        </p>
        <p class="c17">
            <span class="c0">
                10.2 We use Google Analytics. Google Analytics gathers information about the use &nbsp;of our website by means of cookies. The information gathered is used to &nbsp;create reports about the use of our website. You can find out more about &nbsp;Google&#39;s use of information by visiting &nbsp;
            </span>
        </p>
        <p class="c58">
            <span class="c1">
                https://www.google.com/policies/privacy/partners/
            </span>
            <span class="c0">
                and you can review &nbsp;Google&#39;s privacy policy at
            </span>
            <span class="c1">
                https://policies.google.com/privacy
            </span>
            <span class="c0">
                .
            </span>
        </p>
        <p class="c78">
            <span class="c2">
                11. Managing cookies
            </span>
        </p>
        <p class="c32">
            <span class="c0">
                11.1 Most browsers allow you to refuse to accept cookies and to delete cookies. &nbsp;The methods for doing so vary from browser to browser, and from version to &nbsp;version. You can however obtain up-to-date information about blocking and &nbsp;deleting cookies via these links:
            </span>
        </p>
        <p class="c4">
            <span class="c0">
                (a)
            </span>
            <span class="c1">
                https://support.google.com/chrome/answer/95647
            </span>
            <span class="c0">
                (Chrome);
            </span>
        </p>
        <p class="c53">
            <span class="c0">
                (b)
            </span>
            <span class="c1">
                https://support.mozilla.org/en-US/kb/enhanced-tracking-protection firefox-desktop
            </span>
            <span class="c0">
                (Firefox);
            </span>
        </p>
        <p class="c36">
            <span class="c0">
                (c)
            </span>
            <span class="c1">
                https://help.opera.com/en/latest/security-and-privacy/
            </span>
            <span class="c0">
                (Opera);
            </span>
        </p>
        <p class="c65">
            <span class="c0">
                (d)
            </span>
            <span class="c1">
                https://support.microsoft.com/en-gb/help/17442/windows-internet explorer-delete-manage-cookies
            </span>
            <span class="c0">
                (Internet Explorer);
            </span>
        </p>
        <p class="c71">
            <span class="c0">
                (e)
            </span>
            <span class="c1">
                https://support.apple.com/en-gb/guide/safari/manage-cookies-and website-data-sfri11471/mac
            </span>
            <span class="c0">
                (Safari); and
            </span>
        </p>
        <p class="c95">
            <span class="c0">
                (f)
            </span>
            <span class="c1">
                https://support.microsoft.com/en-gb/help/4468242/microsoft-edge browsing-data-and-privacy
            </span>
            <span class="c8">
                &nbsp;
            </span>
            <span class="c0">
                (Edge).
            </span>
        </p>
        <p class="c62">
            <span class="c0">
                11.2 Blocking all cookies will have a negative impact upon the usability of many &nbsp;websites.
            </span>
        </p>
        <p class="c63">
            <span class="c0">
                11.3 If you block cookies, you will not be able to use all the features on our &nbsp;website.
            </span>
        </p>
        <p class="c54">
            <span class="c2">
                12. Amendments
            </span>
        </p>
        <p class="c14">
            <span class="c0">
                12.1 We may update this policy from time to time by publishing a new version on &nbsp;our website.
            </span>
        </p>
        <p class="c76">
            <span class="c0">
                12.2 You should check this page occasionally to ensure you are happy with any &nbsp;changes to this policy.
            </span>
        </p>
        <p class="c52">
            <span class="c0">
                12.3 We may notify you of significant changes to this policy by email.
            </span>
            <span class="c2">
                13. Our details
            </span>
        </p>
        <p class="c55">
            <span class="c0">
                13.1 This website is owned and operated by Animotive Limited.
            </span>
        </p>
        <p class="c19">
            <span class="c0">
                13.2 We are registered in Northern Ireland under registration number NI663613, &nbsp;and our registered office is at 2 Crescent Gardens, Belfast, BT7 1NS, UK.
            </span>
        </p>
        <p class="c40">
            <span class="c0">
                13.3 You can contact us:
            </span>
        </p>
        <p class="c38">
            <span class="c0">
                (a) by post, to the postal address given above;
            </span>
        </p>
        <p class="c67">
            <span class="c0">
                (b) using our website contact form;
            </span>
        </p>
        <p class="c38">
            <span class="c0">
                (c) by email, using the email address published on our website.
            </span>
        </p>
    </body>
</html>`;
